import _extends from '@babel/runtime-corejs2/helpers/extends';
import * as React from 'react';

function SvgAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.812.544A.553.553 0 00.517.91a.425.425 0 00.011.27c.05.171.189.325.33.365.064.018.49.026 1.296.027h1.202l1.978 3.5c2.104 3.723 2.06 3.651 2.318 3.793.239.131.282.135 1.64.135 1.396 0 1.392 0 1.556-.16A.463.463 0 0011 8.464c0-.226-.105-.402-.294-.49-.088-.041-.177-.044-1.31-.045-1.128 0-1.218-.003-1.25-.042-.02-.023-.918-1.6-1.995-3.506C5.074 2.476 4.163.883 4.127.841a1.038 1.038 0 00-.445-.293C3.535.502 3.468.5 2.217.501.999.5.899.504.812.544zm6.075.037l-.08.081v.724l.08.08.08.082H10.828l.063-.059c.093-.088.109-.155.109-.469 0-.216-.01-.307-.039-.369-.074-.158.028-.15-2.082-.15H6.967l-.08.08z",
    fill: "#fff"
  }));
}

var MemoSvgAlt = /*#__PURE__*/React.memo(SvgAlt);

function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.724 5.665H7.463l3.839-4.42a.748.748 0 00.117-.808.756.756 0 00-.695-.437H5.297c-.287 0-.55.16-.68.414L.085 9.216a.818.818 0 00.027.775c.138.228.386.394.653.394H4.096l-1.715 5.65a.748.748 0 00.732.965c.23 0 .454-.106.604-.297l7.61-9.76a.803.803 0 00.084-.828.784.784 0 00-.687-.45z",
    fill: "currentColor"
  }));
}

var MemoSvgBolt = /*#__PURE__*/React.memo(SvgBolt);

function SvgPi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M32.887 35.006a1.5 1.5 0 002.226-2.011l-2.226 2.01zM20.906 22.732a1.5 1.5 0 003 0h-3zm-12.058 0a1.5 1.5 0 003 0h-3zm20.406-6.76c0 6.848-5.725 12.472-12.877 12.472v3c8.728 0 15.877-6.887 15.877-15.472h-3zM16.377 28.444C9.224 28.444 3.5 22.82 3.5 15.972h-3c0 8.585 7.149 15.472 15.877 15.472v-3zM3.5 15.972C3.5 9.124 9.224 3.5 16.377 3.5v-3C7.649.5.5 7.387.5 15.972h3zM16.377 3.5c7.152 0 12.877 5.624 12.877 12.472h3C32.254 7.387 25.104.5 16.377.5v3zm9.839 24.121l6.671 7.385 2.226-2.011-6.67-7.385-2.227 2.011zm-2.31-4.889V21.23h-3v1.502h3zm0-1.502a4.51 4.51 0 00-4.515-4.505v3a1.51 1.51 0 011.515 1.505h3zm-4.515-4.505h-6.029v3h6.03v-3zm-6.029 0a4.51 4.51 0 00-4.514 4.505h3a1.51 1.51 0 011.514-1.505v-3zM8.848 21.23v1.502h3V21.23h-3zm7.529-5.44c2.58 0 4.746-2.044 4.746-4.655h-3c0 .874-.741 1.655-1.746 1.655v3zm4.746-4.655c0-2.61-2.166-4.655-4.746-4.655v3c1.005 0 1.746.781 1.746 1.655h3zM16.377 6.48c-2.58 0-4.747 2.044-4.747 4.655h3c0-.873.742-1.655 1.747-1.655v-3zm-4.747 4.655c0 2.611 2.166 4.655 4.747 4.655v-3c-1.005 0-1.747-.78-1.747-1.655h-3z",
    fill: "currentColor"
  }));
}

var MemoSvgPi = /*#__PURE__*/React.memo(SvgPi);

function SvgPeekIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.596 0v25.674m0 0H0m21.596 0L35 37",
    stroke: "currentColor",
    strokeWidth: 2
  }));
}

var MemoSvgPeekIcon = /*#__PURE__*/React.memo(SvgPeekIcon);

function SvgAc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 11l2.036-2.444A2 2 0 0029 7.276V2a1 1 0 00-1-1h-4m2.5 10V8.5a1 1 0 00-1-1H5a1 1 0 00-1 1v1M26.5 11l-1.207 1.207a1 1 0 01-.707.293H5.914a1 1 0 01-.707-.293L4 11m0 0L1.586 8.586A2 2 0 011 7.172V2a1 1 0 011-1h3.5M4 11V9.5M5.5 1v2.5a1 1 0 001 1H23a1 1 0 001-1V1M5.5 1H24M11.5 14c0 1.833-1 5.5-5 5.5M15 14v5.5m3.5-5.5c0 1.833 1.1 5.5 5.5 5.5M4 9.5h5m1.5 0h1",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgAc = /*#__PURE__*/React.memo(SvgAc);

function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 11h-4l-3 9L9 2l-3 9H2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgActivity = /*#__PURE__*/React.memo(SvgActivity);

function SvgAirplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 16H4a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2h-1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 14l5 6H7l5-6v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgAirplay = /*#__PURE__*/React.memo(SvgAirplay);

function SvgAlertCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgAlertCircle = /*#__PURE__*/React.memo(SvgAlertCircle);

function SvgAlertOctagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgAlertOctagon = /*#__PURE__*/React.memo(SvgAlertOctagon);

function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.29 4.86L1.82 19a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 4.86a2 2 0 00-3.42 0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10v4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgAlertTriangle = /*#__PURE__*/React.memo(SvgAlertTriangle);

function SvgAlignCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 10H6M21 6H3M21 14H3M18 18H6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgAlignCenter = /*#__PURE__*/React.memo(SvgAlignCenter);

function SvgAlignJustify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 10H3M21 6H3M21 14H3M21 18H3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgAlignJustify = /*#__PURE__*/React.memo(SvgAlignJustify);

function SvgAlignLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 10H3M21 6H3M21 14H3M17 18H3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgAlignLeft = /*#__PURE__*/React.memo(SvgAlignLeft);

function SvgAlignRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 10H7M21 6H3M21 14H3M21 18H7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgAlignRight = /*#__PURE__*/React.memo(SvgAlignRight);

function SvgAnchor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 8a3 3 0 100-6 3 3 0 000 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22V8M5 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10h-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgAnchor = /*#__PURE__*/React.memo(SvgAnchor);

function SvgAperture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16L3.95 6.06M14.31 16H2.83M16.62 12l-5.74 9.94",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgAperture = /*#__PURE__*/React.memo(SvgAperture);

function SvgArrowDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 6L6 18M15 18H6V9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgArrowDownLeft = /*#__PURE__*/React.memo(SvgArrowDownLeft);

function SvgArrowDownRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 6l12 12M9 18h9V9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgArrowDownRight = /*#__PURE__*/React.memo(SvgArrowDownRight);

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v16M18 14l-6 6-6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgArrowDown = /*#__PURE__*/React.memo(SvgArrowDown);

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 12H4M10 18l-6-6 6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgArrowLeft = /*#__PURE__*/React.memo(SvgArrowLeft);

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16M14 6l6 6-6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgArrowRight = /*#__PURE__*/React.memo(SvgArrowRight);

function SvgArrowUpLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 18L6 6M15 6H6v9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgArrowUpLeft = /*#__PURE__*/React.memo(SvgArrowUpLeft);

function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 18L18 6M9 6h9v9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgArrowUpRight = /*#__PURE__*/React.memo(SvgArrowUpRight);

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 20V4M6 10l6-6 6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgArrowUp = /*#__PURE__*/React.memo(SvgArrowUp);

function SvgAtSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 16a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12v1a3 3 0 006 0v-1a10 10 0 10-3.92 7.94",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgAtSign = /*#__PURE__*/React.memo(SvgAtSign);

function SvgAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 15a7 7 0 100-14 7 7 0 000 14z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21 13.89L7 23l5-3 5 3-1.21-9.12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgAward = /*#__PURE__*/React.memo(SvgAward);

function SvgBarChart2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 3h4v18h-4V3zM18 8h4v13h-4V8zM2 13h4v8H2v-8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBarChart2 = /*#__PURE__*/React.memo(SvgBarChart2);

function SvgBarChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 3h4v18h-4V3zM10 8h4v13h-4V8zM2 13h4v8H2v-8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBarChart = /*#__PURE__*/React.memo(SvgBarChart);

function SvgBaths(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10H2a1 1 0 00-1 1v4.5a3 3 0 003 3h10.5a3 3 0 003-3V11a1 1 0 00-1-1v0zm0 0V2a1 1 0 00-1-1H13a2 2 0 00-2 2v0M9.5 4.5l-1 3m2.5-3v3m1.5-3l1.5 3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBaths = /*#__PURE__*/React.memo(SvgBaths);

function SvgBatteryCharging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 19a1 1 0 100-2v2zm-4-3H0h1zm5.19-9a1 1 0 000-2v2zM15 5a1 1 0 100 2V5zm-1.19 12a1 1 0 100 2v-2zM5 17H3v2h2v-2zm-2 0a1 1 0 01-1-1H0a3 3 0 003 3v-2zm-1-1V8H0v8h2zm0-8a1 1 0 011-1V5a3 3 0 00-3 3h2zm1-1h3.19V5H3v2zm12 0h2V5h-2v2zm2 0a1 1 0 011 1h2a3 3 0 00-3-3v2zm1 1v8h2V8h-2zm0 8a1 1 0 01-1 1v2a3 3 0 003-3h-2zm-1 1h-3.19v2H17v-2z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 13v-2M11 6l-4 6h6l-4 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBatteryCharging = /*#__PURE__*/React.memo(SvgBatteryCharging);

function SvgBattery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 8a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2H3a2 2 0 01-2-2V8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 13v-2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBattery = /*#__PURE__*/React.memo(SvgBattery);

function SvgBeds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 15v-2m20.5 2v-2M1 13V9.5a2 2 0 012-2h.5M1 13h20.5m0 0V9.5a2 2 0 00-2-2H19m-15.5 0V2a1 1 0 011-1H18a1 1 0 011 1v5.5m-15.5 0h2m13.5 0h-2m-11.5 0V6a1 1 0 011-1H9a1 1 0 011 1v1.5m-4.5 0H10m0 0h2.5m0 0V6a1 1 0 011-1H16a1 1 0 011 1v1.5m-4.5 0H17",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBeds = /*#__PURE__*/React.memo(SvgBeds);

function SvgBellOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.069 2.03a1 1 0 10.982 1.74L8.07 2.03zM19 9h-1 1zm-1 4a1 1 0 102 0h-2zm-1 5a1 1 0 100-2v2zM2 16a1 1 0 100 2v-2zm3-7h1v-.001L5 9zm1.669-2.761A1 1 0 004.89 5.32l1.778.918zm7.926 15.263a1 1 0 10-1.73-1.004l1.73 1.004zm-3.46-1.004a1 1 0 00-1.73 1.004l1.73-1.004zM9.051 3.771a6 6 0 015.976.045l1.009-1.727a8 8 0 00-7.967-.06l.982 1.742zm5.976.045A6 6 0 0118 8.999L20 9a8 8 0 00-3.964-6.91l-1.01 1.726zM18 9v4h2V9h-2zm-1 7H2v2h15v-2zM2 18a4 4 0 004-4H4a2 2 0 01-2 2v2zm4-4V9H4v5h2zm0-5.001a6 6 0 01.669-2.76L4.89 5.32A8 8 0 004 9.001L6 9zm6.865 11.5a1 1 0 01-.865.497v2a3 3 0 002.595-1.494l-1.73-1.004zm-.865.497a1 1 0 01-.865-.498l-1.73 1.004A3 3 0 0012 22.996v-2z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1l22 22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBellOff = /*#__PURE__*/React.memo(SvgBellOff);

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 18a1 1 0 100-2v2zM2 16a1 1 0 100 2v-2zm3-7H4h1zm14 0h1-1zm-5.27 12l.865.502A1 1 0 0013.73 20v1zm-3.46 0v-1a1 1 0 00-.865 1.502L10.27 21zM22 16H2v2h20v-2zM2 18a4 4 0 004-4H4a2 2 0 01-2 2v2zm4-4V9H4v5h2zm0-5a6 6 0 016-6V1a8 8 0 00-8 8h2zm6-6a6 6 0 016 6h2a8 8 0 00-8-8v2zm6 6v5h2V9h-2zm0 5a4 4 0 004 4v-2a2 2 0 01-2-2h-2zm-5.135 6.498a1 1 0 01-.865.498v2a3 3 0 002.595-1.494l-1.73-1.004zm-.865.498a1 1 0 01-.865-.498l-1.73 1.004A3 3 0 0012 22.997v-2zM10.27 22h3.46v-2h-3.46v2z",
    fill: "currentColor"
  }));
}

var MemoSvgBell = /*#__PURE__*/React.memo(SvgBell);

function SvgBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5l11 11L12 23V1l5.5 5.5-11 11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBluetooth = /*#__PURE__*/React.memo(SvgBluetooth);

function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5 4h8a4 4 0 010 8H5V4zM5 12h9a4 4 0 010 8H5v-8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBold = /*#__PURE__*/React.memo(SvgBold);

function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 19.5A2.5 2.5 0 016.5 17H20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBook = /*#__PURE__*/React.memo(SvgBook);

function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2v16z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBookmark = /*#__PURE__*/React.memo(SvgBookmark);

function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.89 1.45l8 4A2 2 0 0122 7.24v9.53a2 2 0 01-1.11 1.79l-8 4a2 2 0 01-1.79 0l-8-4a2 2 0 01-1.1-1.8V7.24a2 2 0 011.11-1.79l8-4a2 2 0 011.78 0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32 6.16L12 11l9.68-4.84M12 22.76V11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBox = /*#__PURE__*/React.memo(SvgBox);

function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 9a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBriefcase = /*#__PURE__*/React.memo(SvgBriefcase);

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 6a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4M8 2v4M3 10h18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCalendar = /*#__PURE__*/React.memo(SvgCalendar);

function SvgCameraOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 1l22 22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 22a1 1 0 100-2v2zM1 19H0h1zM6 7a1 1 0 000-2v2zm3-5a1 1 0 000 2V2zm6 1l.832-.555A1 1 0 0015 2v1zm2 3l-.832.555A1 1 0 0017 7V6zm5 11.34a1 1 0 102 0h-2zm-5.895-1.495a1 1 0 10-1.65-1.13l1.65 1.13zm-5.82-5.3a1 1 0 10-1.13-1.65l1.13 1.65zM21 20H3v2h18v-2zM3 20a1 1 0 01-1-1H0a3 3 0 003 3v-2zm-1-1V8H0v11h2zM2 8a1 1 0 011-1V5a3 3 0 00-3 3h2zm1-1h3V5H3v2zm6-3h6V2H9v2zm5.168-.445l2 3 1.664-1.11-2-3-1.664 1.11zM17 7h4V5h-4v2zm4 0a1 1 0 011 1h2a3 3 0 00-3-3v2zm1 1v9.34h2V8h-2zm-7.545 6.715a3 3 0 01-3.072 1.246l-.398 1.96a5 5 0 005.12-2.076l-1.65-1.13zm-3.072 1.246a3 3 0 01-2.344-2.344l-1.96.398a5 5 0 003.906 3.907l.398-1.96zm-2.344-2.344a3 3 0 011.246-3.072l-1.13-1.65a5 5 0 00-2.076 5.12l1.96-.398z",
    fill: "currentColor"
  }));
}

var MemoSvgCameraOff = /*#__PURE__*/React.memo(SvgCameraOff);

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.5l-.812 1.624a1 1 0 00.429 1.332L10.25 11.5m-3.5-5l13.925 7.33a1 1 0 00.683.09l3.4-.755M6.75 6.5l1.375-2.75m16.633 9.415l2.613-.58c.905-.202 1.073-1.42.256-1.858l-17.22-9.24a1 1 0 00-1.367.434L8.125 3.75m16.633 9.415l1.117.856a1 1 0 01.305 1.2l-.124.279m0 0l2.06 1.05a1 1 0 01.44 1.338l-.098.196a1 1 0 01-1.363.437L25.167 17.5m.889-2l-.89 2m0 0l-.232.523a1 1 0 01-1.38.48L15 14M8.125 3.75L12.5 6m-2.25 5.5c-.417 1-.55 3.2 2.25 4m-2.25-4L15 14m-2.5 1.5c.833 0 2.5-.3 2.5-1.5m-2.5 1.5c.667 2.5.8 7.4-4 7h-4m0 0V21a1 1 0 00-1-1H2a1 1 0 00-1 1v3a1 1 0 001 1h1.5a1 1 0 001-1v-1.5zM14 7l1 .5",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgCamera = /*#__PURE__*/React.memo(SvgCamera);

function SvgCast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.2 15.12a1 1 0 10-.4 1.96l.4-1.96zm2.72 5.08a1 1 0 101.96-.4l-1.96.4zm-2.81-9.144a1 1 0 00-.22 1.988l.22-1.988zm6.846 9.054a1 1 0 001.988-.22l-1.988.22zM1 8a1 1 0 002 0H1zm13 11a1 1 0 100 2v-2zM1.8 17.08a4 4 0 013.12 3.12l1.96-.4a6 6 0 00-4.68-4.68l-.4 1.96zm.09-4.036a8 8 0 017.066 7.066l1.988-.22a10 10 0 00-8.833-8.834l-.222 1.988zM3 8V6H1v2h2zm0-2a1 1 0 011-1V3a3 3 0 00-3 3h2zm1-1h16V3H4v2zm16 0a1 1 0 011 1h2a3 3 0 00-3-3v2zm1 1v12h2V6h-2zm0 12a1 1 0 01-1 1v2a3 3 0 003-3h-2zm-1 1h-6v2h6v-2z",
    fill: "currentColor"
  }));
}

var MemoSvgCast = /*#__PURE__*/React.memo(SvgCast);

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 12.07V13a10 10 0 11-5.93-9.14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 4L11 15l-3-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCheckCircle = /*#__PURE__*/React.memo(SvgCheckCircle);

function SvgCheckSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 11l3 3L22 3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v7a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCheckSquare = /*#__PURE__*/React.memo(SvgCheckSquare);

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 7L9 18l-5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCheck = /*#__PURE__*/React.memo(SvgCheck);

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 9l6 6 6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronDown = /*#__PURE__*/React.memo(SvgChevronDown);

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 18l-6-6 6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronLeft = /*#__PURE__*/React.memo(SvgChevronLeft);

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 18l6-6-6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronRight = /*#__PURE__*/React.memo(SvgChevronRight);

function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l-6-6-6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronUp = /*#__PURE__*/React.memo(SvgChevronUp);

function SvgChevronsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 13l5 5 5-5M7 6l5 5 5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronsDown = /*#__PURE__*/React.memo(SvgChevronsDown);

function SvgChevronsLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 17l-5-5 5-5M18 17l-5-5 5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronsLeft = /*#__PURE__*/React.memo(SvgChevronsLeft);

function SvgChevronsRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 17l5-5-5-5M6 17l5-5-5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronsRight = /*#__PURE__*/React.memo(SvgChevronsRight);

function SvgChevronsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 11l-5-5-5 5M17 18l-5-5-5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronsUp = /*#__PURE__*/React.memo(SvgChevronsUp);

function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 16a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.17 8H12M3.95 6.06L8.54 14M10.88 21.94L15.46 14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChrome = /*#__PURE__*/React.memo(SvgChrome);

function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCircle = /*#__PURE__*/React.memo(SvgCircle);

function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 3a1 1 0 011-1h6a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1V3z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgClipboard = /*#__PURE__*/React.memo(SvgClipboard);

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v6l3 3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgClock = /*#__PURE__*/React.memo(SvgClock);

function SvgCloudDrizzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 19v2M9 13v2M17 19v2M17 13v2M13 21v2M13 15v2M21 16.58A5 5 0 0019 7h-1.26A8 8 0 105 15.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCloudDrizzle = /*#__PURE__*/React.memo(SvgCloudDrizzle);

function SvgCloudLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.9A5 5 0 0019 7h-1.26a8 8 0 10-11.62 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11l-4 6h6l-4 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCloudLightning = /*#__PURE__*/React.memo(SvgCloudLightning);

function SvgCloudOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.819 16.56a1 1 0 101.841.78l-1.841-.78zM18.129 10v1h.002l-.001-1zm-1.26 0l-.969.246a1 1 0 00.97.754v-1zM9.909 3.004a1 1 0 10-.176 1.992l.176-1.992zM5.614 5.875a1 1 0 10-.968-1.75l.968 1.75zM9.13 20v-1h-.016l.016 1zm9 0v1-1zm2.04.64a1 1 0 00-.682-1.88l.683 1.88zm3.49-3.3a6 6 0 00-.524-5.657l-1.667 1.106a4 4 0 01.35 3.771l1.841.78zm-.524-5.657A6 6 0 0018.128 9l.003 2a4 4 0 013.338 1.789l1.666-1.106zM18.13 9h-1.26v2h1.26V9zm-.291.754a9 9 0 00-7.931-6.75l-.176 1.992a7 7 0 016.168 5.25l1.939-.492zM4.646 4.124A9 9 0 00.305 14.32l1.932-.515a7 7 0 013.377-7.93l-.968-1.75zM.305 14.32A9 9 0 009.145 21l-.031-2a7 7 0 01-6.877-5.195l-1.932.515zM9.13 21h9v-2h-9v2zm9 0a6 6 0 002.04-.36l-.682-1.88a4 4 0 01-1.36.24l.003 2z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1l22 22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCloudOff = /*#__PURE__*/React.memo(SvgCloudOff);

function SvgCloudRain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 13v8M9 13v8M13 15v8M21 16.58A5 5 0 0019 7h-1.26A8 8 0 105 15.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCloudRain = /*#__PURE__*/React.memo(SvgCloudRain);

function SvgCloudSnow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.006 19.58a5 5 0 00-2-9.58h-1.26a8 8 0 10-12.74 8.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCloudSnow = /*#__PURE__*/React.memo(SvgCloudSnow);

function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 10.001h-1.26a8 8 0 10-7.74 10h9a5 5 0 000-10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCloud = /*#__PURE__*/React.memo(SvgCloud);

function SvgCodepen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 2l10 6.5v7L12 22 2 15.5v-7L12 2v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22v-6.5M22 8.5l-10 7-10-7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 15.5l10-7 10 7M12 2v6.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCodepen = /*#__PURE__*/React.memo(SvgCodepen);

function SvgCommand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 3a3 3 0 00-3 3v12a3 3 0 103-3H6a3 3 0 103 3V6a3 3 0 10-3 3h12a3 3 0 100-6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCommand = /*#__PURE__*/React.memo(SvgCommand);

function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCompass = /*#__PURE__*/React.memo(SvgCompass);

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9 11a2 2 0 012-2h9a2 2 0 012 2v9a2 2 0 01-2 2h-9a2 2 0 01-2-2v-9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCopy = /*#__PURE__*/React.memo(SvgCopy);

function SvgCornerDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 10l-5 5 5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4v7a4 4 0 01-4 4H4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCornerDownLeft = /*#__PURE__*/React.memo(SvgCornerDownLeft);

function SvgCornerDownRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 10l5 5-5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v7a4 4 0 004 4h12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCornerDownRight = /*#__PURE__*/React.memo(SvgCornerDownRight);

function SvgCornerLeftDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 15l-5 5-5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4h-7a4 4 0 00-4 4v12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCornerLeftDown = /*#__PURE__*/React.memo(SvgCornerLeftDown);

function SvgCornerLeftUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 9L9 4 4 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-7a4 4 0 01-4-4V4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCornerLeftUp = /*#__PURE__*/React.memo(SvgCornerLeftUp);

function SvgCornerRightDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 15l5 5 5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h7a4 4 0 014 4v12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCornerRightDown = /*#__PURE__*/React.memo(SvgCornerRightDown);

function SvgCornerRightUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 9l5-5 5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h7a4 4 0 004-4V4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCornerRightUp = /*#__PURE__*/React.memo(SvgCornerRightUp);

function SvgCornerUpLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 14L4 9l5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20v-7a4 4 0 00-4-4H4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCornerUpLeft = /*#__PURE__*/React.memo(SvgCornerUpLeft);

function SvgCornerUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 14l5-5-5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-7a4 4 0 014-4h12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCornerUpRight = /*#__PURE__*/React.memo(SvgCornerUpRight);

function SvgCpu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9 9h6v6H9V9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCpu = /*#__PURE__*/React.memo(SvgCpu);

function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 6a2 2 0 012-2h18a2 2 0 012 2v12a2 2 0 01-2 2H3a2 2 0 01-2-2V6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10h22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCreditCard = /*#__PURE__*/React.memo(SvgCreditCard);

function SvgCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.13 1L6 16a2 2 0 002 2h15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.13L16 6a2 2 0 012 2v15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCrop = /*#__PURE__*/React.memo(SvgCrop);

function SvgCrosshair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12h-4M6 12H2M12 6V2M12 22v-4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCrosshair = /*#__PURE__*/React.memo(SvgCrosshair);

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 4H8l-7 8 7 8h13a2 2 0 002-2V6a2 2 0 00-2-2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9l-6 6M12 9l6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgDelete = /*#__PURE__*/React.memo(SvgDelete);

function SvgDisc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 15a3 3 0 100-6 3 3 0 000 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgDisc = /*#__PURE__*/React.memo(SvgDisc);

function SvgDishwasher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3h4M10 1H2a1 1 0 00-1 1v4m9-5v2a1 1 0 001 1h4a1 1 0 001-1V1m-6 0h6m0 0h1.5a1 1 0 011 1v4m0 0v19a1 1 0 01-1 1H2a1 1 0 01-1-1V6m17.5 0H8M6.5 6H6M1 6h3.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgDishwasher = /*#__PURE__*/React.memo(SvgDishwasher);

function SvgDoorman(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5V2a1 1 0 011-1h7.5a1 1 0 011 1v2.5M7 4.5h3m-3 0V7m9.5-2.5H10m6.5 0v3.25M10 4.5c-.167 1-1 2.9-3 2.5m3-2.5c.5 1.333 2.5 3.85 6.5 3.25M7 7v4.36a.86.86 0 00.041.274c.194.576.634 1.375 1.38 2.05M16.5 7.75V11c-.1.807-.556 2.103-1.61 3M14 11c-.667.833-2.4 2-4 0m-1.579 2.684C9.229 14.414 10.397 15 12 15c1.263 0 2.204-.415 2.89-1m-6.469-.316V18m0 0L1.74 19.8a1 1 0 00-.74.966V27.5a1 1 0 001 1h9.5M8.421 18l3.284.918a1 1 0 00.585-.015L15 18m0 0l6.758 1.802a1 1 0 01.742.966V27.5a1 1 0 01-1 1h-10M15 18l-.11-4m-3.39 7v1m0 6.5v-5",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgDoorman = /*#__PURE__*/React.memo(SvgDoorman);

function SvgDownloadCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 18l4 4 4-4M13 13v9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.88 19.09A5 5 0 0019 10h-1.26A8 8 0 104 17.29",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgDownloadCloud = /*#__PURE__*/React.memo(SvgDownloadCloud);

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 17v3a2 2 0 002 2h14a2 2 0 002-2v-3M8 12l4 4 4-4M12 2v14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgDownload = /*#__PURE__*/React.memo(SvgDownload);

function SvgDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.383.025c-.425.039-.701.176-1.06.526-.39.381-.44.469-1.01 1.783l-.517 1.188-.798.007c-.559.005-.81.017-.836.04-.137.117-.205.483-.132.71a.936.936 0 00.383.435c.133.069.389.137.584.156l.181.017-.544 1.31.008 2.676c.007 2.613.008 2.679.062 2.808a.69.69 0 00.364.36c.083.03.353.037 1.272.037 1.323 0 1.348-.003 1.506-.208.16-.206.163-.234.163-1.087v-.781h8.062v.756c0 .5.01.794.032.866a.718.718 0 00.369.403c.117.047.23.051 1.309.051h1.18l.13-.068a.66.66 0 00.303-.343c.03-.072.04-.622.056-2.752l.02-2.662-.275-.669c-.15-.368-.274-.678-.274-.69 0-.011.048-.02.107-.02.17 0 .492-.08.647-.16.316-.163.477-.47.417-.799a.899.899 0 00-.098-.272l-.07-.107-1.612-.014-.506-1.17c-.56-1.294-.623-1.406-1.001-1.781-.378-.374-.645-.504-1.127-.548-.354-.032-6.94-.03-7.295.002zm7.39 1.2c.186.09.334.238.514.512.156.237.19.31.762 1.603l.4.906-2.698.007c-1.483.004-3.912.004-5.396 0l-2.699-.007.401-.906c.576-1.3.608-1.368.757-1.593.234-.357.42-.516.677-.578.058-.015 1.621-.024 3.617-.021l3.515.004.15.073zm-8.395 5.25c.194.09.398.294.491.493a1.058 1.058 0 01-.511 1.4c-.154.075-.206.086-.407.086-.203 0-.253-.01-.413-.088a1.097 1.097 0 01-.508-.51c-.06-.133-.07-.19-.07-.432 0-.247.009-.298.076-.446a.96.96 0 01.956-.59.874.874 0 01.386.086zm10.2-.003c.342.161.558.49.578.883.023.471-.186.82-.614 1.025-.13.061-.193.074-.386.074-.203 0-.252-.01-.413-.088-.86-.417-.78-1.64.128-1.95.18-.061.513-.034.706.056zm-3.097.92a.571.571 0 01.204.394c0 .13-.09.305-.204.393l-.102.08-2.293.008c-2.286.008-2.294.008-2.412-.051-.277-.138-.34-.523-.123-.76.148-.163.039-.157 2.532-.15l2.296.006.102.08z",
    fill: "currentColor"
  }));
}

var MemoSvgDrive = /*#__PURE__*/React.memo(SvgDrive);

function SvgDroplet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 2.69l5.66 5.66a8 8 0 11-11.31 0L11 2.69z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgDroplet = /*#__PURE__*/React.memo(SvgDroplet);

function SvgEdit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 3l5 5L8 21H3v-5L16 3z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgEdit2 = /*#__PURE__*/React.memo(SvgEdit2);

function SvgEdit3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 2l4 4L7 17H3v-4L14 2v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 22h18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgEdit3 = /*#__PURE__*/React.memo(SvgEdit3);

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 13.66V19a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h5.34",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 2l4 4-10 10H8v-4L18 2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgEdit = /*#__PURE__*/React.memo(SvgEdit);

function SvgElevator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.299 3.19a.5.5 0 00.707.707l-.707-.707zm2.543-1.836L9.49 1l.353.354zm.707 0l-.353.353.353-.353zm1.837 2.543a.5.5 0 00.707-.707l-.707.707zm8.782-2.543a.5.5 0 00-.707-.708l.707.708zM18.624 3.19l.354.353-.354-.353zm-.707 0l.354-.354-.354.354zM16.081.646a.5.5 0 10-.707.708l.707-.708zM1.5 7.478a.5.5 0 01.5-.5v-1a1.5 1.5 0 00-1.5 1.5h1zm.5-.5h25v-1H2v1zm25 0a.5.5 0 01.5.5h1a1.5 1.5 0 00-1.5-1.5v1zm.5.5V27h1V7.478h-1zM27.5 27a.5.5 0 01-.5.5v1a1.5 1.5 0 001.5-1.5h-1zm-.5.5H2v1h25v-1zm-25 0a.5.5 0 01-.5-.5h-1A1.5 1.5 0 002 28.5v-1zm-.5-.5V7.478h-1V27h1zm9.956-13.87a2.24 2.24 0 01-2.239 2.24v1a3.24 3.24 0 003.24-3.24h-1zm-2.239 2.24a2.24 2.24 0 01-2.239-2.24h-1a3.24 3.24 0 003.24 3.24v-1zm-2.239-2.24a2.24 2.24 0 012.24-2.239v-1a3.24 3.24 0 00-3.24 3.24h1zm2.24-2.239a2.24 2.24 0 012.238 2.24h1a3.24 3.24 0 00-3.239-3.24v1zm12.413 2.24a2.24 2.24 0 01-2.24 2.239v1a3.24 3.24 0 003.24-3.24h-1zm-2.24 2.239a2.24 2.24 0 01-2.239-2.24h-1a3.24 3.24 0 003.24 3.24v-1zm-2.239-2.24a2.24 2.24 0 012.24-2.239v-1a3.24 3.24 0 00-3.24 3.24h1zm2.24-2.239a2.24 2.24 0 012.239 2.24h1a3.24 3.24 0 00-3.24-3.24v1zM6.977 20.174a2.24 2.24 0 012.24-2.24v-1a3.24 3.24 0 00-3.24 3.24h1zm2.24-2.24a2.24 2.24 0 012.238 2.24h1a3.24 3.24 0 00-3.239-3.24v1zm2.238 2.24v5.087h1v-5.087h-1zM6.978 25.26v-5.087h-1v5.087h1zM8.006 3.897l2.19-2.19L9.489 1l-2.19 2.19.707.707zm2.19-2.19l2.19 2.19.707-.707L10.903 1l-.707.707zm0 0L10.903 1a1 1 0 00-1.414 0l.707.707zM20.46.647l-2.19 2.19.707.706 2.19-2.19-.707-.707zm-2.19 2.19L16.08.646l-.707.707 2.19 2.19.707-.708zm0 0l-.707.706a1 1 0 001.414 0l-.707-.707zm-1.119 17.337a2.24 2.24 0 012.24-2.24v-1a3.24 3.24 0 00-3.24 3.24h1zm2.24-2.24a2.24 2.24 0 012.239 2.24h1a3.24 3.24 0 00-3.24-3.24v1zm2.239 2.24v5.087h1v-5.087h-1zm-4.479 5.087v-5.087h-1v5.087h1zm2.24 2.239a2.24 2.24 0 01-2.24-2.24h-1a3.24 3.24 0 003.24 3.24v-1zm2.239-2.24a2.24 2.24 0 01-2.24 2.24v1a3.24 3.24 0 003.24-3.24h-1zM9.217 27.5a2.24 2.24 0 01-2.239-2.24h-1a3.24 3.24 0 003.24 3.24v-1zm2.24-2.24a2.24 2.24 0 01-2.24 2.24v1a3.24 3.24 0 003.24-3.24h-1z",
    fill: "currentColor"
  }));
}

var MemoSvgElevator = /*#__PURE__*/React.memo(SvgElevator);

function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgExternalLink = /*#__PURE__*/React.memo(SvgExternalLink);

function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.546 18.735a1 1 0 10-1.212-1.59l1.212 1.59zM12 20v1h.016L12 20zM1 12l-.881-.473a1 1 0 00-.013.92L1 12zm5.667-5.145a1 1 0 00-1.214-1.59l1.214 1.59zm3.005-3.589a1 1 0 00.456 1.948l-.456-1.948zM12 4l-.002 1H12V4zm11 8l.882.471a1 1 0 00.012-.918L23 12zm-2.925 2.546a1 1 0 001.53 1.288l-1.53-1.288zm-5.223.256a1 1 0 10-1.464-1.364l1.464 1.364zm-4.29-4.19a1 1 0 10-1.364-1.464l1.364 1.464zm6.772 6.533A9.07 9.07 0 0111.984 19l.032 2a11.07 11.07 0 006.53-2.265l-1.212-1.59zM12 19c-3.1 0-5.604-1.773-7.395-3.684a18.68 18.68 0 01-2.548-3.463 10.462 10.462 0 01-.156-.287l-.006-.012-.001-.002L1 12a128.571 128.571 0 00-.894.449.099.099 0 00.005.009 7.254 7.254 0 00.203.376 20.682 20.682 0 002.831 3.85C5.105 18.774 8.1 21 12 21v-2zM1.881 12.473a17.45 17.45 0 014.786-5.618l-1.214-1.59A19.45 19.45 0 00.12 11.527l1.762.946zm8.247-7.26A8.12 8.12 0 0111.998 5l.004-2a10.12 10.12 0 00-2.33.266l.456 1.948zM12 5c3.1 0 5.605 1.774 7.395 3.684a18.676 18.676 0 012.548 3.463c.057.101.1.18.127.23l.029.057.006.012.001.002L23 12l.894-.448-.002-.003-.003-.007a8.989 8.989 0 01-.052-.1c-.035-.065-.085-.159-.151-.276a20.676 20.676 0 00-2.831-3.85C18.895 5.226 15.899 3 12 3v2zm10.118 6.529a17.497 17.497 0 01-2.043 3.017l1.53 1.288a19.505 19.505 0 002.277-3.363l-1.764-.942zm-8.73 1.91a2 2 0 01-1.958.574l-.495 1.938a4 4 0 003.917-1.15l-1.464-1.363zm-1.958.574a2 2 0 01-1.443-1.443l-1.937.495a4 4 0 002.885 2.886l.495-1.938zM9.987 12.57a2 2 0 01.575-1.958L9.198 9.148a4 4 0 00-1.148 3.917l1.937-.495z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1l22 22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgEyeOff = /*#__PURE__*/React.memo(SvgEyeOff);

function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 15a3 3 0 100-6 3 3 0 000 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgEye = /*#__PURE__*/React.memo(SvgEye);

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17 2h-3a5 5 0 00-5 5v3H6v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3V2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFacebook = /*#__PURE__*/React.memo(SvgFacebook);

function SvgFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13 19l9-7-9-7v14zM2 19l9-7-9-7v14z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFastForward = /*#__PURE__*/React.memo(SvgFastForward);

function SvgFeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.24 13.24a6.003 6.003 0 00-8.49-8.49L5 11.5V20h8.5l6.74-6.76z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9L2 23M17 16H9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFeather = /*#__PURE__*/React.memo(SvgFeather);

function SvgFileMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v6h6M9 15h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFileMinus = /*#__PURE__*/React.memo(SvgFileMinus);

function SvgFilePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v6h6M12 18v-6M9 15h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFilePlus = /*#__PURE__*/React.memo(SvgFilePlus);

function SvgFileText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v6h6M16 13H8M16 17H8M10 9H8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFileText = /*#__PURE__*/React.memo(SvgFileText);

function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9l-7-7z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 2v7h7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFile = /*#__PURE__*/React.memo(SvgFile);

function SvgFilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 4.18A2.18 2.18 0 014.18 2h15.64A2.18 2.18 0 0122 4.18v15.64A2.18 2.18 0 0119.82 22H4.18A2.18 2.18 0 012 19.82V4.18z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2v20M17 2v20M2 12h20M2 7h5M2 17h5M17 17h5M17 7h5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFilm = /*#__PURE__*/React.memo(SvgFilm);

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22 3H2l8 9.46V19l4 2v-8.54L22 3z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFilter = /*#__PURE__*/React.memo(SvgFilter);

function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1v12z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 22v-7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFlag = /*#__PURE__*/React.memo(SvgFlag);

function SvgFloorplan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 11.92l-2.94-3.276V5.477m0 9.718V20H10.04M20.06 5.477V1H1v7.634m19.06-3.157h-4.98m-5.04 5.887v-2.73H1m0 0V20h9.04m0 0v-4.318",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgFloorplan = /*#__PURE__*/React.memo(SvgFloorplan);

function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2v11z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgFolder = /*#__PURE__*/React.memo(SvgFolder);

function SvgFurniture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.5h6m-6 12h6M6 23H2a1 1 0 01-1-1v-8a1 1 0 011-1h19a1 1 0 011 1v8a1 1 0 01-1 1h-2.5M6 23v3m0-3h12.5m0 0v3M2 1h19a1 1 0 011 1v8a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1z",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgFurniture = /*#__PURE__*/React.memo(SvgFurniture);

function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.287 20.958a1 1 0 10-.574-1.916l.574 1.916zM2.243 16.03a1 1 0 10-.486 1.94l.486-1.94zM15 23a1 1 0 102 0h-2zm1-3.87l-.997-.078a.976.976 0 00-.003.078h1zm-.94-2.61l-.11-.994a1 1 0 00-.608 1.69l.718-.696zm6.44-7h1-1zM20 5.77l-.937-.35a1 1 0 00.213 1.04L20 5.77zM19.91 2l.92-.394a1 1 0 00-.636-.565L19.91 2zM16 3.48l-.262.965a1 1 0 00.819-.134L16 3.48zm-7 0l-.557.83a1 1 0 00.819.135L9 3.48zM5.09 2l-.284-.959a1 1 0 00-.635.565L5.09 2zM5 5.77l.724.69a1 1 0 00.213-1.04L5 5.77zM3.5 9.55h1v-.005l-1 .005zm6.44 7l.719.695a1 1 0 00-.596-1.687l-.123.992zM9 19.13h1c0-.023 0-.047-.002-.07L9 19.13zM8 23a1 1 0 102 0H8zm.713-3.958c-1.137.341-1.89.34-2.407.219-.504-.118-.877-.372-1.224-.718a7.187 7.187 0 01-.525-.602c-.166-.209-.368-.472-.561-.699-.391-.459-.938-1.008-1.753-1.212l-.486 1.94c.185.046.388.184.716.57.166.194.316.392.52.648.193.242.416.51.675.77.528.528 1.217 1.024 2.182 1.25.952.223 2.074.159 3.437-.25l-.574-1.916zM17 23v-3.87h-2V23h2zm-.003-3.792a4.37 4.37 0 00-1.219-3.384l-1.436 1.392a2.37 2.37 0 01.661 1.836l1.994.156zm-1.826-1.694c1.626-.181 3.481-.594 4.93-1.812C21.6 14.442 22.5 12.466 22.5 9.52h-2c0 2.514-.749 3.863-1.686 4.65-.986.83-2.351 1.187-3.865 1.356l.222 1.988zM22.5 9.52a6.44 6.44 0 00-1.776-4.44l-1.448 1.38A4.44 4.44 0 0120.5 9.52h2zm-1.563-3.4a6.07 6.07 0 00-.108-4.514l-1.838.788a4.07 4.07 0 01.072 3.026l1.874.7zM19.91 2c.284-.959.283-.959.282-.96h-.002l-.004-.001a.99.99 0 00-.068-.018 2.323 2.323 0 00-.407-.047 3.9 3.9 0 00-.949.104c-.785.174-1.876.604-3.319 1.571l1.114 1.662c1.287-.863 2.15-1.173 2.639-1.281a1.94 1.94 0 01.46-.056c.033 0 .046.003.04.002a.35.35 0 01-.056-.013l-.007-.002-.004-.001h-.002c0-.001-.001-.001.283-.96zm-3.648.515a14.38 14.38 0 00-7.524 0l.524 1.93a12.38 12.38 0 016.476 0l.524-1.93zm-6.705.134c-1.443-.967-2.534-1.397-3.319-1.571A3.9 3.9 0 005.29.974a2.321 2.321 0 00-.408.047 1.34 1.34 0 00-.072.02h-.002c-.001 0-.002 0 .282.959s.283.959.282.96h-.001a.459.459 0 01-.067.016c-.006.001.007-.002.04-.002a1.94 1.94 0 01.46.056c.488.108 1.352.418 2.64 1.28l1.113-1.66zM4.17 1.606a6.07 6.07 0 00-.108 4.514l1.874-.7a4.07 4.07 0 01.072-3.026l-1.838-.788zm.105 3.474A6.44 6.44 0 002.5 9.555l2-.01A4.44 4.44 0 015.724 6.46L4.276 5.08zM2.5 9.55c0 2.93.903 4.894 2.399 6.152 1.445 1.215 3.297 1.639 4.918 1.84l.246-1.984c-1.519-.189-2.887-.555-3.877-1.387-.94-.79-1.686-2.13-1.686-4.621h-2zm6.721 6.305A4.37 4.37 0 008.002 19.2l1.996-.14a2.37 2.37 0 01.66-1.815l-1.437-1.39zM8 19.13V23h2v-3.87H8z",
    fill: "currentColor"
  }));
}

var MemoSvgGithub = /*#__PURE__*/React.memo(SvgGithub);

function SvgGitlab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 01-.3-.94l1.22-3.78 2.44-7.51A.43.43 0 015.4 2a.42.42 0 01.11.18l2.44 7.49h8.1l2.44-7.51a.43.43 0 01.69-.16c.051.05.09.112.11.18l2.44 7.51L23 13.45a.84.84 0 01-.35.94z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgGitlab = /*#__PURE__*/React.memo(SvgGitlab);

function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12h20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgGlobe = /*#__PURE__*/React.memo(SvgGlobe);

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_svg__pattern0)",
    d: "M0 0h17v17H0z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "google_svg__pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_svg__image0",
    transform: "scale(.00098)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "google_svg__image0",
    width: 1024,
    height: 1024,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABAAAAAQACAYAAAB/HSuDAAAABmJLR0QA/wD/AP+gvaeTAAAgAElEQVR4nOzdeXjV9Zn//9f9OScJBCQJkAQQF+ourV8xJBRFiUlAsdrajlg7M11tbWutttP+us04Q7cZO+102s5036eLbe0yrY6MmISouECIWgtqXQBXSE7YJZDknM/9+0PHukAMITnvszwf19Xr6qWSPAVrue/P+/M+EgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCMLHQAAAA4eFsWnzJhXN+k0r3JdEWixEssrUkv+4uSbrF75aF+r0Tsu9wTmTgRb8/E6Uz5wIRdA8ntgzUd65851K8NAACyhwUAAABZ4EuXJnbterJiXyZdGWWiKjOvyEReabEqTF4RR1GlySvkqpRUYdJh7hqvSOPkmiQpKVOlXKWSJgT+23mhfTLtlatPUr+k3ZJ2umlHJNvp0k4p3umx7Ygi7fTYdrjFOxKyHS7bWdJfmqpctWp74L8HAACKAgsAAABGaMviUyZEA8npblGtoqha5tOj2GvcrFrSDMmqJa+RNF3SYYFzc1laUq9JW93VK1OvuXpiU68998czkbYkLX5qoEyPz7i+qy90MAAA+YgFAAAA+/Fkc8OUklgzo0hHxPIjTXa4mY7w2I+UaaaeHerLQ3cWI5e2mfSU5I+77KlIesplj7n5Uwklntq7xzYdceede0N3AgCQa1gAAACKUnfzvFrJXyX5MZH7MW42y1wzXTpcpqMkjQ/diEOyRdJGlzaYa6Mi32ie2JjO2MZpGvekdXSkQwcCAJBtLAAAAAXJGxuTPck9R8r9GHl0TGR6lbsfI9Mxkh0j+cTQjQhmUNITJm2Q+SOSHvJYDyqOH67WpE0sBwAAhYoFAAAgr/nS2aXd28edECk6yV2zTXayFM+W7FhJJaH7kF9cGjDXBjN/UIoelushlz+UKUs/MH35PanQfQAAHAoWAACAvOBLZ5f2bJt4oik+yaXZJp0s12yZjpWUDN2HotBjrj95pD9J/qfI7U8D5fF6LiUEAOQLFgAAgJyzraWuIh1H/0+mOZLmSDpV0sniiT5yTyyzDXL/o5utM4/Xufs9te1dj4YOAwDgpVgAAACC8WWKttxSf1KUsDpzr5OrTpFOlqsqdBtwiPbIda9MXW7WFWe8a9rCzgdsmeLQYQCA4sUCAACQNdta6ioG4+S8yOJ5LjVIqpdUG7oLyApXSqa1Lq2NYl+rZGZt9c33PB06CwBQPFgAAADGxBPz548vnZA+Q7IF5l4nqU7S9NBdQI7pltTpZl2Sr8qMj+/gTgEAwFhhAQAAGBVbFp9eY/HgArlON9k8yU+TVB66C8gzfZLWynSnZfyOTEnpXdNW3NETOgoAUBhYAAAARmRbS92Rgx6dJddZJp0p04mhm4CCZPaI5Ld57CuTSeuYsqLzidBJAID8xAIAAPCKvK6uJFWleYoTZ8h8gZ59f78mdBdQpLplutWk1nRGt09f2bk+dBAAID+wAAAA7FdP42nHepRsMVOz5GeKy/qAXPWQSx2Re0dsifbattXdoYMAALmJBQAAQNKzR/ozis51qUWuheIJP5CvNrjUam6tySizYnJr187QQQCA3MACAACK1PbGUysHo9JFbt5iUoukV4VuAjDqMjLdK6lVim+oXtB1hy1THDoKABAGCwAAKCI9i+YdZ7FfIPkSlxZIGhe6CUBWPSXTCrluKskM3lTVce+O0EEAgOxhAQAABezhJceWVfZXLY5N50eyc1x+VOgmADkjlukel90QZez66pWru0IHAQDGFgsAACgwqXPqpisTXeCuCyQ1SSoP3QQgL2x06ebIdcPUKX032XXrB0IHAQBGFwsAACgAWxY3zEqk4zfEZheYdKakktBNAPJat+Q3xKbr96Yn3jSro2Nf6CAAwKFjAQAAecglS7XUnSGPlko6X1zgB2Ds7JPUaqbr0yXp301ffk8qdBAAYGRYAABAnvDGxmRPck+juS5w6UKTjgzdBKDoZOS6S6brXNEvattWd4cOAgAMHwsAAMhhvkxRzy1z5yvSm0z2JklHh24CgOf0S7pZsl+X9pf+oXLVqu2hgwAAQ2MBAAA5xiXraW54rXn8FpldJGl66CYAGIpLAybdZO7XZpIDf5i24r49oZsAAC/HAgAAcsBL3um/SNKM0E0AMEL9km52s+s82vcblgEAkDtYAABAQL2L606M4+gd5naJy48K3QMAo2yvTDdYrJ9M3Rn/r3V1DYYOAoBixgIAALJsy+LTa6L0wMUye4uk+eLfxQCKw5Mu/dIT/qNpK9auCx0DAMWI33QCQBb40tmlPdvHX2Bu75B0rqRk4CQACMfUJdmPB1w/n9m2ZmvoHAAoFiwAAGCMuGQ9LfXNkext7v4GSZNCNwFAjolNao/NfpIZn/n1jOu7+kIHAUAhYwEAAKPs6aY5RyWiknea+yWSTgjdAwB5YqeZ/SGW/1dNa2ebSR46CAAKDQsAABgFvnRponf7Y+e6+ztdusCk0tBNAJDH7jbTtzzdd21Nx/pnQscAQKFgAQAAh+DppjlHJZV8t0zvEh/dBwCjbZekn7qib9e2rb4vdAwA5DsWAABwkJ6YP3/8uAnpt7p0mVx1oXsAoBi4dL9J31Gm7/ucCgCAkWEBAADD1N1Ud4xZdKVMb5WrKnQPABSp3S5da+bfqmlde0/oGADIJywAAGAIvkxR76qGJbH8MnO9TlIidBMAQNKzlwS2muxrU89cc6MtUxw6CAByHQsAANiPJ5sbppTKL3PpfSYdGboHADAEs0fk/p+J0uiHU5av3hU6BwByFQsAAHiBLS3zXhsp/jt3vYGb/AEg7/Sb2a9ity9xaSAAvBwLAABFzxsbk6mo742SXyXTGaF7AACjwHW7ZF+tjst/Zx0d6dA5AJALWAAAKFr/d5t/7LrKpJND9wAAxoDrQYv05R0l2//ruOWP9IfOAYCQWAAAKDqpRXNmeJy8QtJlkqaE7gEAZEW35F8rS5Z8q+KmO7eFjgGAEFgAACgavU1zG2KzqyWdJykK3QMAyD6XBiKzX5qif5naetcDoXsAIJtYAAAoaC5Zb1P9+S59nPf7AQAvEEu60WO/pnbl2ttDxwBANrAAAFCQXLLe5obXufRxyReE7gEA5C5ztcXmX6htW3tz6BYAGEssAAAUlCfmzx9fVp6+TNJVkmaF7gEA5BHXOo/sizXp8p/zyQEAChELAAAFYcviUyYk0qXvcbO/k3RE6B4AQP4yaX0sXVOTmfALFgEACgkLAAB5bceCBVUD4/o/Ltflkg4L3QMAKCjdbvatZIl9ecry1btCxwDAoWIBACAv9TTOnqhowgck/4hM1aF7AAAFbbO7vhz1l367+vbbd4eOAYCRYgEAIK/sPGf+5P5M+mM88QcAZJ89I/Ovl6QHr6nquHdH6BoAOFgsAADkhb8M/vYBySeG7gEAFC+XtsnsP3g1AEC+YQEAIKdtXTJvUmYwvtJdHzZpcugeAABe4CmX/rlmct/37Lr1A6FjAOCVsAAAkJO2tdRVpBV9kif+AICc50pJ9m974vKvzuro2Bc6BwAOhAUAgJzidXUlPRWJS838HyQdHroHAICD8Ki7f7rmrLU/s2WKQ8cAwEuxAACQE7yxMdmb3PMud10taWboHgAADsFDcvuH6vY1vzbJQ8cAwP9hAQAgKF+6NNG7fdOl7vqkpKND9wAAMIo6TdHHq9tWrwwdAgASCwAAgbhkqaaGi8z8n1yaHboHAICxYlKrR/r/am7uvDd0C4DixgIAQNZ1N887xRR/SdKi0C0AAGRJ2sy/p4R/pvqmrs2hYwAUJxYAALImdU7ddE/bZyV7h6RE6B4AAALYI9e/K+77Qk3H+mdCxwAoLiwAAIy5bS11FWmPPuPS+0wqDd0DAEBoLm0z6TPVmQlft46OdOgeAMWBBQCAMeONjclUYs8HJF0taUroHgAActCfTfbR6rY1N4QOAVD4WAAAGBM9TQ1LZf5ZSSeEbgEAINeZ1JpJ+IenrVi7LnQLgMLFAgDAqEqdPfcEj+xLks4P3QIAQJ7pN/lXo9LE56csX70rdAyAwsMCAMCoSJ1xxmEaP/CPsetK3vMHAOCQdJvp6qkLOr9vyxSHjgFQOFgAADgkvnRpIrVt0xUu/aNJk0P3AABQQP7sZlfVtq65KXQIgMLAAgDAiPW01C2QR1+TNCd0CwAABeyGTCbxwekdd20KHQIgv7EAAHDQtrXUHZlW9CW5LhL/HgEAIBv63OyLfenya2Z1dOwLHQMgP/EbdwDD9vCSY8smDU7+pLl/VNKE0D0AABShR+X2yZr2NdeFDgGQf1gAABiW7rPnnmGRfVPSa0K3AAAA+3XSMh+Z3Nr1eOgSAPmDBQCAIe1YsKCqv7T/C2Z6t/h3BgAAuaTPzZfVpCf+u3V0pEPHAMh9/GYewH75MkWp2+o/KGmZpMrAOQAA4MAejtzeN7V9TXvoEAC5jQUAgJfZfHb97ERk35J8QegWAAAwLG5mP+13fXhm25qtoWMA5CYWAACet7GxcdyE5J5lcv2dpJLQPQAA4KB1u9nHalvX/FfoEAC5hwUAAElSd9O8xWbxNyQdE7oFAAAcIrMb0/Hg5TPa73ksdAqA3MECAChyW5fMm5Qe8H81+WXi3wkAABSSne72iZr2Nd82yUPHAAiP3+wDRaynee5Fkv2npNrQLQAAYMzclVB06ZS21feHDgEQFgsAoAilFs2Z4XHy25LOD90CAACyYlCmL1dX9f2jXbd+IHQMgDBYAABFJtVSf5lL18hVFboFAABkm99nUXRp9c1r1oYuAZB9LACAIrG1cd7MTNK/LffzQrcAAICg0jL9286S7f903PJH+kPHAMgeFgBAgXPJelvq3+Ouf5VUEboHAADkBpPWZ+L40mkru1aHbgGQHSwAgALW3TyvNlLmWy67MHQLAADISYNu9s816fLPWUdHOnQMgLHFAgAoUKmW+st46g8AAIbDpPXy+G3V7V13h24BMHZYAAAF5unGuqnJROKbkl8UugUAAOSVZ08DVB31WbvuukzoGACjjwUAUEBSTfUXuOm7kmpDtwAAgLx1l8neXt225qHQIQBGFwsAoAD0NM6eaMkJ33D3t4ZuAQAABWGvpE9Wt3V+zSQPHQNgdLAAAPJcT1P9WTL9WNLRoVsAAECBMV+RSCcundKx+snQKQAOHQsAIE95Y2OyN7Hnky5dLakkdA8AAChY3Yr9XTUr194YOgTAoWEBAOShVHPD8S6/VtJpoVsAAEBxMLOfeHrP5TUd658J3QJgZKLQAQAOTk9z/VUuv1cM/wAAIIvc/a1KlN/X3dwwP3QLgJHhBACQJ3YsWFA1UNb/XUl/FboFAAAUtbSbfZ6PCwTyDwsAIA/0tNQtcI9+ZtKRoVsAAACe5SsTmcTbuCAQyB8sAIAc5kuXJnq2P3a1uf+9pGToHgAAgJfYae7vr25fe23oEACvjAUAkKO6m+fVmuIfSTo3dAsAAMAQXKavVlf1fdyuWz8QOgbAgbEAAHJQd/PcRSb7iaTa0C0AAADD4dKaOJN48/SOuzaFbgGwfywAgBzidXUlqcroS5I+KP73CQAA8s9uc38vrwQAuYkBA8gRqXPqpns6+oWks0K3AAAAHAoz+8ng+Mz7Zlzf1Re6BcBfsAAAcsCWRfXNUayfS6oJ3QIAADBK7lUUXVxz8+qHQ4cAeFYUOgAoZr5MUXdLw7Io1v+K4R8AABSWUxXHXammuW8JHQLgWZwAAALpaZw9UYny70q6JHQLAADAGHKXvlyTmfAJ6+hIh44BihkLACCA3ub6epdd5/KjQrcAAABkydq0py+a0X7PY6FDgGLFKwBAlvU01785lrUz/AMAgCIzN2nJVVta5r02dAhQrDgBAGSJ19WV9FRG/2nSZaFbAAAAAkrL7R9q2td8IXQIUGxYAABZ0N08r9YUXyfpzNAtAAAAOeIXcaL/3dNW3LcndAhQLFgAAGOst7m+PpZ+K2lm6BYAAICc4nowihJvmtp61wOhU4BiwB0AwBjqbmp4Yyy1ieEfAADg5Uwnxp65rbt57qLQKUAx4AQAMAa8sTHZk9jzdd73BwAAGBZ3s8/UtK75tEkeOgYoVCwAgFG2Y8GCqoFx+34ht8WhWwAAAPLML9Pl8btmXN/VFzoEKEQsAIBR1NN42rFKRH+Q7KTQLQAAAHnqtjhRctG0FXf0hA4BCg0LAGCUpFoaXufu10o6LHQLAABAnns6cn/j1Pa1a0KHAIWESwCBUdDT0vBBd/+9GP4BAABGw4zY7Nbuloa3hQ4BCgknAIBDwGV/AAAAY8pl+tfqBZ2fsmWKQ8cA+Y4FADBCWxafMiHKlP1E0htDtwAAABS4X+zJTHjnrI6OfaFDgHzGAgAYgc2Nrz06EWWul+nVoVsAAACKxB8TCV0wZUXnE6FDgHzFAgA4SD3NDWdK/ltJU0O3AAAAFJmnzeMLqtu77g4dAuQjLgEEDkJ3c8OFki8Xwz8AAEAIM9yiti2L6ptDhwD5iAUAMEzdLQ3L7Nkn/xNCtwAAABSxyijWTT3N9VeGDgHyDa8AAK/AlylK3Tr3KzL7YOgWAAAA/IVL36nJTPiAdXSkQ7cA+YAFADCEJ+bPHz+ufPDnLrswdAsAAAD266ZEaXTxlOWrd4UOAXJdMnQAkKu2Lpk3Ke5P/9ZlvGMGAACQq0xTE7tLEqEzgHzAAgDYj6eb5hyVGcgsl9lJoVsAAABwQLfGUf95las694QOAfIBrwAAL5FqqjvNLfofSdNCtwAAAOCAbo0T/edNW3Efwz8wTHwKAPACPU1zl7glbhHDPwAAQC5j+AdGgFcAgOd0NzW8UeY/l3xc6BYAAAAcgKmrdF/ZhRz7Bw4eJwAAST3N9VeZ+W8kMfwDAADkrlvjqH9h5apV20OHAPmIBQCKXk9L/TWSviLuxAAAAMhlHPsHDhEDD4qWS5Zqrv+KpCtDtwAAAGBIDP/AKOAOABQlb2xMphLPfF/S20K3AAAAYEgM/8AoSYQOALJtY2PjuHSi71eS3hy6BQAAAENi+AdGEa8AoKikzjjjsHjcwH+b1BS6BQAAAENi+AdGGQsAFI2tS+ZNygzEv5fUGLoFAAAAQ3j2o/4Wcds/MLq4AwBFYfOSOdWZgXiFpFNDtwAAAGBIt8ZR/3mVqzp58g+MMk4AoOClFs2Z4XGiVbKTQrcAAABgSBz7B8YQlwCioPU2zT/cpXbJTgzdAgAAgCEx/ANjjAUACtaWxQ2z5PEtko4N3QIAAIAhMfwDWcACAAWpp/G0YyVbadJRoVsAAAAwJIZ/IEu4AwAFZ2vzvJMzitskTQvdAgAAgCEx/ANZxAkAFJQtLXWvkcTwDwAAkPsY/oEs4wQACkZvy2tPij3TJml66BYAAAAMwdRVuq9sUeWqVdtDpwDFJAodAIyGLYvnvjqOM7eI4R8AACDX3RpH/QsZ/oHs4xUA5L2tzfNOlqtdpprQLQAAABgSx/6BgFgAIK91N9Ud46Z28eQfAAAg1zH8A4HxCgDy1pbFDbPMopWSDg/dAgAAgCEx/AM5gAUA8tLmxtcebRnvkHRE6BYAAAAMieEfyBHJ0AHAwUotmjPDPb5ZriNDtwAAAGBIDP9ADuEOAOSV1Dl10z2T6JB0XOgWAAAADInhH8gxnABA3tjeeGrlYDq6QdLxoVsAAAAwBFNX6b6yCytXdTL8AzmEBQDyQuqMMw4bTAyskHRa6BYAAAAM6dY46j+P4R/IPVwCiJy3sbFxnI/r/72k+tAtAAAAGBLH/oEcxgIAOc0bG5PlyT2/lOzs0C0AAAAYEsM/kONYACBnuWS9yb4fmOv1oVsAAAAwJIZ/IA9wBwByVqpp7lfl/tbQHQAAABgSwz+QJ1gAICf1NNd/UtIHQ3cAAABgSAz/QB6x0AHAS6Wa577XZd8U/3wCAADkMoZ/IM8wYCGn9DTXv1nSz8X9FAAAALmM4R/IQywAkDN6mhvOlHyFpHGhWwAAAHAApq7SfWWLKlet2h46BcDB4SkrckLPovpTJb9BDP8AAAC57NY46l/I8A/kp0ToAODppjlHRYraJU0N3QIAAIAD4tg/kOdYACConefMnxy72kx6VegWAAAAHBDDP1AAWAAgmI2NjeMi9f+PSXNDtwAAAOCAGP6BAsEdAAjCly5NlCf3/FLSmaFbAAAAcEAM/0ABYQGAIHq3bvoPc70+dAcAAAAOiOEfKDAsAJB13U31H3XT+0N3AAAA4IAY/oECZKEDUFy6mxreaOa/FssnAACA3GTqKt1XtoiP+gMKDwsAZE13c8N8k7dLGhe6BQAAAPvFk3+ggLEAQFY83TTnqKQlV0uqDd0CAACA/WL4BwocHwOIMbetpa7ClWg3aVboFgAAAOwXwz9QBHgPG2PKly5NpD36hUknh24BAADAfjH8A0WCBQDGVM/Wx74o6dzQHQAAANgvhn+giHAHAMZMd0v9+831jdAdAAAA2C+Gf6DIsADAmOhuqW8x13JJydAtAAAAeBmGf6AIsQDAqNt8dv3sRKQ7JE0K3QIAAICXYfgHihSfAoBRtXXJvEke+00mzQzdAgAAgJcwdZX2l71u6srOXaFTAGQflwBi1PjSpYnMQPxrbvwHAADISbfGUf/CylWrtocOARAGCwCMmtT2TZ+XtCh0BwAAAF6GY/8AuAMAoyPVNPctbvYz8c8UAABArmH4ByCJYQ2jILWoYa7Hfquk8aFbAAAA8CIM/wCexwIAh2TL4tNrLDPYadKRoVsAAADwIgz/AF6EOwAwYr50dmmUSf+G4R8AACDnMPwDeBkWABix1PYJ/yb5gtAdAAAAeBGGfwD7xSsAGJFUc/3fuPTT0B0AAAB4AVNX6b6yRXzUH4D9YQGAg5Y6e16dR/EqSeNCtwAAAOB5PPkHMKRE6ADkl53nzJ+c8bhd0tTQLQAAAHgewz+AV8QdABg2l6w/nf6xy48K3QIAAIDnMfwDGBYWABi2npa5H5V0fugOAAAAPI/hH8CwcQcAhqWnqf4smdokJUO3AAAAQBLDP4CDxAIAryi1aM4Mj5N3S6oN3QIAAABJDP8ARoBXADAkb2xMepz8mRj+AQAAcgXDP4ARYQGAIaUSfZ+W1Bi6AwAAAJIY/gEcAl4BwAF1N89dZLL/FYsiAACA8ExdpfvKFlWuWrU9dAqA/MQCAPv13Hv/f5Q0NXQLAAAAePIP4NDxZBcv40uXJjyT/LkY/gEAAHIBwz+AUcECAC+T2rbpYzItDN0BAAAAhn8Ao4dXAPAiqbPn1cVRfIdJpaFbAADDtlemfe7abVJa0g6X0pG0azg/2KVK2XO/J3BNkpR47r8fpkjJ5/77REklYxEP4AB45x/AKGMBgOf1NM6eqET53ZKOC90CAEWqW1KPzDfLtcWkLXJt9ki75NrlZjsSrp0e+y4lM7t9cGBXTcf6Z7IVt2XxKRNKBsZXDSbTVVEcVZl7pUdRlXlcFZtVmVRpZlXuXiVXlZuOMGm6WBwAB4/hH8AYYAGA5/U01/9I0ttDdwBAgeqW9LikJyU9brLH3fxJj/VkQsnHpuwc6LGursHAjaPOlynqvX3OtEw6OsIS0eHmOsKlI0w6XK4jWBIA+8HwD2CMsACAJCnV0vDX7v6z0B0AkMcyMtso90ckbTBpQyx7VLINlnlmQzaf1OcbX6Zo663zp0uZEzLS8Rb5CXKdIOkESUfp/15JAIoBwz+AMcQCAOpuqjvGLLpb0qTQLQCQB9KSNsi1TmYPmsfrPNKDe9ITH5jV0bEvdFyheXjJsWUT91UdGyV0gj27FDhe0onP/acybB0wyhj+AYwxFgBFzuvqSnoqo1UmNYRuAYBc49KASesk3e2mu13RPYN7oj8eceede0O3FTuXrLe54TjJ6900V7HqZZojqTx0GzAiDP8AsoAFQJHrbq7/jElXh+4AgBwQu/SgmVab+2q5d06dsm+dXbd+IHQYhscbG5M9ib0nm7zeLJ7rsnq5ThH3CyDXMfwDyBIWAEVsy9l186IoWiU99xFPAFBMTNvlfofJVsfyu0rM10xu7doZOguj6+Elx5Ydtq/i1ITZfFnU6PIFkqaE7gKex/APIItYABSprUvmTcoMxPdKmhW6BQCywF16QNIqc2u1xODt1Tff83ToKISRWjRnhmdKznDzFpNaJL0qdBOK1q1xov+8aSvu2xM6BEBxYAFQpFJN9d9w0/tDdwDAGOpxV6tJra741tr2rkdDByE39S6uO9Hj6KzYdZZJjZIOD92EIsCTfwABsAAoQj3N9edKulH8+gMoLPtMWhXLbjaLb65uXXuvSR46CvmnZ9G848wz5yu217npLHGHAEYbwz+AQBgAi8zOc+ZP7k+n/yRpRugWABgFmyTdKPcb+veWdHA7P0bbs6/MZRZLdr5c58lUHboJeY7hH0BALACKTKq54b9d/obQHQAwQv2SbjbT9ZnIbp62Ys3G0EEoLpvPrp+dMDvfzFv82dcFuEgXB4N3/gEExQKgiKSa6//GpZ+G7gCAg7TXZCtc+t2AdMPMtjVbQwcBkrR1cf0R6Vjnm/tSyc6SlAjdhBzGk38AOYAFQJHoaTztWCWS90g+MXQLAAzDFkm/ctP1u0q233bc8kf6QwcBQ9mxYEFV/7iBC55dBugccW8AXown/wByAguAIuCSpZrrl+vZ35AAQK7qc3n/10kAACAASURBVPPfRx79fOrkPSvsuvUDoYOAkehtmn+4a3Cpm10s6bXi91vFjSf/AHII/4dUBFLNc9/rsm+F7gCA/egzs98o9ut2lG1fwZN+FJonmxumlJhe99zJgCXiNYFiw5N/ADmFBUCBSy2aM8M9uU6uqtAtAPACa+X+40xZ5pfTl9+TCh0DZMOzr+Ml3iXpHZKmB87BWOPJP4AcxAKgwPU019+oZ584AEBoG+X27WSUuXZya9fjoWOAUHyZop5V9U0mXSbXheK+gELEk38AOYkFQAFLNc+9xGXXhu4AUNTSJvufjMU/rN3uN1pX12DoICCXbGupO3JQiXeZ+6WSZobuwSjgyT+AHMYCoED1Ns0/PLb0OkmVoVsAFB+T1sv0tWR68FdVHffuCN0D5IPU2fPq4ii+zKS3ShofugcjwpN/ADmNBUCB6mmuv1bSJaE7ABSVjKTlJvv21MlHLbfrrsuEDgLyUWrRnBmKk5e6dLmkaaF7MEw8+QeQB1gAFKDu5oYLTf670B0AioNL20z6dtLib/FuPzB6Hl5ybFnFwORLJP+QpFND92AIDP8A8gQLgAKzZfHpNVFmcL2kqaFbABQ2l9aY25eqp+z5vV23fiB0D1DIUmfPq1PCr3L3t0hKhu7Bi3DsH0DeYAFQYHpa6n8g1ztDdwAoXCa1euz/Xr1y7XKTPHQPUExSzQ3Hu/wqSW+XNCF0T9HjyT+APMMCoICkWuY2ulu7+HUFMPrSbn6dMtEXaleu+WPoGKDY7Txn/uT+wcx7ZH6F+PSAMBj+AeQhBsUC8fCSY8sq+qvulenE0C0ACso+c/0wjvSl2tbODaFjALyY19WVpCqiv1Vkn5L7saF7igbDP4A8xQKgQKSa66926TOhOwAUjJ1yfdMt+kpt2+ru0DEAhuaNjcme6Jm3mNnfSzohdE9BY/gHkMdYABSArc3zTk4rvsek0tAtAPLeU5K+GCf6v8eFVkD+ccl6m+rPd9PVkupD9xQgLvwDkNdYAOQ5lyzVXH+LpDNDtwDIa0+Y6XNTq/p+xI3+QGHobqlviWSfc/d5oVsKBMM/gLzHAiDPdTfX/61JPwndASBvPSXpi/19ye8cceede0PHABhdLllPc8MbTH61pNNC9+Qtjv0DKBAsAPLYznPmT+5Ppx+QVBO6BUDe6TXpmmcyE74+q6NjX+gYAGPLJetumfv6yPUvkp0UuievMPwDKCAsAPJYT3P9DyW9I3QHgDxi2q7YvpCekPmPGdd39YXOAZBdLlmqqeEimV8j6VWhe/IAx/4BFBQWAHmqt6mhKTZvFb+GAIZnt9w+b/0l36i+/fbdoWMAhOVLZ5f2bi9/h7s+K04SHgjDP4CCw/CYh7yxMZlK7Llb0mtCtwDIee7mv4jTyU9N77hrU+gYALll85I51Yn+xNVu9l4+TegFOPYPoECxAMhDqeb6j7j0pdAdAHKd/09CiY9NaVt9f+gSALlta+O8melEfLVJl0pKhO4JjCf/AAoWC4A8s2Xx6TVRZvDPkipDtwDIUWaPuOJP1Lau/U3oFAD5pbe5vj5+9iHDWaFbguDJP4ACF4UOwMGJMgP/LIZ/APu3y6SPVlftmc3wD2AkprZ1dla3dTa6+9skdYfuySqGfwBFgBMAeaSnueFMyW8Rv24AXiwj6eul/WXL+I0rgNHy9AV15Ym9iY/J/ZNFcD8Ax/4BFAUGyTzhS5cmUts2dUqaE7oFQC6xVbL4yprWtfeELgFQmFLNDce7/D8lLQrdMkYY/gEUDV4ByBOp7RvfLoZ/AH+x1UzvrT5zzUKGfwBjqbptzUPVZ3aea27vkbQ1dM+oMnWV9pddyPAPoFhwAiAPPN1YNzWRiP5s0uTQLQCCy0j6eklm8J+qOu7dEToGQHHZ1lJXkfboM5I+oPz/tACe/AMoOiwA8kBPc/1XJF0VugNAcH82Re+vblu9MnQIgOK2pWXeayPPfFuyU0K3jAgX/gEoUiwActyWxXNfHWXsHknJ0C0Agtln7tfsKNtxzXHLH+kPHQMAkuR1dSW9Ffap2OxTeXVJIMM/gCLGAiDH9bTMvUlui0N3AAjFVlkcv7t65do/hy4BgP3pbp53iln8A7nqQre8IoZ/AEWOBUAOSzXVX+CmP4TuAJB9Lm2T2YdrWtf8xCQP3QMAQ3HJelvq3+Nu/yb5xNA9B8A7/wCKHguAHOV1dSWpyuhPkk4I3QIgu0z+30r65dU3dW0O3QIAB2PL4oZZibR/103NoVteguEfAMTHAOas3orE28XwDxSbXSZ/39S2tW9i+AeQj6atWLNx6pSjzzHZRyT1he6RxEf9AcALcAIgB/U0zp6oRPlDkqaHbgGQJa5bMnHiHdM77toUOgUARkNP42nHKpH4vqSzgkXwzj8AvAg3y+ei5PhPyBn+gSKxx0x/N7Wt87u86w+gkNR03P2IS42p5vorJX1BUlmWE26No/7zKld18uQfAJ7DCYAcs62l7si0Rw9KGh+6BcAYc93ukd5W29q5IXQKAIylzWfXz05EulbSa7L0LXnnHwD2gzsAckza7R/F8A8UulimL1RP6Wti+AdQDKav7FyfKI0WuPSzMf9mvPMPAAfECYAckjp7Xp1H8RqxmAEK2YY4jv962squ1aFDACCE7qaGN8r8eyZNHoMvz5N/ABgCg2YO8Sj+vPg1AQqX2Y2Z0vRrGf4BFLPa9jW/k8cNLq0Z1S/Mk38AeEWcAMgR3S0N55j7/4buADAm+tzs/bWta/4rdAgA5ApfujSR2vrYR2X+WUklh/jlePIPAMPAAiAHuGQ9zfV3mdQQugXAKDN7xDJ2SfXK1V2hUwAgF/U2NTTF5j+XVDuiL8BH/QHAsHHcPAekmhouYvgHCo+bX6v0njkM/wBwYFPb17SnM/GrzdU2gh9+axz1L2T4B4Dh4QRAYN7YmEwl9qyXdHzoFgCjw6WByPTB6tbO74RuAYB84Y2NyVRyz+fk+vgwfwjH/gHgILEACCzV1PBuN/9u6A4Ao2ajxdFSnvoDwMikmude4rLvSZowxF/G8A8AI8ACIKCHlxxbVjFQ9aCko0O3ABgFrlsU65Kajs4toVMAIJ+lFjXMjWP/jUlHvuxP8s4/AIwYdwAEVDlQdYUY/oFC4G726eopRzcz/APAoau+ec3aZGn0GpP/90v+FO/8A8Ah4ARAIFuXzJuUGYg3SJoSugXAIdllsb+1euXaP4QOAYBC45Klmho+JvN/lrSKY/8AcGg4ARBIPBBfJYZ/IK+Z7DHz+GyGfwAYGyZ5TfuaL5jsDaX9ZRcy/APAoeEEQABPNjdMKZU/KqkidAuAkXGpPZOJ3zyjo6s3dAsAAAAwHJwACKBM8cfE8A/kL9MXaiYfvZjhHwAAAPmEEwBZtmXx6TVRZnCDhv5oGwC5adBMV1S3dn4ndAgAAABwsJKhA4pNlB78sIzhH8hDO92ji2vaVq8IHQIAAACMBCcAsmjzkjnViYHkRvH0H8grJnssk4jPn7Zi7brQLQAAAMBIcQIgi6LBkg9IzvAP5BPXuijp51WvWPtE6BQAAADgUHACIEt2njN/cn86vVHSpNAtAIbJ7Eal97y5pmP9M6FTAAAAgEPFpwBkybjL/vi+qHLg/tAdAIbtFztLtr2J4R8AAACFghMAWeC3qSrdX7JRUsXeO6bdvu+WaXMklYfuArB/bvbpmtY1nzbJQ7cAAAAAo4UTAFmQHkheKalCksafvuWMw97y6JOKfHPgLAAvF0u6qrZ1zTKGfwAAABQaTgCMMV+pynSmZJOeWwA8/8f7E7t3/eCE9fGO0teGKQPwEvti80umta79fegQAAAAYCxwAmCMpdPJ9+glw78kWVnmsIr33d9Qduq2myQNZr8MwAvsNkXnMfwDAACgkHECYAz5HRqf7ivZJKlmqL9u4NGK+/ZcN6tWrtrslAF4ga2RtGRqW2dn6BAAAABgLHECYAwN9pW8Ta8w/EtS6TE7T6m4cn0ymjjYlYUsAH/xVCbWQoZ/AAAAFINE6IBC5b9SQuMTv5BUNZy/3kri8nFze2vTW8pXx9vLZorTGcBY25xQtKimfQ0fzwkAAICiwAmAMZKZUvoml151UD8o4YnDLt4wf8L5j6+VafsYpQGQHk17ev6UttUM/wAAACganAAYA+6yeEP0U0nTRvLjE7V7Dy87Zdv2wfsmP+aZ6BVfIQAwfC7dHyXjs6e13v1k6BYAAAAgmzhmPgYGVySbFVnrIX+h2NLP/HrW7YOPTlo4ClkApD+5okW1bau7Q4cAAAAA2cYrAGMhso+Pztfx5MSLNywsb9zcJWnfqHxNoGj5A5aMz2H4BwAAQLHiBMAoG2gvqbNYa0f762ZS4zbt/tHxg56Ojhvtrw0UOpPWp0vTZ09ffk8qdAsAAAAQCicARpvrY2PxZRPV+46u+NC6mclpfbeNxdcHCpc/kEmUNDH8AwAAoNhxAmAUedu4o9KeeURSciy/z77bpq/Yu6p2gaTysfw+QAHYkMhEC6d0rObCPwAAABQ9TgCMorQyV2mMh39JGnfm5sWT3vbQ45bwx8f6ewF5bFPS4rMZ/gEAAIBncQJglPiNmpQuLXlS0mHZ+p5xX3L3Mz844dHM7pJTs/U9gbzgSkVRYuHU1rseCJ0CAAAA5ApOAIySwZKStyuLw78kReXpwyZ9YP3/G1fXe6ukwWx+byBXubQtTnoTwz8AAADwYonQAYXAlynSkYmfyjQ569/cZCXH7DoqMWPv+sH7qyRpYtYbgJxhz3gcnzOtreue0CUAAABAruEEwCjILEic56ZjQzaUHrPzlIor1yejiYNdITuAgPrjyC+ctrJrdegQAAAAIBexABgFruiq0A2SFJUPTqm44v5TS07acYukOHQPkEVpl10y7ebOttAhAAAAQK7iEsBD1N9aekok/2Pojpfqv2fq3X03zTxWrkmhW4AsuKqmrfNroSMAAACAXMYJgEOUML8idMP+lM3pPa3i8vuficoy60K3AGPJpc8w/AMAAACvjBMAh8BbNSWtkickjQ/dckCxpZ/59azbBx+dtDB0CjAGvl7T1pmTSzgAAAAg13AC4BCkPfku5fLwL0mRJydevGFh+aKn2iXtCp0DjKLfVU8+Oifu3wAAAADyAScARsh/pcTg5JINJh0ZumW4Mqlxm3b/6PhBT0fHhW4BDtEd/X3JliPuvHNv6BAAAAAgX3ACYIQykxNL8mn4l6RE9b6jK69cPzOa0s9HBSJvmewxV/Qmhn8AAADg4LAAGCFX4r2hG0akLDO+4rIH6sYt3HK7pL7QOcBB2mGJzLm1bau7Q4cAAAAA+YZXAEZg78pxRyczmUeV5wuUzFPlD+7+2XHlnrG8OsmAopV2j15X2756RegQAAAAIB/l9QAbSjIdv1sF8HOXOLzvxIqr1lVFlQN3hW4BhuGjDP8AAADAyHEC4CD5WpWkd5Q+Lvm00C2jxuV7b555276uqfMllYTOAV7KXN+sbu+8PHQHAAAAkM/y/il2tmV2ll5YUMO/JJls/OInzyq/cNOfZdoaOgd4EdftO8q2fzh0BgAAAJDvWAAcJHd/X+iGsVJ20o5XV1y5XtHEQT4lALni0bKS5OuPW/5If+gQAAAAIN/xCsBB2NdedkIijh9Qof+8uWWe+f1RqwYfqDxTLIkQzh5XdHpt2+r7QocAAAAAhYDh7iAkPH6vCn34lyTzxMQLNy2ccP7jXTJtD52DouTu9laGfwAAAGD0FP4wO0r8VypNTy55StLU0C3ZFO8s3bTreyfs8oHEKaFbUERcn6tp77w6dAYAAABQSDgBMEyZyaVvVJEN/5IUVQwcXXHl+pMTM/d0hm5B0bipesrRy0JHAAAAAIWGEwDDNNhaulzyc0N3hNR/95TVfSuOOEmuSaFbULA2lmQGT6vquHdH6BAAAACg0LAAGAa/afwR6UR6kzgxoUxq3KbdPzp+0NPRcaFbUHD6I+nMqW2dnDYBAAAAxkDRD7TDkU4M/q34uZIkJar3HV3xoXUzk9P6bgvdggLj/lGGfwAAAGDsJEIH5Dp3Wbwx8X1JU0K35ApLeEnZnK1HKaHb049NnCqpJHQT8ptLP6ttX/uJ0B0AAABAIeOp9itI35w8XRLH3fdj/OlbzjjsLY8+qcg3h25BXttQmhm8InQEAAAAUOhYALwCi+wdoRtyWfLo3cdXfmjdxKhy4K7QLchLe2OLL+TSPwAAAGDs8QrAEPx6lccliR9KKgvdksss6WXj5qYO197kbenN5TPEP1cYLrOP1LauvT50BgAAAFAMOAEwhEx5yV9JfOTdsJhs/OInz5pw8cYHZOoOnYO88Lua1jX/EToCAAAAKBYsAIbgrneGbsg3pcfsPKXiyvXJaOJgV+gW5LRNJZnBd4WOAAAAAIqJhQ7IVd42/vC0px8XS5KRcRvc/dtZK9MPTWoRP4d4scE4js+ctrJrdegQAAAAoJgwmB1A2gf/Rvz8jJx5yWF/tWFx+blP3ivTrtA5yCX2RYZ/AAAAIPsYcA/I3hK6oBCUzek9reLy+5+JyjLrQrcgPJfWVGfK/yl0BwAAAFCMeAVgP/rbS2dHsTOwjqbY0s/8etbtg49OWhg6BcHsjRLxaVNXdD0YOgQAAAAoRpwA2I8o1ptDNxScyJMTL96wsPycJ1bzSkBxMvO/Z/gHAAAAwmEB8BLuMpP/deiOQlV22tZ5ky59cJsl44dDtyCbfOXUBWu/GroCAAAAKGa8AvASA+0l8yzWXaE7Cl5/Yu/OHx9/f7y1rC50CsbcHmUyp9Z03P1I6BAAAACgmHEC4CUsFpf/ZUNZZnzFZQ/UjVu45XZJfaFzMHZM/hGGfwAAACA8TgC8gP9KifTk0iclnxa6pZhknip/cPfPjiv3jB0ZugWj7qbqts4lJnnoEAAAAKDYcQLgBdKTk2cz/Gdf4vC+EyuuWlcVVQ7w6kVh2Z329HsZ/gEAAIDcwALgBUzG8f9ArCxzWMX77p83rq73VkmDoXtw6Fz6xIz2ex4L3QEAAADgWbwC8BxfqWQ6U7JF0pTQLcVu4OGKtXt+M2umXJzGyF83V7d1nsPTfwAAACB3cALgOek42SSG/5xQetzOuZWX318SjU+vD92CEdlnsisY/gEAAIDcwgLgOeb2ptAN+AubNDCl4qr1J5actOMWSXHoHhyUz1S3rXkodAQAAACAF+MVAP3f7f8lT0mqDd2Clxv40+TOPf9z5LFyVYVuwSv6Y3Vmwlzr6EiHDgEAAADwYpwAkJSenDxdDP85q/Q12+orLr9/b1SWWRe6BUOK4zh+L8M/AAAAkJtYAEgSx/9zXjRpYEbFh9adWHLMrltCt2D/XPretJVdq0N3AAAAANi/ol8AuMtkflHoDgxD5MmJF29YWN64uUvSvtA5eJHeTCb++9ARAAAAAA6s6O8AGFhRMtcidYbuwMHJpMZt2v2j4wc9HR0XugWSXO+sae/8UegMAAAAAAdW9CcALOL4fz5KVO87uuJD62Ymp/XdFroFuqu6vfPHoSMAAAAADK3oFwASx//zlZXE4w9750Nnjlu45XZJfaF7ilRscXSFSR46BAAAAMDQivoVgP720tlR7NwsXwAyT5U/uPtnx5V7xo4M3VJc/Ps1bWvfHboCAAAAwCsr6hMAkcfnh27A6Egc3ndixZXrJyQmDfBKQPbsiBOlnwodAQAAAGB4inoBILfXh07A6LFx6SmTPnD/grJXb79LUiZ0T6Fz2b9MW3FHT+gOAAAAAMNTtK8A+E2qSSdKNqvYlyAFauDRivv2XDerVq7a0C0F6qHqHfGrratrMHQIAAAAgOEp2uE3E5WcqyL++y90pcfsPKXiyvXJaOJgV+iWQuSmTzL8AwAAAPmlaAfgONLrQjdgbEXlg1Mqrrj/1JKTdtwiKQ7dU0Buq23t/G3oCAAAAAAHpygXAP4rlZrr3NAdyALzxMQLNy2ccP7jXTJtD51TADxy/2joCAAAAAAHrygXAOkpyQWSJoXuQPaUvmZbfcXl9++NyjJ87OOh+eXU9rVrQkcAAAAAOHhFuQCQG8f/i1A0aWDGpA+uPzExc09n6JY8NahM5urQEQAAAABGpjgXANL5oQMQhpXEyUlvfbi+/JwnVsu0K3RPXnH/Vk3H3Y+EzgAAAAAwMkX3MYD7WsuOTyj+c+gOhJdJjdu0+0fHD3o6Oi50Sx7YnSlNHzN9+T2p0CEAAAAARqboTgAklOHpPyRJiep9R1d8aN3M5LS+20K35Dzz/5+9+46zo673P/75zpyyu9lk0wsQCCZAINRslgSS3SQkgA0FlixFUBEQBRRsV6/Xkuu93p/tXjA0ESyXkrIIiHQEktCLqJSEACEB0tv2cvacmfn+/hAfF5SQLeecz8yZ1/NPiGdfKq477/3OzCIu/gEAAIBoi90AIOKcoF2A8DDJoHzwua/Vls/a9qCIdGn3hNSuhNifakcAAAAAGJhY3QJgn5RyryvZJCJl2i0IH39TxZr2Ww6osL7ZV7slTKyYb455+NmfaHcAAAAAGJhYnQDwuhIzhYt/7Ia7d9fkIZesGuYOzv1VuyVEtlk3c7V2BAAAAICBi9UAIOLM1y5AuDkV3uAhF686oqx656MiktPuCYH/N/bBFzu1IwAAAAAMXMwGAHu8dgEiwIgpP2Fj3aCG9a+IkW3aOYo2d/qDrtOOAAAAAJAfsRkA7L0ySkSO1O5AdKQmth5e9eVVCacy97x2iwZj7M/2X7Eio90BAAAAID9iMwD4ydRcidG/X+SHU5EbUXXJ6iOTB7esFJFAu6eINnd4lddqRwAAAADIn/hcEDuW+//RP8a6lSe/OXvQx99+Xow0a+cUgxHz3/z2HwAAACgtsRkAAisnaDcg2lKHNdUMuWB1xqT817VbCmyX9Tt/qR0BAAAAIL9iMQBklqcnGZH9tDsQfe6I7LihX3l5/+TEtpXaLQVj5IrRK1Z1aGcAAAAAyK9YDABOEHD8H/nj2ERlw7rZFSdueEaMtGnn5JfpSGXSV2tXAAAAAMi/WAwAIjJXOwClJz111/Qhn1uzxSTsa9oteWPsDUMffzwWzzkAAAAA4qbkBwBrxRgGABSIOzpzUNVlL41PjO16TLtloKxI1vWc/9buAAAAAFAYJT8AZB9MHSRWRml3oHSZZFA++NzXastmb31CRLq0e/rLiF06YsUzG7U7AAAAABRGyQ8AxrV12g2Ih/Jjt84cfOYbG8WxW7Rb+sUxl2snAAAAACickh8ARKRWOwDxkZjQfuDQy16udIZmn9Zu6RNjHxz9x+f+qp0BAAAAoHBKfgAwYudoNyBeTNofXPWF1dPLqnc+KiI57Z5eCeQK7QQAAAAAhWW0Awqpe3nZhITvr9fuQHxl36h6sfPW/ceIlTHaLbtnXxn18J+mGBGrXQIAAACgcEr6BEDS87n/H6pSE1sPr/ryqoRTmXteu2V3rHUWcfEPAAAAlL6SHgDEcP8/9DkVuRFVl6w+Mnlwy0oRCbR7/sEuf5B/o3YEAAAAgMIr6QHAinACAOFgrFt58puzKz688a9ipE075++Mkd/sddfzkX11IQAAAIDeK9kBwD5YsZeIHKjdAbxb+qidU6suWt3hpP2XtVtExHcluFI7AgAAAEBxlOwA4BvvGO0G4P04Q7J7VV328sTEfh33KafcN/yh599WbgAAAABQJCU7AFjHztRuAHbLseWDz1r7kYoTNzyjdUuAEXOdxtcFAAAAoKNkBwCxMl07AdiT9NRd04ect6bJJILXi/yl3xxZ++y9Rf6aAAAAABSV5ABgGyUlIlO1O4DecEdlJlRd9vI+ibFdjxXti1pzg1kYujcSAAAAACigkhwAcsOTR4hImXYH0FsmGZQPPve12rLZW58QkYI+ld+KZCWwvyrk1wAAAAAQPiU5AIjh+D+iqfzYrTMHn/nGRnHslkJ9DUfMfaNXPLe1UJ8PAAAAIJxKcwDg/n9EWGJC+4FDL3u50hmafbpAX+KGAn0uAAAAgBAryQHAsTJDuwEYCJP2B1d9YfX0suqdj4pILo8fvWWkX3F/Hj8PAAAAQESU3ABgl8tIa2SidgcwYEZM+Qkb6wY1rH9FjGzL00febFas8PLxWQAAAACipeQGAN+6R4uI0e4A8iU1sfXwqi+vSjiVuecH+FFWgoCH/wEAAAAxVXIDgA1c7v9HyXEqciOqLll9ZPLglpUi/X593zOjlv/p1Xx2AQAAAIiOkhsARHgAIEqUsW7lyW/Orvjwxr+Kkba+f4C9Of9RAAAAAKKiBAcAW61dABRS+qidU6u+uLrJpPwXe/uvsSLZdCK5pJBdAAAAAMKtpAYA+8fyfUVkpHYHUGhOVXbC0K+8fEhyYtvK3vx5Y8xDVQ881VToLgAAAADhVVIDgC/+UdoNQNE4NlHZsG52xYkbntnTLQHWWn77DwAAAMRcSQ0AVoQBALGTnrpr+pDz1jSZRPD6bv5Ip3V77ihqFAAAAIDQKakBQCRgAEAsuaMyE6oue3mfxNiux/7pb1q5Z+yDL3YqZAEAAAAIkZIaAKwxDACILZMMygef+1pt2dE7nhOR3N//unVso2IWAAAAgJAw2gH5YpfLSM9P7tDuAMLA31Sxpv2WAyqsb4a2pppHH3Df2h7tJgAAAAC6SuYEgBckDtduAMLC3btr8pCLVle6+3b8hot/AAAAACIlNACIyFTtACBMnMrc8Kqz33hCuwMAAABAOCS0A/LFijmqZO5nAPKjy+3K3qMdASCcZv787v/RbgAAIB+CRPfvnrp4wZPaHVFQMgOAsbwCEHgv+6A5Sbq0KwCEU7pjzle0GwAAyAev8rlpIlKn3REFJXELgH1SykXkAO0OIEyMmN9rNwAAAACFZnIjD9FuiIqSGAByncnJUkKnGYA88Fwvd5d2BAAAAFBojjdu+JyFy7ke7IWSGAAcY6ZoNwAh85j5sDRpRwAAAACFZvwycSX3yQAAIABJREFUkx2282PaHVFQEgOAFTlYuwEIF3u3dgEAAABQLK5TeYp2QxSUxAAgEnDPB/AuvnHv1G4AAAAAisXkqqZrN0RBiQwAhgEA+D+vls3reUM7AgAAACgWxxs9QbshCiI/ANh7JS0iE7U7gBDh+D8AAABixeTGlB13bePe2h1hF/kBIOumDhARV7sDCI3A3qedAAAAABSTESM9XupM7Y6wi/wA4LpyqHYDECJtiaS3UjsCAAAAKDYnGHKidkPYRX4A4A0AwLuZx8xc8bQrAAAAgGIzXhWvh9+DyA8AIpYBAHiHNfYh7QYAAABAg+ONHq3dEHYlMAAIbwAA3mE9wwAAAACAWHK8Ye4x1y2erN0RZpEeAGyjuCIySbsDCIltqROyq7QjAAAAAC1OrvJU7YYwi/QAkKkq21dE0todQBhYKw8aI1a7AwAAANDi+OWztRvCLNIDQMJ4H9JuAELDkeXaCQAAAIAmxx/KLeIfINIDgHXNAdoNQFj4jssAAAAAgFgz3ugx2g1hFukBwARmonYDEAZW5K3yuZk3tTsAAAAATU5uePK4RUu5TtyNSA8AYgIeAAiIiFh5VDsBAAAA0GckK+mTtSvCKtoDgHACABAREYcBAAAAABARMcHgOdoNYRXZAcBaMSLCAACISGAdBgAAAABAREwweIp2Q1hFdgCQP1aME5EK7QxAn91cNr/nNe0KAAAAIAwcb8Q47YawiuwA4JksrwAE/uYp7QAAAAAgLIw3smzOb35Tpt0RRpEdAKzDKwCBdzAAAAAAAO8wNiG5zorjtDvCKLIDAK8ABN5h5RntBAAAACBMjDAAvJ/IDgDW2P20G4AQ8BKB9xftCAAAACBMjFdZrd0QRpEdAIzIvtoNQAi8aE6UTu0IAAAAIEycoHKSdkMYRXkAGK/dAGgzhuP/AAAAwD8y3vBR2g1hFMkBwC4Ux4rspd0BaAtEntNuAAAAAMLGyY1Mz7m6sVK7I2wiOQDIbBktImntDECbNeZZ7QYAAAAgfFzJemaedkXYRHIAyPlJjv8DIl2pndk12hEAAABAGLlu+RzthrCJ5ADgWMMAAIi8bBrE144AAAAAQsmvOEo7IWwiOQAExjIAIPaMCK//AwAAAHbD+IP3124Im0gOALwBABAJGAAAAACA3TLe4JHaDWETyQHAGgYAQAwDAAAAALA7TjCyXLshbCI5ABgr+2g3AMr8ZFfuZe0IAAAAIKyMX2ZqF918iHZHmERyALDcAoCYM1bWm5OkS7sDAAAACLMgUVGn3RAmkRsA7EJxjMg47Q5AkzWW3/4DAAAAe2By6WnaDWESuQFAZskwEUloZwC6nNXaBQAAAEDYGTvoYO2GMIncAJC1qdHaDYA2I8IAAAAAAOyBEwzaV7shTCI3ADgSjNFuALQF1jIAAAAAAHtg/KEjtBvCJHIDgDEOAwDiLkgOyq3RjgAAAADCzvgjysQujNx1b6FE7j+IwNhR2g2AJiPyljlWurU7AAAAgLAzfsrUXjlpsnZHWERuADBiOAGAWLNiXtNuAAAAAKLCJMpqtBvCIoIDgGUAQKwZsWu1GwAAAICosEFyinZDWERuALABAwDiLbDyhnYDAAAAEBXGL5uk3RAWkRsAxBheA4hYcxyHEwAAAABAbwUV47UTwiJyA4AR4QQAYs23lhMAAAAAQC8ZWzZWuyEsIjcAWBHeAoA4s6mK7HrtCAAAACAqTDBoqHZDWERqALCNkhKRSu0OQI/dzCsAAQAAgN4z3tBy7YawiNQAIMNlmHYCoMu8pV0AAAAARIo/2K2+7q4K7YwwiNQA0OOkObqBWLMiG7QbAAAAgCgxYqTc656q3REGkRoAHAkYABBrxhoGAAAAAKCPTOAepd0QBpEaAIxvGQAQa9ZYBgAAAACgj4ykJmo3hEG0BgDjMAAg1hzDCQAAAACgrwI/OV67IQwiNQAEwgkAxFvgcwIAAAAA6Csj6dHaDWEQqQHAiK3SbgA0JYPcJu0GAAAAIGqMTY/QbgiDSA0AItwCgFjzpU22a0cAAAAAkRPwRjmRiA0AxnALAGJtl2kQXzsCAAAAiBpjyyu1G8IgUgNAEAgDAOJsm3YAAAAAEEXGryjTbgiDSA0ARgzPAEB8GY7/AwAAAP1hbGVCuyEMIjUAiLEc20BsWStbtRsAAACAKDJ+mZlz+R2xP1EerQFApEI7ANBiOAEAAAAA9FuuMpis3aAtagNAuXYAoCawDAAAAABAP9mcM0m7QVukBgDDCQDEmDWmWbsBAAAAiCrXl720G7RFagCwDACIMUdMi3YDAAAAEFnGGamdoC1SA4AwACDGrA0YAAAAAIB+SwzTLtAWtQGAZwAgtqyYVu0GAAAAILKCBG8B0A7oLdsoKRHh3Y2ILRtwCwAAAADQbzbJAKAd0GvD+O0/4i2VyjIAAAAAAP1kxK3UbtAWnQHA5/5/xFxauAUAAAAA6C+bYADQDuitnmSaAQBx5ptjpVs7AgAAAIisIDFIO0FbZAYA41luAUCccfEPAAAADICxydhfU0ZnAHBsUrsBUNSlHQAAAABEmk2ltRO0RWYAECuudgKgxXICAAAAABgQYxMp7QZt0RkAEgwAiC/DCQAAAABgYKwb+2vKyAwAxrMJ7QZAEQMAAAAAMBDGNdoJ2iIzAIjLCQDEGrcAAAAAAAMRONG5/i2Q6PwHwDMAEG857QAAAAAgyox1OAGgHdAHDACIM187AAAAAIg0bgGI0ADACQDEmmEAAAAAAAbCMgBEZgAwrmUAQHxZTgAAAAAAA8ItANEZAMQmGAAQXyZgAAAAAAAGwvBiuQgNAJwAQKwxAAAAAAAD4RtOAGgH9BrPAEC8MQAAAAAAA8IJgOgMAEZiv9Yg1qx2AAAAAIBoi84AIOJpBwCKmCsBAACAATAm0E5QF50BwPAaNMQat8AAAAAAA2AtA0CEBgCPAQDxZR0GAAAAAGAgOAEQnQHA+pwAQIwZTgAAAAAAA2J4rlZkBgAxPAUdccZrMAEAAIAB4QRAhAYAXoOGeGMAAAAAAAaEASA6AwAnABBvSe0AAAAAINostwBoB/QBrwFEnFVoBwAAAABRxu+UIzQAWF4DiDgzDAAAAADAQFhOAERnABCPuQbxZa2UazcAAAAAkWYYAKIzAHBeAzFmOAEAAAAADIiVgAFAO6C3bGBy2g2AGk4AAAAAAANieQ1ghAYA1+nSbgAUcQIAAAAAGADHcgtAZAaAtJfp1m4AFDn2SU4BAAAAAP1lTRD728ojMwCIK5wAQLy1yVDtBAAAACCyTI4BQDug14YxACDesm6KAQAAAADoJ+v4nnaDtsgMAGaa5EQk9v+FIb4cEzAAAAAAAP3mxf7B8pEZAN7BKQDEljGWAQAAAADoJ+v4DADaAX1jGAAQYy4DAAAAANBPxvpZ7QZtkRoAjFjeBIDYCgJOAAAAAAD9FQgDQKQGAMstAIgxY+ww7QYAAAAgqowJerQbtEVqABAGAMSaGa1dAAAAAESW8TLaCdqiNQAYBgDElxUZo90AAAAARJYJGAC0A/okMJ3aCYAWI8IJAAAAAKDfGAAiNQBYx7ZoNwCKOAEAAAAA9JOVIPYnyiM1ADhWGAAQZwwAAAAAQD9Zx4v9W+UiNQBYMQwAiLPhdrkktCMAAACASAqC2N9SHqkBQCRo1S4AFDnSI6O0IwAAAIAoMq7XpN2gLVIDACcAEHe5ZHK8dgMAAAAQSTbYqZ2gLVIDgGMZABBvjjX7ajcAAAAAUWRcf5t2g7ZIDQDWCRgAEGuBtZwAAAAAAPrDelu0E7RFawDgFgDEnHGEAQAAAADoB2uCrdoN2iI1AATWYQBAvHECAAAAAOgXL5XYqN2gLVIDQNrvYQBAvFnDAAAAAAD0mS9Pnd/AWwC0A/qkVRgAEG+GhwACAAAAfWXdjNVuCINIDQCmQbIi0qHdAeixY+0DMki7AgAAAIgSazKedkMYRGoAEBExIrF/dQNizeSSyUnaEQAAAECkOFkGAIngAGBFtms3AJoc30zUbgAAAAAixfT0aCeEQeQGABHLCQDEmjUBJwAAAACAPrAmxwAgERwAjBhOACDWjHACAAAAAOgLa7Jd2g1hELkBwIrhBABizRphAAAAAAD6wsm1ayeEQfQGAGM5AYBYs1a4BQAAAADoC5PbpZ0QBpEbABxOACDmjMi+9l4Zot0BAAAARIU1PfwiWSI4AFgJGAAQdyZXljxYOwIAAACIDMfbop0QBpEbAALPYbkBrByinQAAAABEhvHe1k4Ig8gNAKmKLCcAEHvGGk4AAAAAAL0USO4t7YYwiNwAILOkRUSy2hmAKitTtBMAAACAqHBMbq12QxhEbgAwRqwV4RQAYs0YO1m7AQAAAIgGK13uYAYAieAAICJiRDZoNwCarMgEu1wqtTsAAACAsLNuxj5/4Uld2h1hEMkBwIrwAAfEneP5iaO0IwAAAICws6bT024Ii0gOAEYMJwAQe9aaI7UbAAAAgLCzTldGuyEsIjkAWGsZABB7jhEGAAAAAGBPnB6O/78jkgOAYzgBAFgRbgEAAAAA9sA6Pa3aDWERyQEgcDgBAIjIFNsoKe0IAAAAIMysyTZrN4RFJAeAZC7HAACIpHIjkwdrRwAAAABhZkz3Zu2GsIjkACBPyU4R6dHOANRZmaqdAAAAAIRZ4GbXaTeERSQHALNQAiOySbsD0OaIHKPdAAAAAISZcYNXtRvCIpIDgIiINcJtAIg9a2W6dgMAAAAQZl6QXaXdEBbRHQAsAwAgIofYB2SQdgQAAAAQTlbSYl/UrgiLyA4ARsx67QYgBBKek6jRjgAAAADCyLqdwYqLGzq0O8IiwgOAfUO7AQgFh9sAAAAAgPcTOG08PP5dIjsAWMsAAIiIiBVOAAAAAADvx+1s104Ik8gOAImEt1a7AQgFY+qsFaOdAQAAAISNdbp3aTeESWQHADNXtooIaw5gZVT24dTB2hkAAABA2FjTs027IUwiOwC8Y512ABAGxtg67QYAAAAgbKzT87Z2Q5hEfACw3AYAiIgEwgAAAAAA/ANjerhmfJeIDwAODwIERMQYM0e7AQAAAAgb62bXaDeESaQHAMurAIF32HGZ5elJ2hUAAABAmKSMfVK7IUwiPQCYgAEA+DsnCGq1GwAAAICwsE6XfeSLDZu0O8Ik0gNAwk1wPwfwd1ZO1E4AAAAAwiJwW7q1G8Im0gOA7MpsFJEe7QwgDIzIXGvFaHcAAAAAoZBob9ZOCJtIDwCmQXwReU27AwiJ0blHkkdpRwAAAABhYE3XFu2GsIn0ACAiYkVWazcAYWHEHq/dAAAAAISC27lOOyFsIj8AGGNf0W4AwsMwAAAAAAAiErg9/LL4H0R/ABCH/1KBv7My094lFdoZAAAAgDZXcn/WbgibyA8AviecAAD+T5lXnqjTjgAAAAB0Wcmmgye0K8Im8gNAakT2VRHJaXcAYWHEnKTdAAAAAGiybkfw1PkNTdodYRP5AcBMk5yIrNXuAMIiEGEAAAAAQKzZRHOXdkMYRX4A+BvLcwCAdxiR8T1/TB2m3QEAAABoCZxOfvv/PkpkAOBBgMC7OSb4uHYDAAAAoMbp3KydEEYlMQAYw4MAgfew5mPaCQAAAICWwHSu0m4Io5IYAILArtFuAELFyHR7vwzXzgAAAAA0mJT3jHZDGJXEAJAclFsjIp52BxAiCT+R5GGAAAAAiKVkrvsR7YYwKokBwBwr3WKEUwDAu1gxC7QbAAAAgKJzO4NHvnzGG9oZYVQSA4CIiA3kL9oNQLjY+faPUqVdAQAAABSTn2jq0G4Iq5IZAEQYAIB/kG6zgz6hHQEAAAAUk3Vbt2k3hFXJDADGsS9oNwBhEYiR6zon93yqpe487RYAAACgqNzOtdoJYVUyA0DC8f4sIla7A9DWFqTkS63HNP+2+8D01qCi5vAbzxmk3QQAAAAUS2C6+OXwbpTMAGDmSosReVO7A9C03hssZ7bO3fXn3Mhh7/ylilSy8yOqUQAAAEAROdL9lHZDWJXMACAiYo3lOQCIrcXdEzNnt8zNNfnpEe/5G8acrZQEAAAAFJfxxXGEVwDuRkkNAGLlr9oJQLF124R8q72m+crOKWWBSPJ9/shHjr79lBHv89cBAACAkhIkWnIrLm7gLQC7UVIDgBFOACBe3vQHyxnNx7Ws7Bk37AP+WMrmnFOLFgUAAAAosW5Ti3ZDmJXUAOCaFAMAYuPR7LieT7fUdW4Pyobu6c9aKw3FaAIAAAA0Wbd9g3ZDmJXUAGDmdW8SkZ3aHUAh5cSRH7RP7fhmW006Z93ePuH/uOk3n7pPQcMAAAAAZYFp55fCH6CkBgAREbHmWe0EoFB2BWXyuZa6Hff17FPZx3+p47tmQUGiAAAAgLBIZVZqJ4RZQjsg70zwjIj5qHYGkG9/yY3wvtY2vavbJkb16wOMfFZELs9rFIDIeuTfKo12A4DCq73qnuuTrbPP1+4AisGKlYTTc592R5iV3gkAI09rJwD5FIiRn3dO6biodabbbRNDBvBRh09rXHB03sIAAEDoOblhtdoNQNEkd2ZXXHgWt4R/gJIbABKO96yIBNodQD40BWn5XEtd09LuiZUiMvDf1vnBuQOvAgAAUWG8sRO0G4BiCRK7tms3hF3JDQBmrrSIkde0O4CBeik3PGhomdf6qlc1PG8fauTM6rtOqsjb5wEAgNA6btHSiU52VFq7AygW67a/rt0QdiU3AIiIGMttAIi2X3ce1HFh6yzbGSSq8vzRVaYr9ck8fyYAAAihrCk/Jx8HCIHIMJ08EH4PSnIACIw8o90A9EdGXPnX1pod13cfVGlF3MJ8FfPpwnwuAAAIE+MPna/dABST7zQ/rN0QdiU5AEjAAIDoecMfIqc2zW9akRvXv6f895a1J06/pf6Agn4NAACgzvVGTNFuAIrFulmb3LnPcu2OsCvJASCZyL0kIp3aHUBv/T6zX9c5zbNzzUE6f/f7754JEnJeEb4OAABQMufqxkonu9dQ7Q6gWKy7rWvFwrmedkfYleQAYOaKJyJ/1u4A9qTHuvKv7TXNP+44osKKSRbr61prz5t070d4KBAAACUqME692JR2BlA0vtuySbshCkpyAPgbw4MAEWrb/TL5dMvsbSt6xg0r/lc3I4e1V/AwQAAASlSQrfyEdgNQVE7bau2EKCjZAcBYngOA8HomO8o7vWVex9t+5RitBmvlC1pfGwAAFJbjj6zRbgCKyaa7uf+/F0p2AHAT2ZUiYrU7gHfzrCM/6jii5bK2Y9yMdSuVc+ZOW3rKocoNAAAgzxY0Nqbc7L77aHcAxRNILtG1TLsiCkp2ADBzZaeIvKLdAfxdS5CWz7fO2npnZr+hEpqX8rqf1y4AAAD5tWVH6gwTVITkZw2g8PzkjuwzF5y1TbsjCkp2ABARMVYe1W4ARESezY3yTmme3/GKN3Ssdst72fOOaVxQjDcPAACAIjHekE9rNwDFZBM7N2o3REVJDwAi5jHtAsRbIEau6Ty4/dLWY5wQHPl/PxWebz+nHQEAAPLHyY2Zpt0AFJXb8oJ2QlSU9ADgOu5K7QbEV1uQki+2Hrvjpu4DBkuI/7dmjb1kzvI5Ce0OAAAwcMdd27i3m92nSrsDKCY/2fmgdkNUhPaiJB/MvO5NRmSddgfiZ7U3LKhvntfyYm7EKO2WXtivY/sIXgkIAEAJyHplXxTramcAxWN8SbqZ32lnREVJDwDv4DkAKKpbuie1X9Bc63fY5FDtlt4yVi7VbgAAAAPn+MNP0m4AiilI7MysuPCsndodUVHyA0BghecAoCiy1pXvtldvu6rzkMGBkaR2T19YkdqaxgVHancAAICBcXv2nqzdABSTn9y+SbshSkp/AEg4nABAwa33BttTWubveqhn7zHaLf0V+MG/ajcAAID+q7vqtjrjjUppdwDFZNy2P2s3REnJDwBlc3vWitjN2h0oXQ/27N15TsucTJOfHqHdMhDGSP30W+oP0O4AAAD9Y/3KC7QbgGKzycwftRuipOQHABERa8zj2g0oPb4Yubzj0Kbvt1dX+GLKtXvywPVd+bJ2BAAA6B/HGzlfuwEorkBcp/MO7YooicUAIFZ4LQTyaldQJue0zNnSmPnQcBEx2j159LnqxWeO1I4AAAB9M/36xWPcnv3HancAxRQkt/EAwD6KxQCQtAmOhSBvnsyO6Tm1eV77em/wOO2WAqgwTvYy7QgAANA3qe4h3xHL7f+IlyC1fa12Q9TEYgAwx3e/LSKvaXcg2qyI3NB54K6vt01PZK07WLunYKx8YUrjgkrtDAAA0HuOt9fJ2g1AsVnTxK3efRSLAUBExIhwCgD91hSk5bMtc7b/qnvyCCviavcUlJER5UFwqXYGAADonWOvvX20k9lvH+0OoNhsovsW7Yaoic0AINYwAKBfXvSG5xa0zGt5zRsyWruliL46885PlO4pBwAASojru183Nq2dARSVTbT6j1/cwAmAPorNAOCWZx8RkZx2B6LDisgNXQc1f6FlltMVJIZq9xTZ8GwmcYl2BAAA2DMnO26BdgNQbEFyyxbthiiKzQBgZkm7iDyn3YFoaLdJuaT12O2/6jpoWMkf+d8NG5ivcQoAAIBwm3P5HUOdnon7aXcAxRa4zc9rN0RRbAYAEeE2APTKWm9IcFrTvJ1/zo2M05H/f2ZkRKY7ebF2BgAA2D0/mfyKCdKl9EpioFes2/4H7YYoitcAIMFD2gUItwd69mn9TMvsTJtNjdRuCQMj5rLDbzxnkHYHAAB4fyY38kztBqDYrOmR5tFbGrU7oihWA0Ai4T0tIm3aHQgfzzryg/ajtixsn1oViKnQ7gkPOyaV6rpMuwIAAPyz6TffPMTp2X+SdgdQbH5qW9uqhos7tDuiKFYDgJkrnoh5TLsD4bLJr5CGlnk77+sZP067JaS+dfiNp8T7dggAAEIo1TT0h44/iOP/iJ/E9tXaCVEVqwFARMQae7d2A8Lj4exenae3HNe1xS/nyP/uVaZSzje1IwAAwHs52f04/o9YChKt3NrdT7EbAJJe4h752xveEGOBGLmy85Bt32mbVu5bhyP/e/aFo5Z8Yi/tCAAA8Dezrmmsdnv2G6HdARSfFT/ZeYt2RVTFbgAwJ3ZvEJGXtDugZ2dQJp9qmbtlcfekMRLD/w30U0XCJP5dOwIAAPyNyY38MT/GII6C5NbMUxeetUa7I6pi+l3DcBtATL3oDc80NM9retOr5H7/PrJiPjO1cQEPGgIAQJu1xs1MrNPOADT4ya2vajdEWTwHABPco52A4grEyNUdhzRd2Dwr1W3d4do9EZV0guBn2hEAAMTdrKvvuMjxRiS1OwANQaLlXu2GKIvlAJDY5T0jIju1O1AcbUFKPt8yc8vNmUnDxcTzn/k8+mTNktPmaUcAABBnTm7cpdoNgI5ArGm7TrsiymJ5MWQaxLci92t3oPBe9oblTmme37TKG86R/zyxxv5MFi6M5fcOAAC01d500zi3+4ADtDsADX5ya9eTl3zqLe2OKIvtD/GOGG4DKHG/795v54UttX6XTXDkP7+OrDnoxQXaEQAAxJFtHf59Y8u0MwAVNrWVh/8NUGwHADedfUBEPO0O5F+3TchX26Zv/nHnESMDEf4fsgCsY35WfddJvD4RAIAic7sOOEe7AdASuM13aTdEXWwHAFMrzWLkCe0O5Ndmv8I/vfm4TU9lx/DO+kKyso/pSl6inQEAQJzUXf2H89zcXgzwiCfjS65s+w3aGVEX2wHgb+x92gXInwd79u5saJ6X3RGU7a3dEgvWLJyx5OQJ2hkAAMRGdq/vaScAWoLk5s5nLrhgo3ZH1MV6APB993btBgxcThz5bvu0bd9vrx7kiynX7omRct+4P9GOAAAgDo69emlNovuAfbU7AC1BavtL2g2lINYDQNkJPa+LCP8gRdjWoNwuaJq39aGevcZot8SRFVkwdVn9idodAACUOjc39gqxrnYGoMZ3W7n/Pw9iPQCIiIixt2knoH/+5I3qOL3puJZtQflY7ZY4c6z8dM7yOQntDgAAStX0m28ekshMnqHdAejxxalq/Y12RSmI/QAQBA63AUSMFZFfdE7e8uXmY8qz4g7T7oEc1r51xEXaEQAAlKp0y6jLjV8Z+5/bEV9++u2Wx845Z4t2RymI/TeS9PHZl0TkVe0O9E5TkJazm+du/t/uA8dZI5yDCwlj5D9rlnxyvHYHAAAlxy50nK5JZ2lnAJpsavtT2g2lIvYDgIiIGHOHdgL27AVvRKa+ZX7TOn8wr/gLn8HWJBZpRwAAUGpqrzziy05uTJl2B6DJd1v+V7uhVDAAiIj1eQ5A2C3t/tCWL7QeazKBO1y7Bbt18rSlp31EOwIAgFJi/H2/od0AaLJue/DERS/dqt1RKhgARCR1Qu5PRmS9dgf+WbtNyudbZ236eeeh48SatHYP9sReN6VxQaV2BQAApeDYa+44O9F1ECcfEWte8s31YhYG2h2lggHgHdbI77Ub8F6v+0Ny9c3zt7+UG763dgt6bXx5EPy7dgQAAKUgmdn3R9oNgLrkrvu0E0oJA8DfcRtAqNzXM37HZ5tn59qD5GjtFvTZl6obFxymHQEAQJTNuvYPH3e7D+SXIIg1K1aCxLartDtKCQPAOxIt3tMisk27I+4y4so32o/e9oP2o0YFYiq0e9AvSRMEN1df9/mkdggAAFHldo+9UsRoZwCqbGpj5xMXnccb2/KIAeAdpkF8EVmm3RFnm/wK/7SmeZsf7xk7RrsFA3a4DN35Te0IAACiaNbVjR92uydP0O4AtAWprX/Wbig1DADvYq0s0W6Iqwcye7ec3nJcz66gjAfdlAhjzXenLT3lUO0OAACixsnueyU/pgMifrJ5sXZDqeE7y7ukjs89LSKva3fEiWcd+UH7UVsWdlRX+dbhyH9pSYk1v1rQuMDVDgEAICrqrrqtLtHQDw3RAAAgAElEQVR18CTtDkBb4HbavUZ6v9buKDUMAP/ImkbthLhoCdL2My2z19/XM36ccJNbaTLm6HV+cLF2BgAAkZEbe5UI2zlgUxs339rQkNXuKDUMAP8gELlFuyEOXvBGdJzSPH/XOn/w/totKCxj5L+mNi7gNxkAAOzBrGsaqxPdh/AmHUBE/NTWu7UbShEDwD9IH599RURe0O4oVYEYWdQxZdsXWmaWZ6w7UrsHRTHICYJlvBUAAIAP5mT2axTL/10C1njimLYfaneUIgaA92MsDwMsgDabkvNaat9ekpk4RjjbFjdTpWrXd7QjAAAIq2OvueNst/uQD2l3AGEQpDc0PXrxmRu0O0oRA8D7SHjJxSJitTtKyUve8MwpTfN3rfGG7qvdAh1G5NtTl546Q7sDAIAwSnYfcKXhkUiAiIgEyc2PaDeUKgaA92FO7N4gIk9od5SKG7sP2HphyyynyyZGaLdAVcIRc/OUxgWV2iEAAIRJ7ZV3ftfNTBiq3QGEg5WgvOO/tStKFQPAblgRbgMYoKx15RttR6+7tvPgsVYkpd2DUJhYFgT/qR0BAEBYTFm4KuV2H/5t7Q4gLPzUlu4nLqh/WrujVDEA7EZScreJiKfdEVXrvMHByc3zdzyeHcu9bHgPI3Jp9bL6k7U7AAAIg+Ej3v6lkxtVpt0BhEWQ3PSMdkMpYwDYDTNftom192p3RNHdmX13nNM6J9McpEdptyCcHCu/rm5cwPMgAACxduy1t49OdB5xtnYHECZBsukX2g2ljAHgAxjj/Ea7IUpy4si/th+94YcdR44KrKnQ7kF4WZFhThDcvKBxAW+DAADEltszdInxh/D/hcA7gsQu74mL65dpd5QyBoAP4LrZu0XMVu2OKNgVlPlnNM9dt6Jn7HjtFkSDFaldb/2vaXcAAKCh9prFhye6D5+r3QGESZDa+Ip2Q6ljAPgAZq54YiwPA9yDZ7Ojm05pnt+62R/E/f7oG2v+c1rjgqO1MwAAKDYnM+lOE5Tx3j/gXYLkjlu0G0odA8AeBJ75tXZDWFkRuarjkLcubZsxJGed4do9iKSkBMHSw245a5h2CAAAxVK76P5vu92HTNDuAMLEuh1BYlDzz7U7Sh2rYy/kHko+LyJTtTvCZFdQZi9uOXbDW0ElD3JDPjy8v+OceGvDrb52CAAAhXTstbePTrfVbDLesIR2CxAmXvmLqx/96rFTtDtKHScAesEa4WGA7/LX3IiOU5vnNXHxjzyat97639GOAACg0NyeYbdx8Q/8Mz+5nWuuImAA6IVkLrdYRHq0O7RZEflF5+QtF7XMLM9ad4R2D0qMNd+rWXzKh7UzAAAolNprGj+W6DpqlnYHEDbW7Qj2GpNdpN0RBwwAvWA+LE0i8gftDk3tNimfa6lb97/dB46zRnhdDQrBsY5zy4wlJ0/QDgEAIO/sQsfpmnKLsfzyH/hHfmrtmlsbGrLaHXHAANBLxgl+q92g5U1/cPdpzfM3rvGG8pR/FNpwT5ybqq/7fFI7BACAfJp15YxFbs9+VdodQBj5ia2/1W6ICwaAXnKN/6CI2aLdUWz39Yzf8anmObYtSO6j3YKYMGaWVO28QjsDAIB8qbt6yfhU12Ff1O4AQsntCJKD26/UzogLBoBeMnPFEyu/1O4oloy4cmnbMW/+oP2oUYGYCu0exIsRc1H10np+UAIAlIaeD60Qv4qfu4H34affeGXFuedmtDvigm9EfZBIuDeIiKfdUWgbgorcqbvmb3g2O2qCdgviy4j8vKZxwWztDgAABmLWVXf9LNE9hdsogd0IUjt+pd0QJwwAfWDmdm8UsXdrdxTS/Zl9dpzRNC/bbNPjtVsQe0kb2GXTbz6V208AAJE059obD011HP0V7Q4gtNzWwN1RxfH/ImIA6Csrv9BOKIRAjPy08/C1/94xdUQgZpB2D/A3doyfMEsn3fuRtHYJAAB9FXQe9oD4g/h5G9gNv2z9KysWzi35E9ZhwjekPkrM9x4Ukde1O/Kpxab9M1vmvX5794RJwj8TCJ+ZQ9sqrhcrRjsEAIDeqr3y7kWJngP20u4Awixwdtyg3RA3XOz1kTFixdiSuU/lqeyYpk80Hd/+tldxgHYL8AHOqWk89d+1IwAA6I2Z1982I9Ex4xLtDiDMgsSu3GNfemGRdkfcMAD0Q8LxfiUikX5SZSBGLu84bMNX26ZX5awzVLsH2BNrzXemLTn1HO0OAAA+kF3oJNoOvMcEZZxcAz6An173jJiFgXZH3DAA9IOZKzutkdu1O/qrzabsZ1rmvNGY2X+8iLjaPUAvGTHmhmlLTpujHQIAwO7UXjljsZvZf7h2BxBuVpzElh9oV8QRy2Q/5R5O1Ik1K7U7+up1r6rtwtaZHd02wT1piKqtvm9n/OVTt7+lHQIAwLvVXb30BLft+PtNkOZnbOAD+MmNXSv/ZTIPHlfACYB+Ss7zHhUjL2t39MWvuw58+zMts8u4+EfEjXVd8/DhN54yWjsEAIC/q73ppnFux4y7uPgH9syWvXWPdkNcMQAMgA3kl9oNvdFtE3JJ6zFvXt81eV8rktLuAfJgYirl3H34jeewHAMAQsHsmPy08UbycxawR77k0ru+p10RVwwAA5DM5H4lIk3aHR9knT+k+xPNx295PjdqgnYLkGc1yVTX0gWNC3iOBQBAVe2i+29MdB+8r3YHEAV+2bptT1141hrtjrhiABgAc5J0iTW/1u7Ynbt79tt4TvNs2xEkx2m3AIVgRD6+PvCv1u4AAMTXrKt/d2ayYzpvqQF6yUtsWqzdEGcMAAOUcJyrRMTT7ng3X4ws7Ji65oftR+wdiKnQ7gEKy1xYs7T+Uu0KAED81F53/7hkR81vxSa1U4BIsG63NcnW/9DuiDMGgAEy8zJvidg7tTv+blNQkftk0/FvPZDZZ7LwlgfEhBW5vGZZ/QXaHQCAeHE6RzxrvBHc9w/0UpB+/bXHL/pUs3ZHnDEA5MfPtQNERJ7Jjd5yRvNxbbuCsv20W4AiM9bKNTXL6k/SDgEAxEPtovtvdLsP3ke7A4gSv2z7NdoNcccAkAfJ+d5jIvKc1te3IvLzjimvXdY6Y7RnnRFaHYCyhLXSWNO4YLZ2CACgtM266vbPcd8/0Dc2sTP7+Bf+epV2R9wxAOSJsaLyD3NTUOaf1jxv3dLMxANFhKehI+7KbBDcW924YJZ2CACgNB3ziyXzkh0zb+C+f6Bv/PRr94tZGGh3xB0DQJ64zbmlImZrMb/my97wXac2z9u+2R/0oWJ+XSDkKkwQ3D69ccEh2iEAgNJyzP/ctXe6bcbdxh/Ec5aAPrAmJ075+m9qd4ABIG9Mg2TFBL8oxteyInJ15yFvXtAyq6rHurziD/hno/zAX1nduOAw7RAAQGmY85vflKXtvn91cqPKtFuAqPHTb2xYceGFa7Q7wACQVwk/db2IZAv5NdptUs5vqVt/c/ekCSKSKOTXAqLNjDRB8HDN4vop2iUAgOgLWg940slMHKndAUSRTW3g3v+QYADII3NC12Yj8ttCff5ruaq2TzYdv3m1N3T/Qn0NoMSMElce4XYAAMBAzFp0/+JE55FHaXcAURQkduYeu+SFn2l34G8YAPLME/fHIuLn+3OXdE9c/5m2unS3TeyV788GSpm1MtoP7CNTl55ysHYLACB6Zl75+6+n2o85U7sDiKqg7I0VPPwvPBgA8qxsfmadiL0jX5+XE0e+0Tb9hUWdU/YXa9L5+lwgXuwYI869M5acPEG7BAAQHbXX3D473Tnjx7xoCeivQLzEjn/TrsD/4QmmBZB9MDnNOPLcQD/n7aCy+/MtM7e3Bun98tEFwGwzgZ333Fm3rdIuAQCE28zrb5uRbDr6cccbxtU/0E9+2atbV36tmoeWhwgnAAogdULuT2Lk4YF8xr094zec2TzX5+IfyCc7Rlx5ZNrSUw7VLgEAhFfdL245INl85Aou/oGB8VMbr9NuwHsxABSKtT/uz78sECP/1XHEqv9oP2rvwJrKfGcBcWetjBZxH6heXD9ZuwUAED7H3NA43Ok46jknN4ZbL4EBsIlWP1HZ9CPtDrwXtwAUUO6h5J9EpLq3f77FprOfa657Y0tQzsPKgMLb6jrOvGcabl2tHQIACIc5Vy+vtJnR693MfrzuDxigbOXTf3z80vknaHfgvTgBUEBGzE97+2efyI7ZetKu4zu5+AeKZqwfBE9MW3bqTO0QAIC+BY2NqSAz5DUu/oE8MDkRd+cl2hn4ZwwABeQ2ZX9nrKz9oD8TiJGfdhy+9utt00d54gwrVhsAEREZKtY8WLP4lA9rhwAAFNmFztYN41cnMgfxsDIgD3LpNW88fskZr2l34J8xABSQaRA/EFm0u7/faZP2/Ja6NbdnJkwS3i8DaKmwjnNHzbL6k7RDAAA66hbNfiiZOWyidgdQKoL0Zu79DymeAVBg9l5Je6nEGyJm73f/9b96I3Zd2nqMn7XOaK02AO/hGyNffO70267XDgEAFE/tzx9Zkew4erZ2B1AqgvTbHSu+fshg7Q68P04AFJj5qPRYMT95919b1v2h1y9qmVnBxT8QKq618ovqJfVf1g4BABRH7eVPcPEP5JmXXrdYuwG7xwmAIrDLpczzE2902+TYL7Ues2qVN+ww7SYAu2fE3jBoTNMXV8xd4Wm3AAAKo/aKR59Odk6drt0BlBLrtAV2yONVKy5u6NBuwfvjBEARmLmSecUfduUpTfPf5uIfCD8r5vyObcNvmnTvR3gHNACUoNornniMi38g/7zyNU9x8R9uDABF8uXNH7ui1aZT2h0AesucMbStYuVRjQtGaZcAAPKn7oqVzyY7j5il3QGUHl+89LYvaVfggzEAFMmKc3+bsWKv1O4A0CfT3SB4pGbJJ8drhwAABq7u8ieeTHRW12h3AKXIL39901NfPPMv2h34YAwARVRWnrtarOzS7gDQJ4daJ/HM1MYF1dohAID+q71i+WOJriOO0e4ASpVfvvEne/5T0MZDAIts2rJT/0Ws+bF2B4A+6zFGzn/u9Ntu1g4BAPRe9XV3VQzqGvVCouvQSdotQKnyU2+3r/zGIUO0O7BnnAAosmzPoKtFZId2B4A+S1srN05bctpCsYynABAFtTfdNK6ybd+3ufgHCssvf+OX2g3oHQaAInvx0zd1GmMv1+4A0C9GjP3+tGX1S+b85rNl2jEAgN2rXXTzIe7Wmtfd7MQR2i1AKQsSO3PjRnd/W7sDvcMAoCAw7jU8CwCItNM7KzruqV585kjtEADAP6u74s66RHftX5zsPoO0W4BS55W/ctetDQ1Z7Q70DgOAgucbbm0VkR9qdwDoP2vtccbJvXB04wIeKAUAIXLsNXec7XbXLDfeCF6/DBSYdTttIt18oXYHeo8BQEllZvC1IvK2dgeAgbB7BUGwvGZp/ee1SwAAIrVX3vnddNvsG00whJ9xgSLwylY/ueLCs3Zqd6D3+OaoZMW5v81YI/9PuwPAgKWtyHXVS+uvmLN8TkI7BgDiqu7Ku65ItNX9wPgpHtQKFIE1ntjUjku1O9A3fINUVH3d55OmatcrIjJRuwVAHli70rjuGc813LpVOwUA4mLKwlWpkUO6nnK7D56q3QLEiVf+wtpHvzrzAO0O9A0nABQ9f+Evc8baf9PuAJAnxsy2gf/S1GX1J2qnAEAcHHvVLfuNGuxt4uIfKC4rVoL0pi9pd6DvGACUPffq4beKyEvaHQDyxYx0rNw9bWn9N8RyygoACqXuqtvqUl3T1ziZibyRBSiyILVu1+MXN9yv3YG+YwDQtnBhIEa+pZ0BIK8SIvKTmsbTHpq++BNjtGMAoNTMuurO/3Db56xwcmPLtFuAOPLK13L9ElH8diokapbWP2VFZmh3AMi7tYHjnPHnhluf1w4BgFJQe8WKO5KdU0/m91iADr9sXcvKrx0+TLsD/cN3zpDwg4BnAQClaZITBE9WL63/KrcEAED/VV93V0Xd/zy+Ktk5jYt/QJGfXvcj7Qb0Hz+MhkjN0vr7rQgPDwNK172+43z2Lw237tAOAYAoqVt07wlOZvLvndzocu0WIM789FvtK78+ZYh2B/qP+TREgkAuExFPuwNAwXzUDfzVU5ee9nHtEACIitor77nW7ZpxPxf/gD5btvYn2g0YGE4AhMy0pfU3iMh52h0ACiowRn7aZZzvrWq4NasdAwBhNOdnd40MzNgnEpmDD9RuASDiJzd0rfzGwZVixGq3oP84ARAy2WzwbRFp0+4AUFCOtfLN8iD469FL6qdpxwBA2My8+rbTTXDoJi7+gfDwy1+/nIv/6OMEQAhVLzv1O8aa/9DuAFAUnjHy30HLiO8+f+Evc9oxAKCt7ucP3J7oPPoUsUntFADv8JObu1Z+Y/FgMQsD7RYMDCcAQihj3CvEyBbtDgBFkbBWvmmG7PzjjCUnT9COAQAttTfdNK7uf55Zl+iYycU/EDJB2Wu/5uK/NDAAhNCqhls7rDXf0+4AUETGzPaM+8K0paddyOsCAcRN7RUPfjuxaf6GRPeU/bVbALyXTW3tOTi96avaHcgPfsgMqQWNC9z1QfAXETlMuwVAcRljHjHGnP9sw63rtVsAoJDmXLd4ZNA1/o9u15FHGn4sBUIpN2TlLx770se+qN2B/OA7bYhNW3LaHDF2uXYHABUZsebHtm34D3k2AIBSNGvRHV9Ldk/7kfGGJbRbALy/ILWle8XXb6nk+H/pYAAIuWlL6x8QkRO0OwAosfZxcd3z/9Rw66vaKQCQD8fccP/wVPvwh92ug4/kR1Eg3LJVD/348UtO/pZ2B/KH77ohN23pKYeKOH8REdZxIL4yYuyPWgZ3/2jtR+/r0Y4BgP6q/fk95ycyh15tvBEp7RYAHyxIvdW54utTBvPqv9LCQwBD7k9n3PGyFblauwOAqjKxZuHQtooXqpedOlc7BgD6as7ldwytveKRlcmOWddz8Q9Eg1+29sdc/JceTgBEwMw7PzG4pzu1RsTupd0CQJ8Vudux3kXPnXnnBu0WANiT6mUNn6nYetE1yY5pFdotAHonSG1oXfGNg4dqdyD/OAEQAU988g/tYux3tTsAhIMR+biVxF9qltZ/XhYu5Ps4gFCqWfLJ8dOW1v/OWP+33aOvqegZeo8Iv0wEIsEbtOrftBtQGJwAiAorZtqy+hUiUqedAiBUXg2MXPrn0297QDsEAERE5vzms2UdZR3fEmP/RUTK3/33El1TpXz7BWJ8DgMAYeWXrd2x8mtHjtbuQGHwm6OoMGLFymUi4munAAiVgxwr91cvrb9rxpKTJ2jHAIi3aUtP+0hHefvLYuz35R8u/kVEvIo/S+feC8VPb1SoA7BnVvzyNy7TrkDhcAIgYqYtrb9BRM7T7gAQSm3W2B9kjHvlqoZbs9oxAOKjpnHBWBsEPxGRs6U3P1/alJTvPEeSbRxsBMLEr3h188qvVO+t3YHC4QRAxGSzwbdFpEW7A0AoDTHW/Kw8CFZNW1Zfrx0DoPQdfuM5g2qW1n/PBsHrInKO9PaXSyYr3aN+LZkRS0UMhxuBcAgkm15/sXYFCosTABFUvbT+i0bkGu0OAOFmRJ4Xx/nacw23rtRuAVBaJt37kXRV66DLzN/u8x8+kM9yeyZIxdZLxHij8lQHoD+88hdXP/rVY6dod6CwOAEQQYPH7LpeRF7S7gAQblak2gbB8mlL6hfzfAAA+TJtWf1Hh7ZVPG+M/ZEM8OJfRMRPvykd+ywUr4IfbQA1To8NEq+cpZ2BwuMEQETVLD21xop5SkRc7RYAkeCJyBLjy8LnPnXbOu0YANFTs+zUOhvIT8WYowvzFYykWz4qqV0LxPAjKlBUuUHPrXjssrlztTtQeHx3jbDqJfW/NEYu0O4AECldIuYqJ+X/5NlT79ilHQMg/I5uXLB/4Ac/ECNnSRFOjya6jpDy7ReK8QcV+ksBEBFxW4NgzBN7rzi3Yat2CgqPASDCpt/8qSFeIrPaiPCkTgB91WWM3OD4uf965qw/bNOOARA+1YvrJzuO/MCK1EuRbxt1vBFSvu0ScTMfKuaXBWIpV/nEzY9deuI52h0oDgaAiKtZVn+2tXKTdgeAyGqy1lwhrln0fMOtrdoxAPTV3FL/Iev8//buNM7K+r77+Pd3nXNmZVOCBNyXuKFGGAYkGoOWbCoKzCKLuLRRIqgxSZv0vpO02KRNk1faJu3dprExJijbDIvRRBNFRRhkHdwAjbVq1Mi+M8xyzrl+9wNNShKMLDPzP8vn/VBx5sNLGc/5nv91XfqKTJMlpUJ1mKdUtm2SUns4lQx0lWxqU4f1W9p78U03tYVuQfdgACgAVXNqHjLpqtAdAPJai5nukUXfXF3fyBFAoAhVN9RdGMfx1026Qjl0o+jU3otVtu0GWVwaOgUoOB29H/9G023XfC10B7oPA0ABGDxz3MmJhK2XxMVyAI4WQwBQZIbOrhnspr/LtTf+B4raT1LF5tsVpY8LnQIUjGzpazuf+svzj/pJHsgvDAAFomp27dfM/O9CdwAoGLtN+n4Up7/LPQKAwlTdUHehZ+MvyjReUjJ0z/uxuEzlW25RsqUqdApQAFyZPo98Zsm0+ntCl6B7MQAUiDMe/nRpnz0Vz0o6O3QLgILSZtK9yuo7PD4QKAAuq5oz7oooir7g7peHzjl8kUp3jFXpztHiZSxw5DJlL7255ItDTwrdge7HT84CMnR27UiZPyH+vQLofBm5GiOLv7Vq/MLnQscAODwj772xrKVi72R3fV7SOaF7jlay9WyVb54qy/YOnQLkHY/a1dbnF8OX3zppVegWdD/eKBaYoXPG/Uiym0J3AChcZvZELP+30yx6qLG+MRu6B8B7u2DG2ONKUompFvmt7iqoC+gte6wqNk1Tou2M0ClAXkn3XLFo6R2jPh66A2EwABSY82dOPKY02b5ergGhWwAUvNfc/N+zJfE9z459YFfoGAD/q7qh7sI4G0+1dx7lVxa6p8t4QqU7alS668rQJUBeiFNb08nej/ZbNGUKj/4tUgwABahqbs0Ycy0M3QGgaLSYNEOx/n31xPnrQ8cAxeqCGZMrS0r3XyvXLZKGh+7pTql9I1S25SaZ86hA4E9J9378m0tvu+b/hu5AOAwABWronJoZkiaH7gBQXExqlnR3XNlxf/Poh/aH7gGKQfXcmlFy3eLSaBXyp/3vI0oPUMWmOxR1DAydAuSkbNl/b33qi4ML6lIgHD4GgAI1oqHu2HQcr5f0wdAtAIrSLjPNUEbf4+kBQOcb0VB3bEfWbzbzG1QAN/XrNHGZyrd+Rql91aFLgJziSqut7y9GLf/shMdDtyAsBoACNnRO7XjJZ4fuAFDUMpJ+Ltm9vvvYh5un3J0OHQTks6rZNcPNdJ2k6yT1Cd2Tq1J7LlP51smSEqFTgJyQrmxuXnrnx4aG7kB4DAAFrnpOTYNLdaE7AEDSbklzPYrua65vbAodA+SLqoa6SyKP62JXjUnHh+7JF8m2M1W+aZosy06C4uaJPdnM8Y+fuHTy5I2hWxAeA0CBGzz76oFJS61z6ZjQLQBwgDWSfpKI040rJz64OXQMkGuqZ19zoltyvKSJki4M3ZOvokxflW+apkT76aFTgGA6ejbNaLrjUzeE7kBuYAAoAtVza65z132hOwDgYN69ceB9cdobmicv4NMJFK3Bs68eGKlkssyvN+nc0D0F43ePCrxCvPRFscmWvr7zqS/O+4Bsehy6BbmBn4LFwGXVc2secemToVMA4E/ocOnRyDQ3Spc9uPK6mXtCBwFdrXpmzWlKaPS7d/C/VFIqdFOhSu4fovItN8uyFaFTgG7hllZHz59ds+z2yQ+GbkHuYAAoElX3jRtgSXtBpr6hWwDgEGQlrTCpkZMBKCSDGupKKjz+pLuucukTJp0SuqmYROn+Kt98hxLtJ4ROAbpcunLN00vvHHlx6A7kFgaAIlI9p3aSy+8P3QEAh6lD0iKTzbOS7IOrxi3cHjoIOBxVD42usJbSj0s+WrKrJO8fuqmoeYnKt01Was+loUuALhMnt2f29lk2oHnKxG2hW5BbGACKTNXsmrlmqg/dAQBHKGvS07Hbz82yP18zfuG60EHAwVQ11J2vOP64mX1c7h+TVB66Cb8vtecylW27TubJ0ClAp+vo88vpTdNq7grdgdzDAFBkRjTUHZuO/QXJB4ZuAYCj5dLrkj9sin6Wimzx8vrG1tBNKE7VDXUflMej3PUJmUbJNSB0E95fov0UVWy6TZbpFzoF6DTZ8g2/eeoLw7jOBQfFAFCEhswae3kURY9JikK3AEAnypr0rEyLJC3ab9GS9fWNHaGjUJjOnznxmJJExyiTj5I0StJpoZtwZCzbQ+VbPqvk/vNDpwBHzROtnun12IVLp058PnQLchMDQJGqnlPzHy7dGroDALqKmbbItUiyRbEyS5rHP/A/oZuQv4bfP+6ETDIaYeYjFPtFMhsiqTR0FzqLqXTXFSrZXifj5THyWLrXkvlLb7+iNnQHchc/4YrUGQ9/urTPnoo1ks4L3QIA3WSPpFXutkgJW7a7x77Vr1zxSHvoKOSe82dOPKYs2X6Jx1Yl84slDZPUK3QXul5y/4dVvmWKLFsZOgU4bNmSN/Zay+ZjF0+/LBO6BbmLAaCIVc2uGW6mJknc/QZA0TFpp5s97bFWmmdXeDK5qrm+cXfoLnSvkU+OTO7bfMzZUmKIy4dE0nCXhkgqCd2GMKKOD6pi8+2KOriEGvkkVuaYR29cMrX2J6FLkNsYAIpc9dxxf+duXwvdAQA5IHbpJZOvlKKVrnh1W5RYx30ECsfIe28saynfc75kg10+RK7BMjtf3KEff8A8pbJtk5Tac1noFOCQZHqsWrHkc5ePCN2B3McAUOSqfnBLynpvXyppeOgWAMhBHZLWmXxtLFvr8mdKo8RzPG0gt418cmRyz9Z+p0Sxf0juZ8v8QlsTE9UAACAASURBVMkGSzpHnHrDYUjtvVhl226QxdzuAbkrm9rUYf2W9l980027Qrcg9zEAQNUza07zhNZK6h26BQDyQEbSq5LWyfwlydYp1ks92nq+uPimH7eFjismIxrqju/w7JmR24ckO9NNH5L7WZJOFUf40Umi9pPeuSQgfVzoFOAgYrUd89iUp6fW3B26BPmBAQCSpOrZ4651szmhOwAgj2UlvSazV9zjV2V6VbL/8axebU9Gr66vb9wXOjCvTJ8eDT5r7QdTidKT3eMTY/mJkewkd50k6WRJZ0riTm3oFhaXqXzLLUq2VIVOAX5PprL5mSV3fmxI6A7kDwYA/M7QOTU/lPQXoTsAoDDZZsnfcLO35P6GpDci01uK7a1kwn69R9paLPcbqJo14QMetfVLmPXzWMdJ1l+RD1RsJ5np5Fg60aTjJaVCtwL/651HBZZur5UUhY4BFKe2pvf2Xj6wecrEbaFbkD8YAPA7VQ+NrrCWkjV65xpJAED32yVps9y3ehRtjdw3xdJWk+801y63aKdZvDO2xM5kR3bnvpLErhAnCy5cOKZPKp0qUzquiBPex0zlJiv32PtIKjezcnf7gEz9XHE/s+g4ufeXqZ9c/cR1+MhjydazVb55qizLlZMIx+VK9/7Z55pum/CvoVuQXxgA8HuGzKq5IIq0UlJZ6BYAwCFrNanNpb165x4Fu+Sekdmew/gafeyA1wUu9dGBrxNcvWUql1TRWdFAvrLssarYNE2JtjNCp6BIpcuf2bD0Cx8dFLoD+YcBAH+kak7tZ0z+X6E7AAAAcpYnVLqjRqW7rgxdgiITJ7enO3o1n/D0reO2hG5B/kmEDkDu2Thvw9oBdYM+bFwKAAAAcHDmylasl6d2Krn/PPGyGt0l3Wv515dNHftw6A7kJ+5ggoMzu0nSa6EzAAAAcllHz6e078SvKS55O3QKikCm4rkXmqZdc1foDuQvBgAcVHN9425zu05SOnQLAABALotTG7Xv+LuU7rE6dAoKmKc2drRUrLs8dAfyG2eV8J7enr/hzYE15+6Q6YrQLQAAADnNMsr0WKU4uVup/eeLz9nQmdwySvdacf3KWyevDN2C/MZNAPG+hs6pmSFpcugOAACAfJBsO1Plm6bJsn1Cp6BApHusWrT0c5d/PHQH8h/TJN5XR0fFrS5tCN0BAACQDzJlL2vfiV9VtpyXTzh6cenruxI77dOhO1AYOAGAQzK0oe4sxfFqST1DtwAAAOSF3z0q8ArxshtHwhNtnu3x1Mglt9UsCd2CwsAJABySNfWNv5LsltAdAAAAecOyau/boP0D/lWe2B+6BnkoXbnmx7z5R2fiJoA4ZG/P27Du+Npz+0uqDt0CAACQL+LURmUq1yjRdo6ibK/QOcgT2fIX31p658dGhu5AYeEEAA5LMoq+6NJzoTsAAADySZzarP0Dv65MZXPoFOSDxL7Yyl/kun90Oi5GwmGraqg7ybLxWpn6hm4BAADIN6k9l6ls23UyT4ZOQU6Kle75+OeX3jH2u6FLUHgYAHBEhs6pvUbyheK/IQAAgMOWaD9FFZtuk2X6hU5BjslUrl695M7LhoXuQGHiEgAckTXj5/1Ubl8N3QEAAJCPsqWva98J05WpeCF0CnJItvSNvVHv1y8N3YHCxU0AccTenrehacC6c88x06DQLQAAAHkn6lC653Ip6lCi9VwZByuLWpxo8WzFio8tmTL516FbULg4AYAjZ/K2RPQXkpiuAQAAjoirvc/P1TrgX+SJltAxCChdufKfmm6bsDJ0BwobMyOO2kWzx5ySsWi1ZB8I3QIAAJCvokxflW++TYm200KnoJtlKp5/ccnnP3Ju6A4UPk4A4KitmPDA62Y2QVI2dAsAAEC+ipPbtX/gPyjd68nQKehGcWpjW6TNHwndgeLAPQDQKd6e9+KrA2oGtZtpVOgWAACAvGWxMpXPKk5tVbL1PB4VWODc2tVRvrx26Z01z4VuQXHgEgB0HpcNnVuzQNKY0CkAAAD5LtF2hso3T1WU6Rs6BV0k3XPZvKV3fLIudAeKB5cAoPOYvLQ8fb1LG0KnAAAA5Lts2StqOfH/KlPZHDoFXSBT+cJrvPlHd2MAQKdads2De+OsXyHZ5tAtAAAA+c6jNu3/4L+pvW+DpDh0DjpJNvX2/sg3DQndgeLDAIBO98ykBb+O3K+StD90CwAAQP5751GB+wd+S57YHToGR8kTrd7Rq/nqxZ8fuyt0C4oPAwC6xKoJ89e47EZJHroFAACgEGTKX9K+E6crW/ZK6BQcMVemx8qvL//shMdDl6A48RQAdJmN8zZsGFgzyGQaGboFAACgIEStSvdcJnlSybYzQ9fgMGUqm5cvveMTk0N3oHhxAgBdas34eXe5fGboDgAAgIJhWbX3bVBr//+UW3voGhyiuOx/tkW7/NLQHShuDADoWibv2drrM3JfHjoFAACgkKR7LFfLiX+ruOTt0Cl4H57YkYlSL160ePplmdAtKG4WOgDFYfisq/tno9RKSSeHbgEAACgocZnKt35GqX3VoUtwEK600r2e/POm28fdG7oFYABAt6maM26IyZZIqgzdAgAAUFhMpTuvVumOMeKQb27pqGxa0HTnp2pCdwASAwC62bDZ48bGZvPE/5kAAAA6XbLtTJVvmibL9gmdAkmZ8mdfWvKFS84J3QH8Fm/C0K1WTViw0GVTQncAAAAUokzZy9p34leVLd8QOqXoZUtf39lSubMqdAdwIB4DiG63cd6GtQNqz41M+ljoFgAAgIITdSjdY8W7jwr8kDj02/3i1Pa091w9eMVnazeHbgEOxACAIDY2vvjUwHXnnijT4NAtAAAABcdc2Yr1ypa9oWTrBTJPhS4qGp7o8I4eS8c3TZ3QFLoF+ENcAoAwTH5qIrpF0k9DpwAAABSqTMVatRw/XdnSt0KnFAWXK1257FtPT6ufF7oFOBjOAyGoqodGV0QtJY+7dFHoFgAAgILlJSrfNlmpPZeGLilo6R6rnlr6uctHhu4A3gsnABBU8+iH9sdxyWhJL4duAQAAKFjWodZ+96i134/llgldU5AyZS+9ufSOJZeH7gD+FAYABNc8cfa2RBSNlbQjdAsAAEAhS/d6UvsHfFue2B06paDEqc3tyYpXR8imx6FbgD+FSwCQM4bMrv1oZP6opLLQLQAAAIXMsj1UvuWzSu4/P3RK3vPEzri9zxOXPP3ZG5aHbgHeDwMAckr13JpR7vqZpNLQLQAAAIXNVLrrCpVsr5PxtuCIeKLD072evK5pas2s0C3AoeAxgMgpb8978dXjawdtkFQrLlEBAADoUtmy/1Zc9tq7jwosCZ2TZ2Klez91V9O0sf8vdAlwqBgAkHPenrfhxQF1524x6arQLQAAAIUuTm1WpscKJdo/pChzTOicvJHp8fTCpbdfOTV0B3A4GACQkzbOe3HNgLpzsibjTqoAAABdzKNWZXo+rSjbU4n2U0Pn5LxsxTPPLbnz8stCdwCHiyPWyFnN1y74hsn+KXQHAABAMXBLq7Xfj9V63N3yqD10Ts7KlP1qo+3ODA3dARwJTgAgp73duOGxgevPPUHSkNAtAAAAxSAufVOZiueUbD1PFleGzskpccmbLR19XvpQ0xeuagndAhwJTgAgt5n81CiaIrN5oVMAAACKRVz6hlpO+Joylc2hU3JGnNiV6UiuvWT5Z+p3hG4BjhTP+0BeqHpodIW1lDwq6eLQLQAAAMUjUumOsSrdOVrF/NbBE22e7rl4UtO02tmhW4CjUbx/ipF3Llw4pk+yPfG4uBwAAACgWyVbz1b55qmybO/QKd3OrU1tvX95+/Jpk3jcH/IeAwDySlVDXW/LZh+V2bDQLQAAAMXEsseqYtM0JdrOCJ3SfSyrjl6Lv9F02zVfC50CdAYGAOSdqoa63hbHj0mqDt0CAABQVDyh0h01Kt11ZeiSbtHRs2lG0x2fuiF0B9BZGACQly5cOKZPqj2xyKWq0C0AAADFJrVvhMq23CTz0tApXSZdueqJpXde/mehO4DOxACAvFU1a8IHLOp4QtL5oVsAAACKTZQeoIpNdyjqGBg6pdNlKp55dsnnPzo4dAfQ2XgMIPJW88TZ27JR9GeS1oduAQAAKDZxaqP2HX+X0j1Wh07pVNnyF9+Kdme41BQFiRMAyHsXzBh7XKoketKkc0O3AAAAFKPUnstUvnWypETolKOSLX1tu5W/eMriafX7QrcAXYEBAAWhqqHuJMXxUyadEroFAACgGCVbz1P55ltl2R6hU45InNrUur987aBVt9e/FroF6CoMACgYF80ec0rGEk9IOjV0CwAAQDGybE9VbJ6qRGt+HcyMS37T1lry5AUrP/fZ/w7dAnQlBgAUlOGzru6fjVKPSxoUugUAAKAo/e5RgVcoH95uxKnN7e29V164fMrEl0K3AF0t9/9EAofpghljjyspiRaJpwMAAAAEk9w/ROVbbpZlK0KnvKc4tT2d6bFyRNPU+ubQLUB3YABAQRrcUNcviuPHTPpw6BYAAIBiFaX7q3zzHUq0nxA65Y94Ykcm3WPZJU23TVgZugXoLgwAKFgXLhzTJ9kW/VJmw0K3AAAAFC0vUfm2yUrtuTR0ye94Yk+2rc9Tn1z+2QmPh24BuhMDAArahQvH9Em1Jx5x6aLQLQAAAMUstecylW27TubJoB2e2Buney69smla/S+ChgABMACg4FU11PW2bPYRmY0I3QIAAFDMEu2nqGLTbbJMvyDfP060eKbXkmubptY1BgkAAmMAQFG4cOGYPsn2xC8kDQ/dAgAAUMws2+fdRwWe1a3f16N27+j91NRlU8f9Z7d+YyCHMACgaAy/f1KvbLLtp5JGhm4BAAAobqbSXVeoZHudrBvekniixTO9F/350lsn/bjLvxmQwxgAUFQGNdSVlGXj+8xUH7oFAACg2CX3f1jlW6bIspVd9j080eLpnksnNU2rnd1l3wTIE4nQAUB32tq4IXvJtect3Bn7ADNVhe4BAAAoZnFqszI9VijR/iFFmWM6/et7osU7ejZNWDatdk6nf3EgD3ECAMXJZUPn1v6j5F8KnQIAAFDszFMq2zZJqT2Xdd4XTbTE7T2bJi6bVjO3874okN8YAFDUqmbXftnMvyn+LAAAAASX2nuxyrbdIItLj+4LJVrijl5LxnO3f+D3cQkAitrG+RuWDag7d7NJV4gRAAAAIKi49E1lKp5TsvU8WXyE9wVI7Ivbei65dtm0+nmdWwfkPwYAFL2N815cc3zNOW/I7CpJUegeAACAYubJ3Ur3WKFEx8mK0scd3j+baPF0r2WTl02r49g/cBB84gm8a9jscWNjs1mSykK3AAAA4J1HBZZur9WhfEYTJ3dlM70Wj2m69bqfdX0bkJ8YAIADDG2oG2YeP+Suw5ubAQAA0CWSrWerfPNUWbb3e/6abGprOnPM2kuX3VyzohvTgLzDAAD8geqZNafFCf3CpA+FbgEAAIBk2WNVsWmaEm1n/NHfi1ObWtXz6WGLb71+XYA0IK8wAAAHMWzB2L5xR/SgpI+EbgEAAIAkT6h0R41Kd135u7+ULXljb2vZug+vur3+tYBlQN5gAADewwUzJleWlLbOlfuV7/+rAQAA0B1S+0aobMtNypb+Zkem4pVznr513JbQTUC+4CkAwHvYvPD59MX1g+bu8ri/ZEND9wAAAECKS96Sl/3qibik70eXTxm9LXQPkE84AQAcgqrZtV82838M3QEAAFDs3NWgPX2va55ydzp0C5BvGACAQzR0Ts1tkr4rTs4AAAAE4vf26L/jlsWXLc6ELgHyEQMAcBiq5taMMdf9kipDtwAAABQV839YU7/gqzJ56BQgXzEAAIdp6Jyx57mih0w6JXQLAABAEUi76ebma+f/JHQIkO8YAIAj8O5jAhdIujR0CwAAQAHbb6bxq6+d/1DoEKAQMAAAR+iMhz9d2md3xQ9lui50CwAAQAHaqii6ak1946rQIUChYAAAjobLqubUfsnM/0FSFDoHAACgQPw6VvzpteMXvhg6BCgkDABAJ6iaU1tn8p9IKg/dAgAAkOee9bRf0Tx5wcbQIUChYQAAOkl1Q93HPBvPl6lv6BYAAIB8ZNJSK4nHrhq3cHvoFqAQMQAAnWhIQ90ZURw/KOmc0C0AAAD5xWfs6tV6yytXPNIeugQoVAwAQCcbee+NZfvK994taXLoFgAAgDyQNemLq8fP/17oEKDQMQAAXeF/bw7495ISoXMAAABy1B6L42tXT1z4i9AhQDFgAAC6UPWssZ9SFM1y6ZjQLQAAADnmjTjW6LUT5z8fOgQoFgwAQBd7974AD0gaFLoFAAAgR6zxtF/Nnf6B7sVzy4Eutra+8ZXWKLpI0oLQLQAAADnggY6OipG8+Qe6HwMA0A3W1zfuOzWK6iX7tiQP3QMAABCE6V9OjaLa56+/ryV0ClCMuAQA6GbVs8dd62Y/lNQjdAsAAEA3aZNsyprx82aEDgGKGQMAEMDgmeNOTkRqkNmw0C0AAABd7LU41hhu9geExwAABHLGw58uPWZvxbfddUfoFgAAgC6yKCqJx68at3B76BAADABAcNVzaie5/AeSKkO3AAAAdBYzfesUi77SWN+YDd0C4B0MAEAOqJpVc7ZFapR0XugWAACAo9RqsptXj583M3QIgN/HAADkiKqGut4Wx/dIqgndAgAAcCTMtEXyutXXLlgSugXAH2MAAHLM0Dm110v+fUkVoVsAAAAOw6PZKLrumfrGraFDABwcAwCQg4bMGXeRyWabdEroFgAAgPfhJvvnyv7b/nrxZYszoWMAvDcGACBHDWqo61Eex/8haXLoFgAAgIOzzXGcnbh24sInQpcAeH8MAECOq5pTW2fyuyX1Cd0CAABwgKcTGb925XUL3godAuDQMAAAeeCi2WNOyVpitksXhW4BAABFz8307crjtn+VI/9AfmEAAPJE1Q9uSVmvHV+R+dckRaF7AABAUdol2Y1rxs/7aegQAIePAQDIM0Pn1tTI9UNxSQAAAOhe6xJRdO3K+sYNoUMAHBk+RQTyzJpr589PxOmzTfpl6BYAAFAUYrnd5bv7DuHNP5DfOAEA5KmRT45M7t30gf9j71wSkArdAwAACtJul93cPH5eY+gQAEePAQDIc9WzagZ5pBmShoRuAQAABWVJIuOTuMs/UDi4BADIc6snzl/vu/teJLe7JGVD9wAAgLyXldtdp0bR5bz5BwoLJwCAAjJkzriLItlPJJ0ZugUAAOQfl34TRdGk1fWNT4VuAdD5OAEAFJC14xes8CgaJvmM0C0AACDPmD0WRdFQ3vwDhYsTAECBqppT+wnJf2TS8aFbAABATtsr2W1rxs/jAwSgwDEAAAVs+Kyr+2ej1H9KGhO6BQAA5KTVHuv65onzXwodAqDrMQAARWDo3JorJP1ArhNCtwAAgJzQbtKXV187/19l8tAxALoHAwBQJKoa6npbHH9b0s3izz4AAMXsGYs1efXE+etDhwDoXrwJAIrMkLk1n4xcd0s6KXQLAADoVlm5fcP3HPv3zVPuToeOAdD9GACAInT+zInHlCbavivZ9aFbAABANzC9pWz852smLnwsdAqAcBgAgCJW1VB3icXxPZLODN0CAAC6RNZM30ladNfy+sbW0DEAwmIAAIrc8Psn9comW78t2S3iZwIAAIXkFbndvGbCvMWhQwDkBl7sA5AkVTfUXejZ7A9kNix0CwAAOCod7vY32nPsP3OtP4ADMQAA+F/Tp0fVZ7/wGZe+I6ln6BwAAHDYVnsU/UVzfeMLoUMA5B4GAAB/ZPDsqwcmopLvyb02dAsAADgkLSZ9pbL/9n9ffNniTOgYALmJAQDAe6qaPW6iWfTPkvcP3QIAAN7TSo+im/nUH8D7YQAA8CdVPTS6Itpf8jfu+ktJidA9AADgHWba4m5/tebaeffJ5KF7AOQ+BgAAh2To3HEXy+37ks4P3QIAQLEzaZai6Iur6xs3hW4BkD8YAAAcOpcNnVs7WdK3uSwAAIAg1nkU3dpc39gUOgRA/mEAAHDYLlw4pk+qI/HX7vq8pJLQPQAAFIF9Jn2Vm/wBOBoMAACO2NCGurMsjr/n0idDtwAAUMDmp6Loc8vrG38TOgRAfmMAAHB0fntZgPk/yjUgdA4AAAXD9Jbc/mrN+HlzQqcAKAwMAAA6xYiGuvJ01r8s8y9LKgvdAwBAHttn0lf3R9H319c3doSOAVA4GAAAdKqhDXVneRx/x6SrQrcAAJCHHoqj6Atr6xtfCR0CoPAwAADoEkMb6oYpm/0nmV0SugUAgDzwvEXRHavrG58KHQKgcDEAAOhS1XNrRrvru5JOC90CAEDu8W0m+0pl/+0/4u7+ALoaAwCALlf10OiKqKXkL136kqTK0D0AAOSAWPL7s575P89MePDt0DEAigMDAIBuM6Kh7tiMx19y1+cllYTuAQAgBJMa41h/0zxx/kuhWwAUFwYAAN1uyKyaC6KEfUfuHw/dAgBAN1on2ZfWjJ/3SOgQAMWJAQBAMEPmjLsoYdHfu/vloVsAAOhCr7rsr5uvnTdPJg8dA6B4MQAACK56bs0od31T0tDQLQAAdKJdJk3fH0XfX1/f2BE6BgAYAADkhunTo+pzXpjorumSTg+dAwDAUUjLdY8lortW1zduCh0DAL/FAAAgt0yfHlWdva7G5N8UQwAAIL9kJP3IPPON1RN++mboGAD4QwwAAHJS1Q9uSUW9t9/ksr+VfGDoHgAA/oSspHuSnv3migkPvB46BgDeCwMAgJw2/P5JvTKp1jvM7fOSjg3dAwDAgczsiazHX1k7fsGK0C0A8H4YAADkhTMe/nTpMXsqbuBEAAAgF/DGH0A+YgAAkFcu/unVPTvakre56wuSfSB0DwCguLj0nMn+ds34eT8N3QIAh4sBAEBeGtRQV1IRxzfG0t+YdHzoHgBAwXvco2h6c31jU+gQADhSDAAA8tpvhwA3fU2uE0L3AAAKi0s/UxR9izf+AAoBAwCAgnDBjMmVJSUtN0v2BUknhu4BAOS9xXEcf33txIVPhA4BgM7CAACgsEyfHlWf88KV7vqKpOGhcwAAecVNmmeK/37V+IXPhY4BgM7GAACgMLlsyNzaKyOPvyyzS0LnAAByWizpAUXRt9bUN64KHQMAXYUBAEDBGzZn7IdjRV+UNEFSMnQPACBntJjpnkzG//mZSQt+HToGALoaAwCAojGsoe5U9/hOd31GUkXoHgBAIKaN5vpWHEU/bq5v3B06BwC6CwMAgKIzePbVAxOWmirpFkn9QvcAALqJ6S2Xf7esLHP3smse3Bs6BwC6GwMAgKI18t4by/ZV7J0o1+2SLgzdAwDoMuvM/Z/2JxKz1tc3doSOAYBQGAAAQNKQhrqqKI5vkXS9pLLQPQCAo5aRNDuOou+trW9sDh0DALmAAQAADjB81tX9M1Zyo8xvN+n40D0AgMO2Q27/llXH3c9MePDt0DEAkEsYAADgIC6YMbkyVbp/srmmSTovdA8A4E9z6fXI7d/TZZkfPjv2gV2hewAgFzEAAMD7OODygEmSKkP3AAB+x136eWT63ur6+Y/L5KGDACCXMQAAwCEa3FDXL+HZm+Q2RdJpoXsAoIjtlun+yOP/WjV+4XOhYwAgXzAAAMAROOBUwGRJ5aF7AKAIuKTHXXZ3W2Q/5W7+AHD4GAAA4CgMv3/cCXFKt7hHfyH5wNA9AFBoTNrpsvul7N1rxi9cF7oHAPIZAwAAdIK6hrrEq9nsp8zsJkmjJZWEbgKAvObeJIv+KxVZ4/L6xtbQOQBQCBgAAKCTDb9/Uq9ssn2M5JMl/Zn4WQsAh+p/3O2/ktl45srrFrwVOgYACg0vSgGgCw1tqDtLWZ8g8xslnRy6BwByUIukmR5F9zVvGPS0pk+PQwcBQKFiAACAbjCooa6k3OPR7rrRpE9JSoZuAoDAnjfpR3FcMrN54uxtoWMAoBgwAABAN7tgxtjjSkqiekkTJI0QP4sBFAvXdplmu/ze5vEL1obOAYBiw4tOAAho2IKxfb0jqnHpekkfET+XARSerWaaHVvUyBF/AAiLF5oAkCMGzxx3cjJhY1y6QdLg0D0AcBT2SVpopsadPfc/+soVj7SHDgIAMAAAQO5x2bDGuovi2CfIvFauAaGTAOAQxJKectmsjmzJ/BcmzdoZOggA8PsYAAAgl02fHg095/kRchvn0jiTTgmdBAAHyMq9ycwWJqNo3vL6xt+EDgIAvDcGAADII9Uza05TQqNdqhP3DAAQxj5JC132ULY089izYx/YFToIAHBoeOEIAHnqgHsG1OmdpwlEoZsAFKzdkh40U2PSokXL6xtbQwcBAA4fAwAAFIBhDXWnxnH2GsmulHSppJLQTQDy3DuP7HvYZA/Ele2/aB790P7QSQCAo8MAAAAFZuS9N5a1VOy9RNIod42RdFboJgB5wSU97W4PRe4/Wz1x/vrQQQCAzsUAAAAF7oD7Blwl6WOSUqGbAOSMvSb9wmU/y0b2yDP1jVtDBwEAug4DAAAUkeGzru6fTaSuNNenXPozSceGbgLQ3extlz9q7j8vrcj8ctk1D+4NXQQA6B4MAABQxN49HTBK0iiXPiWpZ+gmAJ1uh0mPS1qkrBatnjT/1dBBAIAwGAAAAJKkEQ115RmPL5Y0Sq5RLg0R/58A8lG7pKXutsgTtuh06dnG+sZs6CgAQHi8sAMAHNQ7TxbwT8g0Sq6PSt4/dBOAg3JJ62V6SrEvTiUSTyyvb9wROgoAkHsYAAAAh2Tw7KsHRlZycWR+iVwXc0IACKZNUpPcllnkTe3tFcufv/6+ltBRAIDcxws3AMARqWqoOyny+NI41qVm+qiks0M3AQWqQ9Jqd1tipqWl5R1N3LgPAHAkGAAAAJ3ighljjystSVwi6SPu8XCZDZFUEboLyD/2tuQr3Pxpk1b02N+rVeqzaAAABCRJREFUefFNP24LXQUAyH8MAACALlM9s+Y0T9glZl7lripJQyWVhu4Ccsgul5rMrdkib4otWt1c37g7dBQAoDAxAAAAuk1VQ11vxT5cruEyH2ayam4uiCISS3pZrjUyb5ZpNZ/uAwC6EwMAACCo4fdP6pUp6bggiuMql6pMOtel88RJAeS3dklrzNTsbs0We3O8t+/LzVPuTocOAwAULwYAAEDOqWqo6x159sNyGyzX4Nh0oUnnSkqFbgMOYp+kFyVf56b1ktbKEms5yg8AyDUMAACAvDCooa6kNBOfnTA/R5EGudu5kgZJOkNSMnAeikOrpBclrXe39W5an4xs/aq6xtdl8tBxAAC8HwYAAEBeG9RQV1ImnRV5fE7sGmRm58r9t8MAJwZw+Ewb5fqVu/47kr3sil+OE4kNp0uvNdY3ZkPnAQBwpBgAAAAFaeSTI5Mtb/c9yS0+3RPR6eY6TdLpLp1u0umSeoRuRDgm7ZT0qrteVuS/kuzl2KKXy0vbX152zYN7Q/cBANAVGAAAAEVp+Kyr+3uy9DT3+HSXn26xneqmEyQdL+lkSeWBE3F02iS9Luk1l78m06uRR6+5+2uZsuxrz459YFfgPgAAuh0DAAAABzFswdi+6tAJGSVOTCg+yU3Hy+1EuZ8ksxMkDZBUEbqzSLVJ+o1Jb7vrLZk2Sv6muTbGicRv4mz7q8+Mf3Aj1+UDAPD7GAAAADhCF8yYXJksaxsQeba/y/rJNcDMj5Osn8sGWhz3k9lxemcs6Bm6N8ftcWlzJG2PpW2Stsm0zVxbTLbNpU1S9s2oRBtXjVu4PXQsAAD5iAEAAIBuUNdQl3hL6p1Jx32yqegYZTK9E1Gij6Terri3POojU2+X95FZb3PvKancpLJY6mVS0qQ+LpVIqgz82znQPpPSsbTbpKxJu2S22933Strj8r2R2d44tp0y3xOZ9nrsezzSXlliW5xt396RKN22vr6xI/RvBACAQscAAABAHrpgxuRKT2RLKqP9vT1OpNKpqNcf/ppkNjaP1Odov1fWop0JKat0vCdy79hvZS19O0paF9/047aj/doAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABA1/r/Mce3NjBx/SQAAAAASUVORK5CYII="
  })));
}

var MemoSvgGoogle = /*#__PURE__*/React.memo(SvgGoogle);

function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 3h7v7H3V3zM14 3h7v7h-7V3zM14 14h7v7h-7v-7zM3 14h7v7H3v-7z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgGrid = /*#__PURE__*/React.memo(SvgGrid);

function SvgGym(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 8H2a1 1 0 00-1 1v2a1 1 0 001 1h2m0-4V4c0-.333.3-1 1.5-1S7 3.667 7 4M4 8v4m3-8V2c0-.333.3-1 1.5-1s1.5.667 1.5 1v6M7 4v11m3-7h10M10 8v4m10-4V2c0-.333.3-1 1.5-1s1.5.667 1.5 1v2m-3 4v1.5M23 4c.167-.333.7-1 1.5-1 .659 0 1.137.452 1.378.798a.757.757 0 01.122.438V8m-3-4v11.5M26 8h2a1 1 0 011 1v2a1 1 0 01-1 1h-2m0-4v4m0 0v3.264c0 .155-.033.31-.122.438-.24.346-.719.798-1.378.798-.8 0-1.333-.667-1.5-1m0 0V17c0 .333-.3 1-1.5 1s-1.5-.667-1.5-1v-5m0 0H10m10 0V9.5M10 12v4.764c0 .155-.033.31-.122.438-.24.346-.719.798-1.378.798-.659 0-1.137-.452-1.378-.798A.757.757 0 017 16.764V15m0 0c0 .5-.3 1.5-1.5 1.5S4 15.5 4 15v-3m8-2.5h1m7 0h-5.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgGym = /*#__PURE__*/React.memo(SvgGym);

function SvgHash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 9h16M4 15h16M10 3L8 21M16 3l-2 18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgHash = /*#__PURE__*/React.memo(SvgHash);

function SvgHeadphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 18v-6a9 9 0 0118 0v6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14h1a1 1 0 00-1-1v1zM3 14v-1a1 1 0 00-1 1h1zm17 5a1 1 0 01-1 1v2a3 3 0 003-3h-2zm-1 1h-1v2h1v-2zm-1 0a1 1 0 01-1-1h-2a3 3 0 003 3v-2zm-1-1v-3h-2v3h2zm0-3a1 1 0 011-1v-2a3 3 0 00-3 3h2zm1-1h3v-2h-3v2zm2-1v5h2v-5h-2zM2 19a3 3 0 003 3v-2a1 1 0 01-1-1H2zm3 3h1v-2H5v2zm1 0a3 3 0 003-3H7a1 1 0 01-1 1v2zm3-3v-3H7v3h2zm0-3a3 3 0 00-3-3v2a1 1 0 011 1h2zm-3-3H3v2h3v-2zm-4 1v5h2v-5H2z",
    fill: "currentColor"
  }));
}

var MemoSvgHeadphones = /*#__PURE__*/React.memo(SvgHeadphones);

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.501 5.501 0 10-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgHeart = /*#__PURE__*/React.memo(SvgHeart);

function SvgHelpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgHelpCircle = /*#__PURE__*/React.memo(SvgHelpCircle);

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22V12h6v10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgHome = /*#__PURE__*/React.memo(SvgHome);

function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15l-5-5L5 21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgImage = /*#__PURE__*/React.memo(SvgImage);

function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 13h-6l-2 3h-4l-2-3H2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.47 5.19L2 13v5a2 2 0 002 2h16a2 2 0 002-2v-5l-3.47-7.81A2 2 0 0016.7 4H7.3a2 2 0 00-1.83 1.19z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgInbox = /*#__PURE__*/React.memo(SvgInbox);

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v-4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgInfo = /*#__PURE__*/React.memo(SvgInfo);

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 7a5 5 0 015-5h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 11.37a4 4 0 11-7.914 1.173A4 4 0 0116 11.37z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgInstagram = /*#__PURE__*/React.memo(SvgInstagram);

function SvgItalic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 4h-9M14 20H5M15 4L9 20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgItalic = /*#__PURE__*/React.memo(SvgItalic);

function SvgLayers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 2L2 7l10 5 10-5-10-5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 17l10 5 10-5M2 12l10 5 10-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgLayers = /*#__PURE__*/React.memo(SvgLayers);

function SvgLayout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9h18M9 21V9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgLayout = /*#__PURE__*/React.memo(SvgLayout);

function SvgLifeBuoy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 16a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93 4.93l4.24 4.24M14.83 14.83l4.24 4.24M14.83 9.17l4.24-4.24M14.83 9.17l3.53-3.53M4.93 19.07l4.24-4.24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgLifeBuoy = /*#__PURE__*/React.memo(SvgLifeBuoy);

function SvgLink2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 6a1 1 0 100 2V6zm3 1V6v1zm-3 9a1 1 0 100 2v-2zm-6 2a1 1 0 100-2v2zM9 8a1 1 0 100-2v2zm6 0h3V6h-3v2zm3 0a4 4 0 012.828 1.172l1.415-1.415A6 6 0 0018 6v2zm2.828 1.172A4 4 0 0122 12h2a6 6 0 00-1.757-4.243l-1.415 1.415zM22 12a4 4 0 01-4 4v2a6 6 0 006-6h-2zm-4 4h-3v2h3v-2zm-9 0H6v2h3v-2zm-3 0a4 4 0 01-2.828-1.172l-1.415 1.415A6 6 0 006 18v-2zm-2.828-1.172A4 4 0 012 12H0a6 6 0 001.757 4.243l1.415-1.415zM2 12a4 4 0 014-4V6a6 6 0 00-6 6h2zm4-4h3V6H6v2z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgLink2 = /*#__PURE__*/React.memo(SvgLink2);

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgLink = /*#__PURE__*/React.memo(SvgLink);

function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 6h13M8 12h13M8 18h13M4 6H3M4 12H3M4 18H3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgList = /*#__PURE__*/React.memo(SvgList);

function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgLoader = /*#__PURE__*/React.memo(SvgLoader);

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 13a2 2 0 012-2h14a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 0110 0v4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgLock = /*#__PURE__*/React.memo(SvgLock);

function SvgLogIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 22h5a2 2 0 002-2V4a2 2 0 00-2-2h-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16l4-4-4-4M15 12H3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgLogIn = /*#__PURE__*/React.memo(SvgLogIn);

function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 22H5a2 2 0 01-2-2V4a2 2 0 012-2h5M17 16l4-4-4-4M21 12H9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgLogOut = /*#__PURE__*/React.memo(SvgLogOut);

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 6l-10 7L2 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMail = /*#__PURE__*/React.memo(SvgMail);

function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 13a3 3 0 100-6 3 3 0 000 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMapPin = /*#__PURE__*/React.memo(SvgMapPin);

function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2v16M16 6v16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMap = /*#__PURE__*/React.memo(SvgMap);

function SvgMaximize2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMaximize2 = /*#__PURE__*/React.memo(SvgMaximize2);

function SvgMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 4a1 1 0 000-2v2zM2 8a1 1 0 002 0H2zm18 0a1 1 0 102 0h-2zm-4-6a1 1 0 100 2V2zm0 18a1 1 0 100 2v-2zm6-4a1 1 0 10-2 0h2zM4 16a1 1 0 10-2 0h2zm4 6a1 1 0 100-2v2zM8 2H5v2h3V2zM5 2a3 3 0 00-3 3h2a1 1 0 011-1V2zM2 5v3h2V5H2zm20 3V5h-2v3h2zm0-3a3 3 0 00-3-3v2a1 1 0 011 1h2zm-3-3h-3v2h3V2zm-3 20h3v-2h-3v2zm3 0a3 3 0 003-3h-2a1 1 0 01-1 1v2zm3-3v-3h-2v3h2zM2 16v3h2v-3H2zm0 3a3 3 0 003 3v-2a1 1 0 01-1-1H2zm3 3h3v-2H5v2z",
    fill: "currentColor"
  }));
}

var MemoSvgMaximize = /*#__PURE__*/React.memo(SvgMaximize);

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h18M3 6h18M3 18h18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMenu = /*#__PURE__*/React.memo(SvgMenu);

function SvgMessageCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.379 8.379 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMessageCircle = /*#__PURE__*/React.memo(SvgMessageCircle);

function SvgMessageSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMessageSquare = /*#__PURE__*/React.memo(SvgMessageSquare);

function SvgMicOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 2l22 22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10a1 1 0 00-2 0h2zm-1 3H8h1zm5.827 2.828a1 1 0 00-1.414-1.415l1.414 1.415zM14 10.34a1 1 0 102 0h-2zM15 5l-1-.001V5h1zm-6.92-.799a1 1 0 101.96.398l-1.96-.398zM8 10v3h2v-3H8zm0 3a4 4 0 002.47 3.693l.765-1.848A2 2 0 0110 13l-2 .002zm2.47 3.693a4 4 0 004.357-.865l-1.414-1.415a2 2 0 01-2.178.432l-.765 1.848zM16 10.34V5h-2v5.34h2zm0-5.339a4 4 0 00-3.598-3.984l-.2 1.99A2 2 0 0114 5l2 .002zm-3.598-3.984A4 4 0 008.08 4.201l1.96.398a2 2 0 012.161-1.592l.201-1.99zM17.714 18.65a1 1 0 10-1.428-1.4l1.428 1.4zM5 13l1 .007V13H5zm1-2a1 1 0 10-2 0h2zm14 0a1 1 0 10-2 0h2zm-1 2h1-1zm-1.094 1.053a1 1 0 001.968.354l-1.968-.354zm-1.62 3.197a6 6 0 01-6.574 1.348l-.763 1.849a8 8 0 008.765-1.797l-1.428-1.4zm-6.574 1.348A6 6 0 016 13.008l-2-.015a8 8 0 004.95 7.454l.762-1.85zM6 13v-2H4v2h2zm12-2v2h2v-2h-2zm0 2c0 .353-.032.706-.094 1.053l1.968.354c.083-.464.126-.935.126-1.406l-2-.002z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v4M8 24h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMicOff = /*#__PURE__*/React.memo(SvgMicOff);

function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 1a3 3 0 00-3 3v8a3 3 0 106 0V4a3 3 0 00-3-3z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10v2a7 7 0 11-14 0v-2M12 19v4M8 23h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMic = /*#__PURE__*/React.memo(SvgMic);

function SvgMinimize2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMinimize2 = /*#__PURE__*/React.memo(SvgMinimize2);

function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 3a1 1 0 00-2 0h2zM3 7a1 1 0 000 2V7zm18 2a1 1 0 100-2v2zm-4-6a1 1 0 10-2 0h2zm-2 18a1 1 0 102 0h-2zm6-4a1 1 0 100-2v2zM3 15a1 1 0 100 2v-2zm4 6a1 1 0 102 0H7zM7 3v3h2V3H7zm0 3a1 1 0 01-1 1v2a3 3 0 003-3H7zM6 7H3v2h3V7zm15 0h-3v2h3V7zm-3 0a1 1 0 01-1-1h-2a3 3 0 003 3V7zm-1-1V3h-2v3h2zm0 15v-3h-2v3h2zm0-3a1 1 0 011-1v-2a3 3 0 00-3 3h2zm1-1h3v-2h-3v2zM3 17h3v-2H3v2zm3 0a1 1 0 011 1h2a3 3 0 00-3-3v2zm1 1v3h2v-3H7z",
    fill: "currentColor"
  }));
}

var MemoSvgMinimize = /*#__PURE__*/React.memo(SvgMinimize);

function SvgMinusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMinusCircle = /*#__PURE__*/React.memo(SvgMinusCircle);

function SvgMinusSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMinusSquare = /*#__PURE__*/React.memo(SvgMinusSquare);

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMinus = /*#__PURE__*/React.memo(SvgMinus);

function SvgMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 5a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21h8M12 17v4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMonitor = /*#__PURE__*/React.memo(SvgMonitor);

function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMoon = /*#__PURE__*/React.memo(SvgMoon);

function SvgMoreHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 14a2 2 0 100-4 2 2 0 000 4zM20 14a2 2 0 100-4 2 2 0 000 4zM4 14a2 2 0 100-4 2 2 0 000 4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMoreHorizontal = /*#__PURE__*/React.memo(SvgMoreHorizontal);

function SvgMoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 14a2 2 0 100-4 2 2 0 000 4zM12 6a2 2 0 100-4 2 2 0 000 4zM12 22a2 2 0 100-4 2 2 0 000 4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMoreVertical = /*#__PURE__*/React.memo(SvgMoreVertical);

function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 9l-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMove = /*#__PURE__*/React.memo(SvgMove);

function SvgMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 17h1a1 1 0 00-1-1v1zm12-2h1a1 1 0 00-1-1v1zM9 16H5v2h4v-2zm-4 0a3 3 0 00-3 3h2a1 1 0 011-1v-2zm-3 3a3 3 0 003 3v-2a1 1 0 01-1-1H2zm3 3h2v-2H5v2zm2 0a3 3 0 003-3H8a1 1 0 01-1 1v2zm3-3v-2H8v2h2zm11-5h-4v2h4v-2zm-4 0a3 3 0 00-3 3h2a1 1 0 011-1v-2zm-3 3a3 3 0 003 3v-2a1 1 0 01-1-1h-2zm3 3h2v-2h-2v2zm2 0a3 3 0 003-3h-2a1 1 0 01-1 1v2zm3-3v-2h-2v2h2z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17V5l12-2v12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMusic = /*#__PURE__*/React.memo(SvgMusic);

function SvgNavigation2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 3l7 19-7-4-7 4 7-19z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgNavigation2 = /*#__PURE__*/React.memo(SvgNavigation2);

function SvgNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 12l19-9-9 19-2-8-8-2v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgNavigation = /*#__PURE__*/React.memo(SvgNavigation);

function SvgOctagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgOctagon = /*#__PURE__*/React.memo(SvgOctagon);

function SvgOutdoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 18.22c.392-.304.5-.912.5-1.5 0-1.6-2-2-3-2H18.5m16 3.5c-.673.521-1.868.5-2.5.5H9m25.5-.5c1 0 1.5 1 1.5 1.5 0 1.5-1.833 1.5-3 1.5h-.5M9 18.72H3.5c-1 0-2.5 0-2.5 1 0 1.5 1 1.5 2.5 1.5H5m4-2.5l-4.5-4c-.5-.5-1.3-1.8-.5-3 .778-1.167 2.563-.539 3.427-.043.05.027.094.06.137.097l3.155 2.704a1 1 0 00.65.241H18.5m0 0l-2.5-4m-1-1.5l-.5-1m-4-6.5c3.25-1.625 5.62-.169 6.842 1.15.395.426.22 1.081-.295 1.352l-2.138 1.125M10.5 1.719C7.093 3.423 7.313 6.093 8.071 7.878c.208.488.796.648 1.266.4l2.48-1.305M10.5 1.719c-.455.836-.828 3.057 1.318 5.254M10.5 1.719c1.106.085 3.536.928 4.409 3.627m-3.091 1.627l3.091-1.627M5 21.219l-.591.986a1 1 0 00.857 1.514h.668a1 1 0 00.857-.485L8 21.219m-3 0h3m0 0h21.197m0 0l1.023 1.962a1 1 0 00.886.538h1.128a1 1 0 00.857-1.514l-.591-.986m-3.303 0H32.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgOutdoor = /*#__PURE__*/React.memo(SvgOutdoor);

function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.89 1.45l8 4A2 2 0 0122 7.24v9.53a2 2 0 01-1.11 1.79l-8 4a2 2 0 01-1.79 0l-8-4a2 2 0 01-1.1-1.8V7.24a2 2 0 011.11-1.79l8-4a2 2 0 011.78 0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32 6.16L12 11l9.68-4.84M12 22.76V11M7 3.5l10 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPackage = /*#__PURE__*/React.memo(SvgPackage);

function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.438 11.662l-9.19 9.19a6.003 6.003 0 11-8.49-8.49l9.19-9.19a4.002 4.002 0 015.66 5.66l-9.2 9.19a2.001 2.001 0 11-2.83-2.83l8.49-8.48",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPaperclip = /*#__PURE__*/React.memo(SvgPaperclip);

function SvgPark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1v3m6 2.5l2-2m.5 8h3m-5.5 6l2 2m-8 .5v3m-6-5.5l-2 2m0-8H1m5.5-6l-2-2m8 3c1.667 0 5 1 5 5s-3.333 5-5 5c-1.667 0-5-1-5-5s3.333-5 5-5z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPark = /*#__PURE__*/React.memo(SvgPark);

function SvgPauseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15V9M14 15V9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPauseCircle = /*#__PURE__*/React.memo(SvgPauseCircle);

function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 4h4v16H6V4zM14 4h4v16h-4V4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPause = /*#__PURE__*/React.memo(SvgPause);

function SvgPeek(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.465 15.945a11.222 11.222 0 01-.907 4.684 7.795 7.795 0 01-3.065 3.604 8.813 8.813 0 01-4.746 1.27c-2.046 0-3.76-.546-5.143-1.636a.633.633 0 00-1.04.475v7.025A.636.636 0 016.93 32H.632A.632.632 0 010 31.367V7.637a.63.63 0 01.632-.63h6.12a.629.629 0 01.63.63v.033a.634.634 0 001.043.478c1.412-1.159 3.186-1.74 5.322-1.741a8.888 8.888 0 014.764 1.25 7.737 7.737 0 013.026 3.572c.643 1.487.96 3.096.928 4.716zm-7.944 0a5.12 5.12 0 00-.354-2.144c-.57-1.2-1.636-1.799-3.198-1.796a3.51 3.51 0 00-2.568.932c-.633.62-.949 1.518-.947 2.694v.563c0 1.148.303 2.041.947 2.675a3.474 3.474 0 002.568.95c1.572 0 2.637-.598 3.198-1.796a4.92 4.92 0 00.354-2.078zM38.898 19.044h5.875a.63.63 0 01.605.797 6.563 6.563 0 01-1.86 2.972c-1.9 1.78-4.854 2.672-8.861 2.674-2.646 0-4.937-.47-6.873-1.408a8.225 8.225 0 01-4.097-4.087 10.091 10.091 0 01-.771-4.083c-.006-.738.059-1.476.194-2.202.119-.65.322-1.283.605-1.881a8.126 8.126 0 013.98-4.047c1.852-.915 4.02-1.372 6.505-1.372 2.602 0 4.805.486 6.61 1.46a8.58 8.58 0 013.903 4.207c.346.808.6 1.652.756 2.518.134.699.208 1.408.22 2.12a.634.634 0 01-.632.648l-14.26.015c-.427 0-.702.515-.605.933.15.64.762 2.15 4.425 2.15 1.925 0 3.092-.187 3.477-.765.111-.17.157-.161.245-.303a.646.646 0 01.56-.346zm-7.055-7.788a3.44 3.44 0 00-1.491 1.606c-.042.1-.079.2-.112.303a.774.774 0 00.672 1.048h6.749a.771.771 0 00.675-1.048 4.458 4.458 0 00-.1-.255 3.191 3.191 0 00-1.474-1.65 5.137 5.137 0 00-2.508-.567 4.86 4.86 0 00-2.41.563zM62.226 19.044h5.869a.628.628 0 01.605.797 6.563 6.563 0 01-1.843 2.972c-1.898 1.78-4.85 2.672-8.858 2.674-2.65 0-4.94-.47-6.873-1.408a8.2 8.2 0 01-4.108-4.087 10.04 10.04 0 01-.775-4.083c-.005-.739.06-1.476.194-2.202.12-.65.323-1.283.605-1.881a8.131 8.131 0 013.975-4.05c1.85-.915 4.017-1.372 6.501-1.372 2.602 0 4.806.486 6.61 1.46a8.553 8.553 0 013.903 4.207c.348.807.602 1.652.756 2.517.135.7.209 1.409.221 2.12a.635.635 0 01-.632.65l-14.261.014c-.427 0-.702.515-.605.933.151.64.762 2.15 4.423 2.15 1.927 0 3.092-.187 3.476-.765.112-.17.16-.161.245-.303a.65.65 0 01.572-.343zm-7.052-7.788a3.43 3.43 0 00-1.495 1.606c-.039.1-.078.2-.111.303a.777.777 0 00.674 1.048h6.75a.77.77 0 00.671-1.048 4.46 4.46 0 00-.1-.255 3.19 3.19 0 00-1.473-1.65 5.138 5.138 0 00-2.508-.567 4.836 4.836 0 00-2.408.563zM82.48 24.615l-4.236-5.292a.631.631 0 00-1.125.394v4.516a.634.634 0 01-.632.633h-6.302a.635.635 0 01-.63-.633V.633a.634.634 0 01.63-.633h6.296a.629.629 0 01.632.633v10.139a.633.633 0 001.098.436l3.676-3.999a.626.626 0 01.463-.203h7.735a.629.629 0 01.448 1.076L84.1 14.579a.63.63 0 00-.027.86l7.309 8.364a.634.634 0 01-.475 1.051h-7.935a.63.63 0 01-.493-.24z",
    fill: "currentColor"
  }));
}

var MemoSvgPeek = /*#__PURE__*/React.memo(SvgPeek);

function SvgPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 5L5 19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM17.5 20a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPercent = /*#__PURE__*/React.memo(SvgPercent);

function SvgPets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.76 13.165l.497.056-.497-.056zm15.503-3.198l-.401.3.4-.3zm5.793 3.604l-.163.473.048.016.05.007.065-.496zm1.593 1.796l-.495-.067v.001l.495.066zm-.716 1.267l-.311-.391-.005.003.316.388zm-.284.406l.474.158.004-.01-.478-.148zm-2.137 2.853l.187.464.003-.002-.19-.462zm-6.46.418l-.04-.498h-.003l.042.498zm-3.558 2.78l.463.188-.463-.188zm-3.327-14.6a.5.5 0 00-.98-.196l.98.196zM8.44 16.252l-.381.324.381-.324zm-1.195-6.45a.5.5 0 10-.994-.112l.994.111zm19.972-6.944l.5-.008v-.004l-.5.012zm-7.054 1.34l.369-.337-.369.338zm6.535 0l.352.355.024-.023.02-.026-.396-.305zm-4.002 2.706l-.365.342.365-.342zm1.457-.001l.365.342-.365-.342zM1.091 23.165l.271.42h.001l.002-.002.004-.003.012-.008a3.079 3.079 0 00.182-.133c.118-.091.283-.227.481-.413.397-.373.926-.945 1.48-1.757 1.108-1.626 2.304-4.204 2.733-8.048l-.994-.111c-.411 3.683-1.55 6.105-2.566 7.596a9.574 9.574 0 01-1.337 1.59 5.712 5.712 0 01-.515.43 1.71 1.71 0 01-.026.02l.272.419zm5.166-9.945c.376-3.404 1.997-5.044 3.555-5.858 1.59-.832 3.168-.83 3.458-.83v-1c-.327 0-2.109-.005-3.922.944-1.846.965-3.671 2.892-4.085 6.634l.994.11zm7.013-6.689c.593 0 4.866.077 7.592 3.735l.802-.597c-3.031-4.067-7.75-4.138-8.394-4.138v1zm7.592 3.735c.205.275.37.547.529.82.155.265.315.548.494.802.381.54.873.986 1.735 1.186l.226-.974c-.57-.132-.87-.4-1.143-.788-.148-.21-.282-.445-.45-.731a9.61 9.61 0 00-.59-.913l-.801.598zm2.758 2.808c.698.162 1.514.403 2.162.607a51.649 51.649 0 011.09.356l.016.005a.21.21 0 00.005.002l.163-.473.163-.473h-.002l-.004-.002c-.004 0-.01-.003-.017-.005l-.064-.022a52.205 52.205 0 00-1.05-.342c-.656-.206-1.5-.457-2.236-.627l-.226.974zm3.436.497a58.69 58.69 0 01-.065.496h-.001.008l.04.008a1.984 1.984 0 01.637.237c.162.097.296.218.381.365.081.14.137.335.098.623l.991.133c.066-.493-.025-.913-.223-1.256a2.043 2.043 0 00-.734-.723 2.98 2.98 0 00-1.033-.374l-.023-.003-.007-.001h-.004l-.065.495zm1.098 1.73a1.461 1.461 0 01-.532.942l.622.782c.31-.247.792-.77.901-1.592l-.991-.132zm-.537.945c-.2.163-.363.378-.446.646l.956.295a.348.348 0 01.122-.166l-.632-.775zm-.442.635c-.242.723-.608 2.037-1.853 2.55l.38.924c1.744-.717 2.218-2.551 2.421-3.157l-.948-.317zm-1.85 2.548c-.74.299-1.696.36-2.815.358-1.084-.003-2.329-.069-3.499.026l.08.997c1.116-.09 2.26-.026 3.416-.023 1.12.003 2.252-.052 3.192-.43l-.374-.928zm-6.316.384c-.612.052-1.36.176-2.085.63-.732.457-1.392 1.22-1.894 2.46l.928.375c.437-1.083.975-1.662 1.496-1.988.529-.33 1.09-.434 1.64-.48l-.085-.997zm-3.979 3.09c-.82 2.023-1.265 3.764-1.097 6.006l.997-.075c-.153-2.037.242-3.618 1.027-5.555l-.927-.376zm-3.353-14.51l-.49-.098a.027.027 0 00-.001.005l-.002.008a2.171 2.171 0 00-.02.125 5.626 5.626 0 00.005 1.46c.122.896.507 2.042 1.566 2.95l.651-.758c-.819-.703-1.126-1.592-1.226-2.328a4.627 4.627 0 01-.005-1.186l.01-.065.002-.014V8.49v.001l-.49-.098zm1.058 4.45c.478.411.913.749 1.278 1.04.371.295.662.534.885.768.22.229.358.434.437.65.079.215.112.475.07.831l.993.118c.057-.48.019-.903-.123-1.292-.142-.387-.374-.707-.655-1-.276-.288-.616-.565-.984-.858-.375-.298-.79-.62-1.25-1.015l-.651.759zm2.67 3.29c-.076.64-.492 1.164-1.083 1.521-.596.36-1.304.51-1.84.44l-.129.991c.787.103 1.721-.112 2.487-.575.772-.467 1.436-1.229 1.558-2.26l-.993-.118zm-2.922 1.96c-.63-.081-1.18-.209-1.745-.51-.569-.302-1.185-.796-1.917-1.655l-.761.649c.788.924 1.499 1.512 2.209 1.89.712.378 1.392.528 2.084.618l.13-.991zM8.822 15.93c-.978-1.153-1.382-2.667-1.533-3.934a11.547 11.547 0 01-.057-2.038 5.685 5.685 0 01.012-.149l.001-.006V9.8l-.497-.055a69.654 69.654 0 00-.497-.055v.001a.396.396 0 01-.002.015 3.897 3.897 0 00-.015.18 12.548 12.548 0 00.062 2.226c.162 1.355.603 3.095 1.763 4.463l.763-.647zM27.716 2.846C27.686 1.543 26.65.464 25.314.464v1c.766 0 1.384.619 1.403 1.406l1-.024zM25.314.464a2.4 2.4 0 00-2.402 2.394h1a1.4 1.4 0 011.402-1.394v-1zm-2.402 2.394V2.987h1v-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.002-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.002-.001-.001-.001-.002-.001-.002-.001-.002-.001-.001-.002-.001-.002-.001-.001-.001V2.9v-.001-.001-.001-.002-.001-.001-.001-.001-.002-.001-.001-.001-.001-.001-.001-.002-.002-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.002-.002-.002-.002-.002h-1V2.987h1v-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.002-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.002-.001-.001-.001-.002-.001-.002-.001-.002-.001-.001-.002-.001-.002-.001-.001-.001V2.9v-.001-.001-.001-.002-.001-.001-.001-.001-.002-.001-.001-.001-.001-.001-.001-.002-.002-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.002-.002-.002-.002-.002h-1zm1 0A2.399 2.399 0 0021.51.464v1c.775 0 1.402.627 1.402 1.394h1zM21.51.464a2.399 2.399 0 00-2.403 2.394h1c0-.767.627-1.394 1.403-1.394v-1zm-2.403 2.394c0 .659.232 1.181.687 1.678l.738-.675c-.31-.34-.425-.628-.425-1.003h-1zm.687 1.678c.262.286 1.66 1.775 2.537 2.71l.73-.684a724.184 724.184 0 01-2.53-2.7l-.737.674zm4.724 2.709a2310.776 2310.776 0 012.507-2.665l.019-.02.006-.007-.705-.709a650.15 650.15 0 00-2.557 2.717l.73.684zm2.575-2.74c.106-.137.64-.69.623-1.655l-1 .016c.01.561-.273.844-.414 1.027l.791.611zm-4.762 2.741c.593.632 1.595.63 2.187-.001l-.73-.684a.499.499 0 01-.728 0l-.729.685z",
    fill: "currentColor"
  }));
}

var MemoSvgPets = /*#__PURE__*/React.memo(SvgPets);

function SvgPhoneCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.05 6l.191-.981a1 1 0 00-.898 1.688L14.05 6zM18 9.95l-.707.707a1 1 0 001.688-.898L18 9.95zM14.05 2l.11-.994a1 1 0 00-.817 1.702L14.05 2zM22 9.94l-.707.708a1 1 0 001.7-.82L22 9.94zm-1 10.98h-1v.004l1-.004zm-2.18 2l-.108.994.018.002.09-.996zm-8.63-3.07l.544-.84-.008-.004-.536.844zm-6-6l.844-.536-.005-.008-.84.544zM1.12 5.18l-.996.09.002.016.994-.106zM3.11 3V2h-.001v1zm3 0v1h.01l-.01-1zm2 1.72l.991-.13v-.01l-.991.14zm.7 2.81l-.937.35v.002l.937-.352zm-.45 2.11l.707.707.004-.004-.711-.703zm-1.27 1.27l-.707-.707a1 1 0 00-.162 1.201l.869-.494zm6 6l-.494.87a1 1 0 001.201-.163l-.707-.707zm1.27-1.27l-.703-.711-.004.004.707.707zm2.11-.45l-.352.936h.002l.35-.936zm2.81.7l.14-.99-.01-.001-.13.991zm-5.422-8.909a4 4 0 013.16 3.16l1.963-.382a6 6 0 00-4.74-4.74l-.383 1.962zm4.849 2.262l-3.95-3.95-1.414 1.414 3.95 3.95 1.414-1.414zm-4.768-6.25a8 8 0 017.067 7.059l1.988-.224a10 10 0 00-8.834-8.822l-.22 1.988zm8.768 6.24l-7.95-7.94-1.414 1.415 7.95 7.94 1.414-1.416zM20 17.92v3h2v-3h-2zm0 3.004a1 1 0 01-.324.741l1.352 1.474A3 3 0 0022 20.916l-2 .008zm-.324.741a1 1 0 01-.766.26l-.18 1.99a3 3 0 002.298-.776l-1.352-1.474zm-.748.26a18.791 18.791 0 01-8.194-2.914l-1.088 1.678a20.79 20.79 0 009.066 3.225l.216-1.988zm-8.202-2.919a18.5 18.5 0 01-5.692-5.692l-1.688 1.072a20.5 20.5 0 006.308 6.308l1.072-1.688zm-5.697-5.7a18.79 18.79 0 01-2.915-8.232l-1.988.212a20.79 20.79 0 003.225 9.108l1.678-1.088zM2.116 5.09a1 1 0 01.257-.764L.896 2.977A3 3 0 00.124 5.27l1.992-.18zm.257-.764A1 1 0 013.111 4l-.002-2a3 3 0 00-2.213.977l1.477 1.349zM3.11 4h3V2h-3v2zm3.01 0a1 1 0 011 .86l1.98-.28A3 3 0 006.1 2l.02 2zm.999.85c.136 1.036.39 2.052.754 3.03l1.874-.7A11.84 11.84 0 019.1 4.59l-1.982.26zm.755 3.032a1 1 0 01-.225 1.055l1.422 1.406a3 3 0 00.675-3.165l-1.872.704zm-.221 1.05l-1.27 1.27 1.414 1.415 1.27-1.27-1.414-1.414zM6.22 11.405a17 17 0 006.375 6.375l.988-1.738a15 15 0 01-5.625-5.625l-1.738.988zm7.576 6.213l1.27-1.27-1.414-1.414-1.27 1.27 1.414 1.414zm1.266-1.266a1 1 0 011.055-.225l.704-1.872a3 3 0 00-3.165.675l1.406 1.422zm1.057-.224c.978.365 1.994.618 3.03.754l.26-1.982a11.843 11.843 0 01-2.59-.646l-.7 1.874zm3.02.753a1 1 0 01.86 1.015l2 .05a3 3 0 00-2.58-3.045l-.28 1.98z",
    fill: "currentColor"
  }));
}

var MemoSvgPhoneCall = /*#__PURE__*/React.memo(SvgPhoneCall);

function SvgPhoneForwarded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 2l4 4-4 4M14 6h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 17.92v3a2 2 0 01-2.18 2 19.791 19.791 0 01-8.63-3.07 19.502 19.502 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 013.11 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0121 17.92z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPhoneForwarded = /*#__PURE__*/React.memo(SvgPhoneForwarded);

function SvgPhoneIncoming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 3v6h6M22 2l-7 7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 17.92v3a2 2 0 01-2.18 2 19.791 19.791 0 01-8.63-3.07 19.502 19.502 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 013.11 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0121 17.92z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPhoneIncoming = /*#__PURE__*/React.memo(SvgPhoneIncoming);

function SvgPhoneMissed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 2l-6 6M16 2l6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 17.92v3a2 2 0 01-2.18 2 19.791 19.791 0 01-8.63-3.07 19.502 19.502 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 013.11 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0121 17.92z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPhoneMissed = /*#__PURE__*/React.memo(SvgPhoneMissed);

function SvgPhoneOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.387 12.603a1 1 0 00-1.414 1.414l1.414-1.414zm2.703 3.307l-.494.87a1 1 0 001.201-.163l-.707-.707zm1.27-1.27l-.703-.711-.004.004.707.707zm2.11-.45l-.352.936h.002l.35-.936zm2.81.7l.14-.99-.01-.001-.13.991zm1.72 2l-1-.01v.01h1zm0 3h-1v.004l1-.004zm-2.18 2l-.108.994.018.002.09-.996zm-8.63-3.07l.544-.84-.008-.004-.536.844zm-2.623-3.377a1 1 0 10-1.415 1.414l1.415-1.414zm-4.216-2.089a1 1 0 101.678-1.088l-1.678 1.088zM2.12 4.18l-.996.09a.99.99 0 00.002.018l.994-.108zM4.11 2V1h-.001v1zm3 0v1h.01l-.01-1zm2 1.72l.991-.13v-.01l-.991.14zm.7 2.81l-.937.35v.002l.937-.352zm-.45 2.11l.707.707.004-.004-.711-.703zm-1.977.563a1 1 0 001.414 1.414L7.383 9.203zm2.59 4.814a17.003 17.003 0 003.623 2.762l.988-1.738a15.004 15.004 0 01-3.197-2.438l-1.414 1.414zm4.824 2.6l1.27-1.27-1.414-1.414-1.27 1.27 1.414 1.414zm1.266-1.266a1 1 0 011.055-.225l.704-1.872a3 3 0 00-3.165.675l1.406 1.422zm1.057-.224c.978.365 1.994.618 3.03.754l.26-1.982a11.843 11.843 0 01-2.59-.646l-.7 1.874zm3.02.753a1 1 0 01.86 1l2 .02a3 3 0 00-2.58-3l-.28 1.98zm.86 1.01v3h2v-3h-2zm0 3.004a1 1 0 01-.324.741l1.352 1.474A3 3 0 0023 19.886l-2 .008zm-.324.741a1 1 0 01-.766.259l-.18 1.992a3 3 0 002.298-.777l-1.352-1.474zm-.748.26a18.79 18.79 0 01-8.194-2.914l-1.088 1.678a20.79 20.79 0 009.066 3.225l.216-1.988zm-8.202-2.92a18.425 18.425 0 01-3.159-2.532l-1.415 1.414a20.426 20.426 0 003.502 2.807l1.072-1.688zm-5.697-5.71a18.79 18.79 0 01-2.915-8.193l-1.988.216a20.79 20.79 0 003.225 9.066l1.678-1.088zM3.116 4.09a1 1 0 01.257-.764L1.896 1.977a3 3 0 00-.772 2.293l1.992-.18zm.257-.764A1 1 0 014.111 3l-.002-2a3 3 0 00-2.213.977l1.477 1.349zM4.11 3h3V1h-3v2zm3.01 0a1 1 0 011 .86l1.98-.28A3 3 0 007.1 1l.02 2zm.999.85c.136 1.036.39 2.052.754 3.03l1.874-.7a11.841 11.841 0 01-.646-2.59l-1.982.26zm.755 3.032a1 1 0 01-.225 1.055l1.422 1.406a3 3 0 00.675-3.165l-1.872.704zm-.221 1.05l-1.27 1.27 1.414 1.415 1.27-1.27-1.414-1.414z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 1L1 23",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPhoneOff = /*#__PURE__*/React.memo(SvgPhoneOff);

function SvgPhoneOutgoing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 8V2h-6M15 9l7-7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 17.92v3a2 2 0 01-2.18 2 19.791 19.791 0 01-8.63-3.07 19.502 19.502 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 013.11 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0121 17.92z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPhoneOutgoing = /*#__PURE__*/React.memo(SvgPhoneOutgoing);

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 16.92v3a2 2 0 01-2.18 2 19.791 19.791 0 01-8.63-3.07 19.502 19.502 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 013.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0121 16.92z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPhone = /*#__PURE__*/React.memo(SvgPhone);

function SvgPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.21 15.89A10 10 0 118 2.83",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22 12A10 10 0 0012 2v10h10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPieChart = /*#__PURE__*/React.memo(SvgPieChart);

function SvgPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9 8.91v6.39H8.1V8.91A4.502 4.502 0 019 0a4.5 4.5 0 01.9 8.91zm-3.6 2.032v1.824c-2.64.33-4.5 1.082-4.5 1.634 0 .726 3.221 1.8 7.2 1.8s7.2-1.074 7.2-1.8c0-.552-1.86-1.304-4.5-1.634v-1.824c3.65.4 6.3 1.63 6.3 3.458 0 2.256-4.032 3.6-9 3.6s-9-1.344-9-3.6c0-1.829 2.65-3.058 6.3-3.458zM11.7 4.5a2.7 2.7 0 11-5.4 0 2.7 2.7 0 015.4 0z",
    fill: "currentColor"
  }));
}

var MemoSvgPlace = /*#__PURE__*/React.memo(SvgPlace);

function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 8l6 4-6 4V8v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPlayCircle = /*#__PURE__*/React.memo(SvgPlayCircle);

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5 3l14 9-14 9V3v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPlay = /*#__PURE__*/React.memo(SvgPlay);

function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v8M8 12h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPlusCircle = /*#__PURE__*/React.memo(SvgPlusCircle);

function SvgPlusSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v8M8 12h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPlusSquare = /*#__PURE__*/React.memo(SvgPlusSquare);

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v14M5 12h14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPlus = /*#__PURE__*/React.memo(SvgPlus);

function SvgPocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 3h16a2 2 0 012 2v6c0 5.523-4.477 10-10 10A10 10 0 012 11V5a2 2 0 012-2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10l4 4 4-4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPocket = /*#__PURE__*/React.memo(SvgPocket);

function SvgPool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 18.996c1.313 1.213 4.858 3.275 8.535 1.82 1.039-.412 1.876-.761 2.626-1.027m24.948 1.026c-5.252-2.426-8.316-2.224-9.191-1.82-3.11 1.437-4.973 1.855-5.909 1.893m6.073-16.45c0-1.177-.952-4.004-4.103-3.034-.657.202-1.97.607-1.97 3.033v4.247m0 12.204c-.328.013-.46 0-.656-.073-5.082-1.878-6.624-1.939-9.192-1.027m9.848 1.1V14.75m0-6.065h-9.848m9.848 0v6.066m-9.848-6.066V4.437c0-1.31.056-1.902.46-2.372.468-.547 1.191-.808 1.897-.954 3.201-.663 3.408 1.807 3.408 3.279m-5.765 4.294v6.066m9.848 0h-9.848m0 0v5.038",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgPool = /*#__PURE__*/React.memo(SvgPool);

function SvgPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.36 6.64a9 9 0 01-.001 12.727A9 9 0 015.63 6.64M12 2v10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPower = /*#__PURE__*/React.memo(SvgPower);

function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 14h12v8H6v-8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPrinter = /*#__PURE__*/React.memo(SvgPrinter);

function SvgRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 14a2 2 0 100-4 2 2 0 000 4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.947 7.052a1 1 0 00-1.414 1.415l1.414-1.415zm-1.414 8.49a1 1 0 001.414 1.415l-1.414-1.415zm-8.48 1.406a1 1 0 001.414-1.415l-1.414 1.415zm1.414-8.49a1 1 0 10-1.414-1.416l1.414 1.415zm11.31-4.235a1 1 0 00-1.414 1.414l1.414-1.414zm-1.414 14.14a1 1 0 001.414 1.414l-1.414-1.414zm-14.14 1.414a1 1 0 101.414-1.414l-1.414 1.414zm1.414-14.14a1 1 0 00-1.414-1.414l1.414 1.414zm9.896 2.83A5 5 0 0117 12.005h2a7 7 0 00-2.053-4.953l-1.414 1.415zM17 12.005a5 5 0 01-1.467 3.537l1.414 1.415A7 7 0 0019 12.005h-2zm-8.533 3.527A5 5 0 017 11.995H5a7 7 0 002.053 4.953l1.414-1.415zM7 11.995a5 5 0 011.467-3.538L7.053 7.042A7 7 0 005 11.995h2zm11.363-6.358a9 9 0 010 12.726l1.414 1.414c4.294-4.296 4.294-11.259 0-15.554l-1.414 1.414zM5.637 18.363a9 9 0 010-12.726L4.223 4.223c-4.294 4.295-4.294 11.259 0 15.554l1.414-1.414z",
    fill: "currentColor"
  }));
}

var MemoSvgRadio = /*#__PURE__*/React.memo(SvgRadio);

function SvgRefreshCcw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 4v6h6M23 20v-6h-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.547 9.334a1 1 0 101.886-.668l-1.886.668zM5.64 5.64l.685.729a.985.985 0 00.022-.022L5.64 5.64zM.315 9.271a1 1 0 001.37 1.458L.315 9.27zm23.37 5.458a1 1 0 00-1.37-1.458l1.37 1.458zM18.36 18.36l-.685-.729a1.162 1.162 0 00-.022.022l.707.707zM4.453 14.666a1 1 0 00-1.886.668l1.886-.668zm16.98-6a10 10 0 00-7.22-6.417l-.442 1.95a8 8 0 015.776 5.135l1.886-.668zm-7.22-6.417a10 10 0 00-9.28 2.684l1.414 1.414A8 8 0 0113.771 4.2l.441-1.951zM4.954 4.91l-4.64 4.36 1.37 1.458 4.64-4.36-1.37-1.458zm17.36 8.36l-4.64 4.36 1.37 1.458 4.64-4.36-1.37-1.458zm-4.662 4.382a8 8 0 01-7.424 2.147l-.441 1.951a10 10 0 009.28-2.684l-1.415-1.414zM10.229 19.8a8 8 0 01-5.776-5.134l-1.886.668a10 10 0 007.22 6.417l.442-1.95z",
    fill: "currentColor"
  }));
}

var MemoSvgRefreshCcw = /*#__PURE__*/React.memo(SvgRefreshCcw);

function SvgRefreshCw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 4v6h-6M1 20v-6h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.567 8.666a1 1 0 001.886.668l-1.886-.668zM18.36 5.64l-.707.707.022.022.685-.729zm3.955 5.089a1 1 0 001.37-1.458l-1.37 1.458zM1.685 13.27a1 1 0 00-1.37 1.458l1.37-1.458zM5.64 18.36l.707-.707a1.082 1.082 0 00-.022-.022l-.685.729zm15.793-3.026a1 1 0 10-1.886-.668l1.886.668zm-16.98-6A8 8 0 0110.229 4.2l-.441-1.951a10 10 0 00-7.22 6.417l1.885.668zM10.229 4.2a8 8 0 017.424 2.147l1.414-1.414a10 10 0 00-9.28-2.684l.442 1.95zm7.446 2.169l4.64 4.36 1.37-1.458-4.64-4.36-1.37 1.458zm-17.36 8.36l4.64 4.36 1.37-1.458-4.64-4.36-1.37 1.458zm4.618 4.338a10 10 0 009.28 2.684l-.442-1.95a8 8 0 01-7.424-2.148l-1.414 1.414zm9.28 2.684a10 10 0 007.22-6.417l-1.886-.668a8 8 0 01-5.776 5.134l.441 1.951z",
    fill: "currentColor"
  }));
}

var MemoSvgRefreshCw = /*#__PURE__*/React.memo(SvgRefreshCw);

function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 1l4 4-4 4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13v2a4 4 0 01-4 4H3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgRepeat = /*#__PURE__*/React.memo(SvgRepeat);

function SvgRewind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 19l-9-7 9-7v14zM22 19l-9-7 9-7v14z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgRewind = /*#__PURE__*/React.memo(SvgRewind);

function SvgRotateCcw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 4v6h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51 15a9 9 0 102.13-9.36L2 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgRotateCcw = /*#__PURE__*/React.memo(SvgRotateCcw);

function SvgRotateCw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 4v6h-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.49 15a9 9 0 11-2.12-9.36L22 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgRotateCw = /*#__PURE__*/React.memo(SvgRotateCw);

function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21v-8H7v8M7 3v5h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSave = /*#__PURE__*/React.memo(SvgSave);

function SvgScissors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 9a3 3 0 100-6 3 3 0 000 6zM6 21a3 3 0 100-6 3 3 0 000 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgScissors = /*#__PURE__*/React.memo(SvgScissors);

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.5 18a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-5.2-5.2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSearch = /*#__PURE__*/React.memo(SvgSearch);

function SvgServer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 4a2 2 0 012-2h16a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2V4zM2 16a2 2 0 012-2h16a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgServer = /*#__PURE__*/React.memo(SvgServer);

function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 15a3 3 0 100-6 3 3 0 000 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-1.415 3.417 2 2 0 01-1.415-.587l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-3.417-1.415 2 2 0 01.587-1.415l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9c.26.604.852.997 1.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSettings = /*#__PURE__*/React.memo(SvgSettings);

function SvgShare2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 8a3 3 0 100-6 3 3 0 000 6zM6 15a3 3 0 100-6 3 3 0 000 6zM18 22a3 3 0 100-6 3 3 0 000 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgShare2 = /*#__PURE__*/React.memo(SvgShare2);

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgShare = /*#__PURE__*/React.memo(SvgShare);

function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22s8-4 8-10V4l-8-2-8 2v8c0 6 8 10 8 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgShield = /*#__PURE__*/React.memo(SvgShield);

function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 23a2 2 0 100-4 2 2 0 000 4zM20 23a2 2 0 100-4 2 2 0 000 4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67 6H23l-1.68 8.39a2 2 0 01-2 1.61H8.75a2 2 0 01-2-1.74L5.23 2.74A2 2 0 003.25 1H1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgShoppingCart = /*#__PURE__*/React.memo(SvgShoppingCart);

function SvgShuffle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 3h5v5M3 20L20 3M20 16v5h-5M14 15l6 6M3 4l5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgShuffle = /*#__PURE__*/React.memo(SvgShuffle);

function SvgSidebar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3v18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSidebar = /*#__PURE__*/React.memo(SvgSidebar);

function SvgSkipBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 20L9 12l10-8v16z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19V5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSkipBack = /*#__PURE__*/React.memo(SvgSkipBack);

function SvgSkipForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 4l10 8-10 8V4v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5v14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSkipForward = /*#__PURE__*/React.memo(SvgSkipForward);

function SvgSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22.08 10C19.81 2.41 16.54.65 9 2.92 1.46 5.19-.35 8.46 1.92 16c2.27 7.54 5.54 9.35 13.08 7.08 7.54-2.27 9.35-5.54 7.08-13.08z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.57 6.99l3.58 10.4M7.85 8.61l3.58 10.4M16.39 8.85l-10.4 3.58M18.01 13.57l-10.4 3.58",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSlack = /*#__PURE__*/React.memo(SvgSlack);

function SvgSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93 4.93l14.14 14.14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSlash = /*#__PURE__*/React.memo(SvgSlash);

function SvgSliders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSliders = /*#__PURE__*/React.memo(SvgSliders);

function SvgSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5 4a2 2 0 012-2h10a2 2 0 012 2v16a2 2 0 01-2 2H7a2 2 0 01-2-2V4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgSmartphone = /*#__PURE__*/React.memo(SvgSmartphone);

function SvgSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 4a2 2 0 012-2h12a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 18a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgSpeaker = /*#__PURE__*/React.memo(SvgSpeaker);

function SvgSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSquare = /*#__PURE__*/React.memo(SvgSquare);

function SvgStaging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5V2a1 1 0 00-1-1h-8.5M20 15.5h12a1 1 0 011 1v.5a1 1 0 01-1 1H15.5m4.5-2.5h-4.5a1 1 0 00-1 1v.5a1 1 0 001 1m0 0v5.5m16.5 0v5a1 1 0 01-1 1m1-6v-5m0 5H15.5m0 0v5a1 1 0 001 1m2.5 0v2a1 1 0 01-1 1h-1.5m2.5-3h-2.5m2.5 0h9.5m-12 0v3m0 0h-6m18-3v2a1 1 0 001 1h.5a1 1 0 001-1v-2m-2.5 0H31M10.5 1H2a1 1 0 00-1 1v23m9.5-24v24m0 7.5H2a1 1 0 01-1-1V25m9.5 7.5V25M1 25h9.5M8 11v2.5m5.5-2.5v2.5m9 7H25M22.5 26H25M5 28.5h2",
    stroke: "currentColor"
  }));
}

var MemoSvgStaging = /*#__PURE__*/React.memo(SvgStaging);

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgStar = /*#__PURE__*/React.memo(SvgStar);

function SvgStopCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9 9h6v6H9V9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgStopCircle = /*#__PURE__*/React.memo(SvgStopCircle);

function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 17a5 5 0 100-10 5 5 0 000 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSun = /*#__PURE__*/React.memo(SvgSun);

function SvgSunrise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 17a5 5 0 00-10 0M12 1v7M4.22 9.22l1.42 1.42M1 17h2M21 17h2M18.36 10.64l1.42-1.42M23 21H1M8 5l4-4 4 4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSunrise = /*#__PURE__*/React.memo(SvgSunrise);

function SvgSunset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 17a5 5 0 00-10 0M12 8V1M4.22 9.22l1.42 1.42M1 17h2M21 17h2M18.36 10.64l1.42-1.42M23 21H1M16 4l-4 4-4-4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSunset = /*#__PURE__*/React.memo(SvgSunset);

function SvgTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20 20a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2h12a2 2 0 012 2v16z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgTablet = /*#__PURE__*/React.memo(SvgTablet);

function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 1.5,
    fill: "currentColor"
  }));
}

var MemoSvgTag = /*#__PURE__*/React.memo(SvgTag);

function SvgTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 18a6 6 0 100-12 6 6 0 000 12z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 14a2 2 0 100-4 2 2 0 000 4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgTarget = /*#__PURE__*/React.memo(SvgTarget);

function SvgThermometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 14.76V3.5a2.5 2.5 0 00-5 0v11.26a4.5 4.5 0 105 0v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgThermometer = /*#__PURE__*/React.memo(SvgThermometer);

function SvgThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 15h1a1 1 0 00-1-1v1zm3 7v1a1 1 0 00.914-.594L13 22zm4-9l.914.406A1 1 0 0018 13h-1zm0-11h1a1 1 0 00-1-1v1zM5.72 2l-.011 1h.011V2zm-2 1.7l.988.152V3.85L3.72 3.7zm-1.38 9l-.988-.152v.002l.988.15zm2 2.3v-1h-.011l.011 1zM17 2V1a1 1 0 00-1 1h1zm2.67 0v1a.95.95 0 00.018 0l-.018-1zM22 4h1c0-.045-.003-.09-.009-.134L22 4zm0 7l.991.134c.006-.044.009-.09.009-.134h-1zm-2.33 2l.018-1h-.018v1zM17 13h-1a1 1 0 001 1v-1zm-8 2v4h2v-4H9zm0 4a4 4 0 004 4v-2a2 2 0 01-2-2H9zm4.914 3.406l4-9-1.828-.812-4 9 1.828.812zM18 13V2h-2v11h2zM17 1H5.72v2H17V1zM5.731 1a3 3 0 00-3 2.55l1.978.3a1 1 0 011-.85l.022-2zm-3 2.548l-1.38 9 1.977.304 1.38-9-1.976-.304zm-1.38 9.002a3 3 0 00.703 2.419l1.509-1.313a1 1 0 01-.234-.806l-1.978-.3zm.703 2.419a3 3 0 002.297 1.03L4.33 14a1 1 0 01-.766-.344l-1.51 1.313zM4.34 16H10v-2H4.34v2zM17 3h2.67V1H17v2zm2.688 0a1.31 1.31 0 011.321 1.134l1.982-.268A3.31 3.31 0 0019.652 1l.036 2zM21 4v7h2V4h-2zm.01 6.866A1.31 1.31 0 0119.687 12l-.036 2a3.31 3.31 0 003.339-2.866l-1.982-.268zM19.67 12H17v2h2.67v-2zM18 13V2h-2v11h2z",
    fill: "currentColor"
  }));
}

var MemoSvgThumbsDown = /*#__PURE__*/React.memo(SvgThumbsDown);

function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 9h-1a1 1 0 001 1V9zm0-4h1-1zm-3-3V1a1 1 0 00-.914.594L11 2zm-4 9l-.914-.406A1 1 0 006 11h1zm0 11H6a1 1 0 001 1v-1zm11.28 0l.011-1h-.011v1zm2-1.7l-.988-.152v.002l.988.15zm1.38-9l.988.152v-.002l-.988-.15zm-2-2.3v1h.011l-.011-1zM7 22v1a1 1 0 001-1H7zm0-11h1a1 1 0 00-1-1v1zm8-2V5h-2v4h2zm0-4a4 4 0 00-4-4v2a2 2 0 012 2h2zm-4.914-3.406l-4 9 1.828.812 4-9-1.828-.812zM6 11v11h2V11H6zm1 12h11.28v-2H7v2zm11.269 0a3 3 0 003-2.55l-1.978-.3a1 1 0 01-1 .85l-.022 2zm3-2.548l1.38-9-1.977-.304-1.38 9 1.976.304zm1.38-9.002a3 3 0 00-.703-2.419l-1.509 1.313a1 1 0 01.234.806l1.978.3zm-.703-2.419a3 3 0 00-2.297-1.03L19.67 10a1 1 0 01.766.344l1.51-1.313zM19.66 8H14v2h5.66V8zM7 21H4v2h3v-2zm-3 0a1 1 0 01-1-1H1a3 3 0 003 3v-2zm-1-1v-7H1v7h2zm0-7a1 1 0 011-1v-2a3 3 0 00-3 3h2zm1-1h3v-2H4v2zm2-1v11h2V11H6z",
    fill: "currentColor"
  }));
}

var MemoSvgThumbsUp = /*#__PURE__*/React.memo(SvgThumbsUp);

function SvgToggleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 12a7 7 0 017-7h8a7 7 0 017 7v0a7 7 0 01-7 7H8a7 7 0 01-7-7v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 15a3 3 0 100-6 3 3 0 000 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgToggleLeft = /*#__PURE__*/React.memo(SvgToggleLeft);

function SvgToggleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 12a7 7 0 017-7h8a7 7 0 017 7v0a7 7 0 01-7 7H8a7 7 0 01-7-7v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 15a3 3 0 100-6 3 3 0 000 6z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgToggleRight = /*#__PURE__*/React.memo(SvgToggleRight);

function SvgTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.07 0H3.598A3.6 3.6 0 000 3.597V21.07a3.6 3.6 0 003.597 3.597h.875L2.59 31.729l.989.271.309-1.16H20.78L21.09 32l.995-.265-1.883-7.061h.875a3.6 3.6 0 003.597-3.597V3.597A3.61 3.61 0 0021.071 0zm-.566 29.814H4.164l.548-2.053h15.244l.548 2.053zM4.983 26.728l.548-2.054h13.606l.548 2.054H4.983zM23.64 21.07a2.573 2.573 0 01-2.57 2.57H3.597a2.573 2.573 0 01-2.57-2.57V3.597a2.573 2.573 0 012.57-2.57H21.07a2.573 2.573 0 012.57 2.57V21.07z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.57 2.96H4.117c-.85 0-1.544.84-1.544 1.87v7.473c0 1.03.693 1.87 1.544 1.87h16.447c.85 0 1.543-.84 1.543-1.87V4.831c0-1.03-.686-1.87-1.537-1.87zm-8.737 9.961H4.117c-.284.008-.51-.274-.51-.618V4.831c0-.344.232-.626.516-.626h7.71v8.716zm9.254-.618h-.007c0 .344-.233.626-.516.626H12.86V4.205h7.71c.284 0 .517.282.517.626v7.472zM7.194 16.447a2.573 2.573 0 00-2.57 2.57 2.573 2.573 0 002.57 2.57 2.573 2.573 0 002.57-2.57 2.573 2.573 0 00-2.57-2.57zm0 4.114c-.85 0-1.544-.693-1.544-1.544 0-.85.693-1.543 1.544-1.543.85 0 1.543.693 1.543 1.543s-.693 1.544-1.543 1.544zM17.474 16.447a2.573 2.573 0 00-2.57 2.57 2.573 2.573 0 002.57 2.57 2.573 2.573 0 002.57-2.57 2.573 2.573 0 00-2.57-2.57zm0 4.114c-.85 0-1.543-.693-1.543-1.544 0-.85.693-1.543 1.543-1.543s1.543.693 1.543 1.543-.692 1.544-1.543 1.544z",
    fill: "currentColor"
  }));
}

var MemoSvgTrain = /*#__PURE__*/React.memo(SvgTrain);

function SvgTrash2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6a1 1 0 10-2 0h2zM6 6a1 1 0 00-2 0h2zm1 0a1 1 0 002 0H7zm8 0a1 1 0 102 0h-2zm3 0v14h2V6h-2zm0 14a1 1 0 01-1 1v2a3 3 0 003-3h-2zm-1 1H7v2h10v-2zM7 21a1 1 0 01-1-1H4a3 3 0 003 3v-2zm-1-1V6H4v14h2zM9 6V4H7v2h2zm0-2a1 1 0 011-1V1a3 3 0 00-3 3h2zm1-1h4V1h-4v2zm4 0a1 1 0 011 1h2a3 3 0 00-3-3v2zm1 1v2h2V4h-2z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11v6M14 11v6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgTrash2 = /*#__PURE__*/React.memo(SvgTrash2);

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6a1 1 0 10-2 0h2zM6 6a1 1 0 00-2 0h2zm1 0a1 1 0 002 0H7zm8 0a1 1 0 102 0h-2zm3 0v14h2V6h-2zm0 14a1 1 0 01-1 1v2a3 3 0 003-3h-2zm-1 1H7v2h10v-2zM7 21a1 1 0 01-1-1H4a3 3 0 003 3v-2zm-1-1V6H4v14h2zM9 6V4H7v2h2zm0-2a1 1 0 011-1V1a3 3 0 00-3 3h2zm1-1h4V1h-4v2zm4 0a1 1 0 011 1h2a3 3 0 00-3-3v2zm1 1v2h2V4h-2z",
    fill: "currentColor"
  }));
}

var MemoSvgTrash = /*#__PURE__*/React.memo(SvgTrash);

function SvgTrendingDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 18l-9.5-9.5-5 5L1 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18h6v-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgTrendingDown = /*#__PURE__*/React.memo(SvgTrendingDown);

function SvgTrendingUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 6l-9.5 9.5-5-5L1 18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6h6v6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgTrendingUp = /*#__PURE__*/React.memo(SvgTrendingUp);

function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgTriangle = /*#__PURE__*/React.memo(SvgTriangle);

function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 9a2 2 0 012-2h16a2 2 0 012 2v11a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2l-5 5-5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgTv = /*#__PURE__*/React.memo(SvgTv);

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5 0-.279-.028-.556-.08-.83A7.72 7.72 0 0023 3z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgTwitter = /*#__PURE__*/React.memo(SvgTwitter);

function SvgType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 6V3h16v3M9 19h6M12 3v16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgType = /*#__PURE__*/React.memo(SvgType);

function SvgUmbrella(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 12v1a1 1 0 00.995-1.095L23 12zM1 12l-.995-.095A1 1 0 001 13v-1zm17 7h1a1 1 0 00-.24-.65L18 19zm-6-7l.76-.65A1 1 0 0011 12h1zm11.995-.095A12.05 12.05 0 0012 1v2a10.05 10.05 0 0110.005 9.095l1.99-.19zM12 1A12.05 12.05 0 00.005 11.905l1.99.19A10.05 10.05 0 0112 3V1zM1 13h22v-2H1v2zm16 6a2 2 0 01-2 2v2a4 4 0 004-4h-2zm-2 2a2 2 0 01-2-2h-2a4 4 0 004 4v-2zm-2-2v-7h-2v7h2zm-1.76-6.35l6 7 1.52-1.3-6-7-1.52 1.3z",
    fill: "currentColor"
  }));
}

var MemoSvgUmbrella = /*#__PURE__*/React.memo(SvgUmbrella);

function SvgUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 2v7a6 6 0 0012 0V2M4 20h16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUnderline = /*#__PURE__*/React.memo(SvgUnderline);

function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 13a2 2 0 012-2h14a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 019.9-1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUnlock = /*#__PURE__*/React.memo(SvgUnlock);

function SvgUploadCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 16l-4-4-4 4M13 12v9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.39 18.39A5 5 0 0019 9h-1.26A8 8 0 104 16.3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16l-4-4-4 4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUploadCloud = /*#__PURE__*/React.memo(SvgUploadCloud);

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 17v3a2 2 0 002 2h14a2 2 0 002-2v-3M16 6l-4-4-4 4M12 2v14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUpload = /*#__PURE__*/React.memo(SvgUpload);

function SvgUserCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.5 11a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11l2 2 4-4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUserCheck = /*#__PURE__*/React.memo(SvgUserCheck);

function SvgUserMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.5 11a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 11h-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUserMinus = /*#__PURE__*/React.memo(SvgUserMinus);

function SvgUserPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.5 11a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8v6M23 11h-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUserPlus = /*#__PURE__*/React.memo(SvgUserPlus);

function SvgUserX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.5 11a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8l5 5M23 8l-5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUserX = /*#__PURE__*/React.memo(SvgUserX);

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 11a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUser = /*#__PURE__*/React.memo(SvgUser);

function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9 11a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUsers = /*#__PURE__*/React.memo(SvgUsers);

function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 16a1 1 0 10-2 0h2zM1 17H0h1zM5 6a1 1 0 000-2v2zm5.66-2a1 1 0 100 2V4zM16 10.34h-1a1 1 0 00.293.707L16 10.34zm1 1l-.707.707a1 1 0 001.293.103L17 11.34zM23 7h1a1 1 0 00-1.586-.81L23 7zm-1 10a1 1 0 102 0h-2zm-7-1v1h2v-1h-2zm0 1a1 1 0 01-1 1v2a3 3 0 003-3h-2zm-1 1H3v2h11v-2zM3 18a1 1 0 01-1-1H0a3 3 0 003 3v-2zm-1-1V7H0v10h2zM2 7a1 1 0 011-1V4a3 3 0 00-3 3h2zm1-1h2V4H3v2zm7.66 0H14V4h-3.34v2zM14 6a1 1 0 011 1h2a3 3 0 00-3-3v2zm1 1v3.34h2V7h-2zm.293 4.047l1 1 1.414-1.414-1-1-1.414 1.414zm2.293 1.103l6-4.34-1.172-1.62-6 4.34 1.172 1.62zM22 7v10h2V7h-2z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1l22 22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgVideoOff = /*#__PURE__*/React.memo(SvgVideoOff);

function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23 7l-7 5 7 5V7zM1 7a2 2 0 012-2h11a2 2 0 012 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V7z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgVideo = /*#__PURE__*/React.memo(SvgVideo);

function SvgVoicemail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM18.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16h13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgVoicemail = /*#__PURE__*/React.memo(SvgVoicemail);

function SvgVolume1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13 5L8 9H4v6h4l5 4V5v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.54 8.46a5 5 0 010 7.07",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgVolume1 = /*#__PURE__*/React.memo(SvgVolume1);

function SvgVolume2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 5L6 9H2v6h4l5 4V5v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.777 4.223a1 1 0 00-1.414 1.414l1.414-1.414zm-1.414 14.14a1 1 0 001.414 1.414l-1.414-1.414zm-2.116-10.61a1 1 0 00-1.414 1.414l1.414-1.414zm-1.414 7.07a1 1 0 001.414 1.414l-1.414-1.414zm3.53-9.186a9 9 0 010 12.726l1.414 1.414c4.294-4.296 4.294-11.259 0-15.554l-1.414 1.414zm-3.53 3.53a4 4 0 010 5.656l1.414 1.414a6 6 0 000-8.484l-1.414 1.414z",
    fill: "currentColor"
  }));
}

var MemoSvgVolume2 = /*#__PURE__*/React.memo(SvgVolume2);

function SvgVolumeX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 5L5 9H1v6h4l5 4V5v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9l-6 6M16 9l6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgVolumeX = /*#__PURE__*/React.memo(SvgVolumeX);

function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 5l-5 4H7v6h4l5 4V5v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgVolume = /*#__PURE__*/React.memo(SvgVolume);

function SvgWalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.008.036a1.503 1.503 0 00-1.04 1.001c-.07.222-.074.593-.009.806.128.426.424.767.815.943.212.096.387.13.643.129A1.458 1.458 0 005.855 1.46a1.3 1.3 0 00-.152-.652 1.492 1.492 0 00-.947-.772 1.952 1.952 0 00-.748 0zm-.75 3.267c-.246.083-.662.29-1.195.595-.592.338-.79.477-.969.682-.2.23-.257.324-.67 1.103-.434.82-.465.909-.396 1.145.11.375.491.574.854.444.237-.085.275-.135.702-.95.216-.413.424-.789.463-.836.08-.096.32-.265.33-.233.004.011-.1.487-.231 1.058-.197.858-.238 1.072-.238 1.236 0 .238.068.482.183.658.044.067.59.634 1.214 1.26l1.134 1.137.465 1.357c.256.747.49 1.403.522 1.458a.772.772 0 001.168.204c.195-.16.305-.47.248-.7-.057-.228-.967-2.835-1.04-2.977-.115-.227-.163-.282-.86-.981l-.658-.66.133-.417c.074-.228.262-.823.42-1.32.157-.498.293-.92.302-.937.011-.02.058.029.134.14.233.338.598.6.954.683.174.041 1.532.248 1.628.248a.69.69 0 00.583-.391.669.669 0 00-.32-.87c-.057-.03-1.411-.254-1.54-.255-.062 0-.189-.138-.371-.4-.679-.977-1.088-1.41-1.368-1.446a29.986 29.986 0 00-1.322-.086 1.02 1.02 0 00-.26.05zM1.62 11.122c-.64 1.703-.65 1.733-.65 1.914a.696.696 0 00.413.661.765.765 0 001.005-.303c.028-.056.282-.718.563-1.471l.512-1.37-.583-.581c-.32-.32-.589-.581-.597-.581-.007 0-.306.779-.663 1.73z",
    fill: "currentColor"
  }));
}

var MemoSvgWalk = /*#__PURE__*/React.memo(SvgWalk);

function SvgWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 19a7 7 0 100-14 7 7 0 000 14z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v3l1.5 1.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.506 17.441a1 1 0 10-1.992-.182l1.992.182zM16.16 21.18l-.996-.091v.001l.996.09zm-2 1.82l.004-1h-.004v1zm-4.33 0v-1h-.004l.004 1zm-2-1.82l.996-.09v-.001l-.996.091zm.646-3.921a1 1 0 00-1.992.182l1.992-.182zm-1.982-10.7a1 1 0 001.992.182l-1.992-.182zM7.84 2.82l.996.091V2.91l-.996-.09zM9.83 1V0v1zm4.35 0v1h.004l-.004-1zm2 1.82l-.996.09v.001l.996-.091zm-.646 3.921a1 1 0 001.992-.182l-1.992.182zm-.02 10.518l-.35 3.83 1.992.182.35-3.83-1.992-.182zm-.35 3.831a1 1 0 01-1 .91l-.008 2a3 3 0 003-2.73l-1.992-.18zM14.16 22H9.83v2h4.33v-2zm-4.334 0a1 1 0 01-1-.91l-1.992.18a3 3 0 003 2.73l-.008-2zm-1-.911l-.35-3.83-1.992.182.35 3.83 1.992-.182zm-.34-14.348l.35-3.83-1.992-.182-.35 3.83 1.992.182zm.35-3.831A1 1 0 019.83 2l-.002-2a3 3 0 00-2.985 2.73l1.992.18zM9.83 2h4.35V0H9.83v2zm4.354 0a1 1 0 011 .91l1.992-.18a3 3 0 00-3-2.73l.008 2zm1 .911l.35 3.83 1.992-.182-.35-3.83-1.992.182z",
    fill: "currentColor"
  }));
}

var MemoSvgWatch = /*#__PURE__*/React.memo(SvgWatch);

function SvgWd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3h4M10 1H2a1 1 0 00-1 1v4m9-5v2a1 1 0 001 1h4a1 1 0 001-1V1m-6 0h6m0 0h1.5a1 1 0 011 1v4m0 0v19a1 1 0 01-1 1H2a1 1 0 01-1-1V6m17.5 0h-4M13 6h-.5M1 6h10m-.05 6.908C9.28 12.46 7 13.578 7 16c0 1.745 1.902 3.49 4.048 2.579.548-.233.583-.954.28-1.467-.443-.746-.798-1.805-.193-2.763.337-.533.424-1.278-.186-1.441zM15.5 16a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgWd = /*#__PURE__*/React.memo(SvgWd);

function SvgWifiOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 1l22 22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.72 11.06c.82.4 1.585.9 2.28 1.49M5 12.55a10.94 10.94 0 015.17-2.39M10.71 5.05A16 16 0 0122.58 9M1.42 9a15.91 15.91 0 014.7-2.88M8.53 16.11a6 6 0 016.95 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgWifiOff = /*#__PURE__*/React.memo(SvgWifiOff);

function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.58 13.547a11 11 0 0114.08 0M1 9.997c6.046-5.33 15.113-5.33 21.16 0M8.11 17.107a6 6 0 016.95 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgWifi = /*#__PURE__*/React.memo(SvgWifi);

function SvgWind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.88 3.885a1 1 0 001.42 1.41l-1.42-1.41zM11 8l.004-1H11v1zM2 7a1 1 0 000 2V7zm11.3 11.705a1 1 0 10-1.42 1.41l1.42-1.41zM14 16v1h.004L14 16zM2 15a1 1 0 100 2v-2zm15.024-7.978a1 1 0 001.412 1.416l-1.412-1.416zM19.5 12v1h.002l-.002-1zM2 11a1 1 0 100 2v-2zm8.3-5.705a1 1 0 011.208-.161l.999-1.733a3 3 0 00-3.626.484l1.418 1.41zm1.208-.161a1 1 0 01.466 1.127l1.93.52a3 3 0 00-1.397-3.38l-1 1.733zm.466 1.127a1 1 0 01-.97.739l-.008 2a3 3 0 002.909-2.218l-1.931-.521zM11 7H2v2h9V7zm.88 13.115a3 3 0 003.627.484l-1-1.733a1 1 0 01-1.208-.161l-1.418 1.41zm3.627.484a3 3 0 001.398-3.38l-1.931.52a1 1 0 01-.466 1.127l.999 1.733zm1.398-3.38A3 3 0 0013.995 15l.01 2a1 1 0 01.969.74l1.93-.522zM14 15H2v2h12v-2zm4.436-6.562a1.5 1.5 0 011.81-.237l1-1.732a3.5 3.5 0 00-4.222.553l1.412 1.416zm1.81-.237a1.5 1.5 0 01.699 1.686l1.932.516a3.5 3.5 0 00-1.63-3.934l-1.001 1.732zm.699 1.686A1.5 1.5 0 0119.498 11l.004 2a3.5 3.5 0 003.375-2.597l-1.932-.516zM19.5 11H2v2h17.5v-2z",
    fill: "currentColor"
  }));
}

var MemoSvgWind = /*#__PURE__*/React.memo(SvgWind);

function SvgXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9l-6 6M9 9l6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgXCircle = /*#__PURE__*/React.memo(SvgXCircle);

function SvgXSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9l6 6M15 9l-6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgXSquare = /*#__PURE__*/React.memo(SvgXSquare);

function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 6L6 18M6 6l12 12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgX = /*#__PURE__*/React.memo(SvgX);

function SvgZap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13 2L3 14h9l-1 8 10-12h-9l1-8v0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgZap = /*#__PURE__*/React.memo(SvgZap);

function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 19a8 8 0 100-16 8 8 0 000 16z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-4.35-4.35M11 8v6M8 11h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgZoomIn = /*#__PURE__*/React.memo(SvgZoomIn);

function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 19a8 8 0 100-16 8 8 0 000 16z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-4.35-4.35M8 11h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgZoomOut = /*#__PURE__*/React.memo(SvgZoomOut);
export { MemoSvgAc as Ac, MemoSvgActivity as Activity, MemoSvgAirplay as Airplay, MemoSvgAlertCircle as AlertCircle, MemoSvgAlertOctagon as AlertOctagon, MemoSvgAlertTriangle as AlertTriangle, MemoSvgAlignCenter as AlignCenter, MemoSvgAlignJustify as AlignJustify, MemoSvgAlignLeft as AlignLeft, MemoSvgAlignRight as AlignRight, MemoSvgAlt as Alt, MemoSvgAnchor as Anchor, MemoSvgAperture as Aperture, MemoSvgArrowDown as ArrowDown, MemoSvgArrowDownLeft as ArrowDownLeft, MemoSvgArrowDownRight as ArrowDownRight, MemoSvgArrowLeft as ArrowLeft, MemoSvgArrowRight as ArrowRight, MemoSvgArrowUp as ArrowUp, MemoSvgArrowUpLeft as ArrowUpLeft, MemoSvgArrowUpRight as ArrowUpRight, MemoSvgAtSign as AtSign, MemoSvgAward as Award, MemoSvgBarChart as BarChart, MemoSvgBarChart2 as BarChart2, MemoSvgBaths as Baths, MemoSvgBattery as Battery, MemoSvgBatteryCharging as BatteryCharging, MemoSvgBeds as Beds, MemoSvgBell as Bell, MemoSvgBellOff as BellOff, MemoSvgBluetooth as Bluetooth, MemoSvgBold as Bold, MemoSvgBolt as Bolt, MemoSvgBook as Book, MemoSvgBookmark as Bookmark, MemoSvgBox as Box, MemoSvgBriefcase as Briefcase, MemoSvgCalendar as Calendar, MemoSvgCamera as Camera, MemoSvgCameraOff as CameraOff, MemoSvgCast as Cast, MemoSvgCheck as Check, MemoSvgCheckCircle as CheckCircle, MemoSvgCheckSquare as CheckSquare, MemoSvgChevronDown as ChevronDown, MemoSvgChevronLeft as ChevronLeft, MemoSvgChevronRight as ChevronRight, MemoSvgChevronUp as ChevronUp, MemoSvgChevronsDown as ChevronsDown, MemoSvgChevronsLeft as ChevronsLeft, MemoSvgChevronsRight as ChevronsRight, MemoSvgChevronsUp as ChevronsUp, MemoSvgChrome as Chrome, MemoSvgCircle as Circle, MemoSvgClipboard as Clipboard, MemoSvgClock as Clock, MemoSvgCloud as Cloud, MemoSvgCloudDrizzle as CloudDrizzle, MemoSvgCloudLightning as CloudLightning, MemoSvgCloudOff as CloudOff, MemoSvgCloudRain as CloudRain, MemoSvgCloudSnow as CloudSnow, MemoSvgCodepen as Codepen, MemoSvgCommand as Command, MemoSvgCompass as Compass, MemoSvgCopy as Copy, MemoSvgCornerDownLeft as CornerDownLeft, MemoSvgCornerDownRight as CornerDownRight, MemoSvgCornerLeftDown as CornerLeftDown, MemoSvgCornerLeftUp as CornerLeftUp, MemoSvgCornerRightDown as CornerRightDown, MemoSvgCornerRightUp as CornerRightUp, MemoSvgCornerUpLeft as CornerUpLeft, MemoSvgCornerUpRight as CornerUpRight, MemoSvgCpu as Cpu, MemoSvgCreditCard as CreditCard, MemoSvgCrop as Crop, MemoSvgCrosshair as Crosshair, MemoSvgDelete as Delete, MemoSvgDisc as Disc, MemoSvgDishwasher as Dishwasher, MemoSvgDoorman as Doorman, MemoSvgDownload as Download, MemoSvgDownloadCloud as DownloadCloud, MemoSvgDrive as Drive, MemoSvgDroplet as Droplet, MemoSvgEdit as Edit, MemoSvgEdit2 as Edit2, MemoSvgEdit3 as Edit3, MemoSvgElevator as Elevator, MemoSvgExternalLink as ExternalLink, MemoSvgEye as Eye, MemoSvgEyeOff as EyeOff, MemoSvgFacebook as Facebook, MemoSvgFastForward as FastForward, MemoSvgFeather as Feather, MemoSvgFile as File, MemoSvgFileMinus as FileMinus, MemoSvgFilePlus as FilePlus, MemoSvgFileText as FileText, MemoSvgFilm as Film, MemoSvgFilter as Filter, MemoSvgFlag as Flag, MemoSvgFloorplan as Floorplan, MemoSvgFolder as Folder, MemoSvgFurniture as Furniture, MemoSvgGithub as Github, MemoSvgGitlab as Gitlab, MemoSvgGlobe as Globe, MemoSvgGoogle as Google, MemoSvgGrid as Grid, MemoSvgGym as Gym, MemoSvgHash as Hash, MemoSvgHeadphones as Headphones, MemoSvgHeart as Heart, MemoSvgHelpCircle as HelpCircle, MemoSvgHome as Home, MemoSvgImage as Image, MemoSvgInbox as Inbox, MemoSvgInfo as Info, MemoSvgInstagram as Instagram, MemoSvgItalic as Italic, MemoSvgLayers as Layers, MemoSvgLayout as Layout, MemoSvgLifeBuoy as LifeBuoy, MemoSvgLink as Link, MemoSvgLink2 as Link2, MemoSvgList as List, MemoSvgLoader as Loader, MemoSvgLock as Lock, MemoSvgLogIn as LogIn, MemoSvgLogOut as LogOut, MemoSvgMail as Mail, MemoSvgMap as Map, MemoSvgMapPin as MapPin, MemoSvgMaximize as Maximize, MemoSvgMaximize2 as Maximize2, MemoSvgMenu as Menu, MemoSvgMessageCircle as MessageCircle, MemoSvgMessageSquare as MessageSquare, MemoSvgMic as Mic, MemoSvgMicOff as MicOff, MemoSvgMinimize as Minimize, MemoSvgMinimize2 as Minimize2, MemoSvgMinus as Minus, MemoSvgMinusCircle as MinusCircle, MemoSvgMinusSquare as MinusSquare, MemoSvgMonitor as Monitor, MemoSvgMoon as Moon, MemoSvgMoreHorizontal as MoreHorizontal, MemoSvgMoreVertical as MoreVertical, MemoSvgMove as Move, MemoSvgMusic as Music, MemoSvgNavigation as Navigation, MemoSvgNavigation2 as Navigation2, MemoSvgOctagon as Octagon, MemoSvgOutdoor as Outdoor, MemoSvgPackage as Package, MemoSvgPaperclip as Paperclip, MemoSvgPark as Park, MemoSvgPause as Pause, MemoSvgPauseCircle as PauseCircle, MemoSvgPeek as Peek, MemoSvgPeekIcon as PeekIcon, MemoSvgPercent as Percent, MemoSvgPets as Pets, MemoSvgPhone as Phone, MemoSvgPhoneCall as PhoneCall, MemoSvgPhoneForwarded as PhoneForwarded, MemoSvgPhoneIncoming as PhoneIncoming, MemoSvgPhoneMissed as PhoneMissed, MemoSvgPhoneOff as PhoneOff, MemoSvgPhoneOutgoing as PhoneOutgoing, MemoSvgPi as Pi, MemoSvgPieChart as PieChart, MemoSvgPlace as Place, MemoSvgPlay as Play, MemoSvgPlayCircle as PlayCircle, MemoSvgPlus as Plus, MemoSvgPlusCircle as PlusCircle, MemoSvgPlusSquare as PlusSquare, MemoSvgPocket as Pocket, MemoSvgPool as Pool, MemoSvgPower as Power, MemoSvgPrinter as Printer, MemoSvgRadio as Radio, MemoSvgRefreshCcw as RefreshCcw, MemoSvgRefreshCw as RefreshCw, MemoSvgRepeat as Repeat, MemoSvgRewind as Rewind, MemoSvgRotateCcw as RotateCcw, MemoSvgRotateCw as RotateCw, MemoSvgSave as Save, MemoSvgScissors as Scissors, MemoSvgSearch as Search, MemoSvgServer as Server, MemoSvgSettings as Settings, MemoSvgShare as Share, MemoSvgShare2 as Share2, MemoSvgShield as Shield, MemoSvgShoppingCart as ShoppingCart, MemoSvgShuffle as Shuffle, MemoSvgSidebar as Sidebar, MemoSvgSkipBack as SkipBack, MemoSvgSkipForward as SkipForward, MemoSvgSlack as Slack, MemoSvgSlash as Slash, MemoSvgSliders as Sliders, MemoSvgSmartphone as Smartphone, MemoSvgSpeaker as Speaker, MemoSvgSquare as Square, MemoSvgStaging as Staging, MemoSvgStar as Star, MemoSvgStopCircle as StopCircle, MemoSvgSun as Sun, MemoSvgSunrise as Sunrise, MemoSvgSunset as Sunset, MemoSvgTablet as Tablet, MemoSvgTag as Tag, MemoSvgTarget as Target, MemoSvgThermometer as Thermometer, MemoSvgThumbsDown as ThumbsDown, MemoSvgThumbsUp as ThumbsUp, MemoSvgToggleLeft as ToggleLeft, MemoSvgToggleRight as ToggleRight, MemoSvgTrain as Train, MemoSvgTrash as Trash, MemoSvgTrash2 as Trash2, MemoSvgTrendingDown as TrendingDown, MemoSvgTrendingUp as TrendingUp, MemoSvgTriangle as Triangle, MemoSvgTv as Tv, MemoSvgTwitter as Twitter, MemoSvgType as Type, MemoSvgUmbrella as Umbrella, MemoSvgUnderline as Underline, MemoSvgUnlock as Unlock, MemoSvgUpload as Upload, MemoSvgUploadCloud as UploadCloud, MemoSvgUser as User, MemoSvgUserCheck as UserCheck, MemoSvgUserMinus as UserMinus, MemoSvgUserPlus as UserPlus, MemoSvgUserX as UserX, MemoSvgUsers as Users, MemoSvgVideo as Video, MemoSvgVideoOff as VideoOff, MemoSvgVoicemail as Voicemail, MemoSvgVolume as Volume, MemoSvgVolume1 as Volume1, MemoSvgVolume2 as Volume2, MemoSvgVolumeX as VolumeX, MemoSvgWalk as Walk, MemoSvgWatch as Watch, MemoSvgWd as Wd, MemoSvgWifi as Wifi, MemoSvgWifiOff as WifiOff, MemoSvgWind as Wind, MemoSvgX as X, MemoSvgXCircle as XCircle, MemoSvgXSquare as XSquare, MemoSvgZap as Zap, MemoSvgZoomIn as ZoomIn, MemoSvgZoomOut as ZoomOut };
